/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date, represented as a 'yyyy-mm-dd' string */
  Date: { input: any; output: any; }
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  Secret: { input: any; output: any; }
};

export type AiredRadioShow = {
  __typename?: 'AiredRadioShow';
  djs: Array<User>;
  djsAggregate?: Maybe<AiredRadioShowUserDjsAggregationSelection>;
  djsConnection: AiredRadioShowDjsConnection;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  listenersPeak: Scalars['Int']['output'];
  radioShow: RadioShow;
  radioShowAggregate?: Maybe<AiredRadioShowRadioShowRadioShowAggregationSelection>;
  radioShowConnection: AiredRadioShowRadioShowConnection;
  songRequests: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
};


export type AiredRadioShowDjsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AiredRadioShowDjsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AiredRadioShowDjsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiredRadioShowDjsConnectionSort>>;
  where?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
};


export type AiredRadioShowRadioShowArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type AiredRadioShowRadioShowAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RadioShowWhere>;
};


export type AiredRadioShowRadioShowConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiredRadioShowRadioShowConnectionSort>>;
  where?: InputMaybe<AiredRadioShowRadioShowConnectionWhere>;
};

export type AiredRadioShowAggregateSelection = {
  __typename?: 'AiredRadioShowAggregateSelection';
  count: Scalars['Int']['output'];
  endedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  listenersPeak: IntAggregateSelection;
  songRequests: IntAggregateSelection;
  startedAt: DateTimeAggregateSelection;
};

export type AiredRadioShowDjsAggregateInput = {
  AND?: InputMaybe<Array<AiredRadioShowDjsAggregateInput>>;
  NOT?: InputMaybe<AiredRadioShowDjsAggregateInput>;
  OR?: InputMaybe<Array<AiredRadioShowDjsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiredRadioShowDjsNodeAggregationWhereInput>;
};

export type AiredRadioShowDjsConnection = {
  __typename?: 'AiredRadioShowDjsConnection';
  edges: Array<AiredRadioShowDjsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiredRadioShowDjsConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AiredRadioShowDjsConnectionWhere = {
  AND?: InputMaybe<Array<AiredRadioShowDjsConnectionWhere>>;
  NOT?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
  OR?: InputMaybe<Array<AiredRadioShowDjsConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AiredRadioShowDjsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiredRadioShowDjsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiredRadioShowDjsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiredRadioShowDjsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiredRadioShowDjsRelationship = {
  __typename?: 'AiredRadioShowDjsRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AiredRadioShowEdge = {
  __typename?: 'AiredRadioShowEdge';
  cursor: Scalars['String']['output'];
  node: AiredRadioShow;
};

export type AiredRadioShowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AiredRadioShowSort objects to sort AiredRadioShows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AiredRadioShowSort>>;
};

export type AiredRadioShowRadioShowAggregateInput = {
  AND?: InputMaybe<Array<AiredRadioShowRadioShowAggregateInput>>;
  NOT?: InputMaybe<AiredRadioShowRadioShowAggregateInput>;
  OR?: InputMaybe<Array<AiredRadioShowRadioShowAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiredRadioShowRadioShowNodeAggregationWhereInput>;
};

export type AiredRadioShowRadioShowConnection = {
  __typename?: 'AiredRadioShowRadioShowConnection';
  edges: Array<AiredRadioShowRadioShowRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiredRadioShowRadioShowConnectionSort = {
  node?: InputMaybe<RadioShowSort>;
};

export type AiredRadioShowRadioShowConnectionWhere = {
  AND?: InputMaybe<Array<AiredRadioShowRadioShowConnectionWhere>>;
  NOT?: InputMaybe<AiredRadioShowRadioShowConnectionWhere>;
  OR?: InputMaybe<Array<AiredRadioShowRadioShowConnectionWhere>>;
  node?: InputMaybe<RadioShowWhere>;
};

export type AiredRadioShowRadioShowNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiredRadioShowRadioShowNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiredRadioShowRadioShowNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiredRadioShowRadioShowNodeAggregationWhereInput>>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiredRadioShowRadioShowRadioShowAggregationSelection = {
  __typename?: 'AiredRadioShowRadioShowRadioShowAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiredRadioShowRadioShowRadioShowNodeAggregateSelection>;
};

export type AiredRadioShowRadioShowRadioShowNodeAggregateSelection = {
  __typename?: 'AiredRadioShowRadioShowRadioShowNodeAggregateSelection';
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AiredRadioShowRadioShowRelationship = {
  __typename?: 'AiredRadioShowRadioShowRelationship';
  cursor: Scalars['String']['output'];
  node: RadioShow;
};

/** Fields to sort AiredRadioShows by. The order in which sorts are applied is not guaranteed when specifying many fields in one AiredRadioShowSort object. */
export type AiredRadioShowSort = {
  endedAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  listenersPeak?: InputMaybe<SortDirection>;
  songRequests?: InputMaybe<SortDirection>;
  startedAt?: InputMaybe<SortDirection>;
};

export type AiredRadioShowUserDjsAggregationSelection = {
  __typename?: 'AiredRadioShowUserDjsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiredRadioShowUserDjsNodeAggregateSelection>;
};

export type AiredRadioShowUserDjsNodeAggregateSelection = {
  __typename?: 'AiredRadioShowUserDjsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type AiredRadioShowWhere = {
  AND?: InputMaybe<Array<AiredRadioShowWhere>>;
  NOT?: InputMaybe<AiredRadioShowWhere>;
  OR?: InputMaybe<Array<AiredRadioShowWhere>>;
  djsAggregate?: InputMaybe<AiredRadioShowDjsAggregateInput>;
  /** Return AiredRadioShows where all of the related AiredRadioShowDjsConnections match this filter */
  djsConnection_ALL?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
  /** Return AiredRadioShows where none of the related AiredRadioShowDjsConnections match this filter */
  djsConnection_NONE?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
  /** Return AiredRadioShows where one of the related AiredRadioShowDjsConnections match this filter */
  djsConnection_SINGLE?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
  /** Return AiredRadioShows where some of the related AiredRadioShowDjsConnections match this filter */
  djsConnection_SOME?: InputMaybe<AiredRadioShowDjsConnectionWhere>;
  /** Return AiredRadioShows where all of the related Users match this filter */
  djs_ALL?: InputMaybe<UserWhere>;
  /** Return AiredRadioShows where none of the related Users match this filter */
  djs_NONE?: InputMaybe<UserWhere>;
  /** Return AiredRadioShows where one of the related Users match this filter */
  djs_SINGLE?: InputMaybe<UserWhere>;
  /** Return AiredRadioShows where some of the related Users match this filter */
  djs_SOME?: InputMaybe<UserWhere>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  listenersPeak?: InputMaybe<Scalars['Int']['input']>;
  listenersPeak_GT?: InputMaybe<Scalars['Int']['input']>;
  listenersPeak_GTE?: InputMaybe<Scalars['Int']['input']>;
  listenersPeak_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  listenersPeak_LT?: InputMaybe<Scalars['Int']['input']>;
  listenersPeak_LTE?: InputMaybe<Scalars['Int']['input']>;
  radioShow?: InputMaybe<RadioShowWhere>;
  radioShowAggregate?: InputMaybe<AiredRadioShowRadioShowAggregateInput>;
  radioShowConnection?: InputMaybe<AiredRadioShowRadioShowConnectionWhere>;
  radioShowConnection_NOT?: InputMaybe<AiredRadioShowRadioShowConnectionWhere>;
  radioShow_NOT?: InputMaybe<RadioShowWhere>;
  songRequests?: InputMaybe<Scalars['Int']['input']>;
  songRequests_GT?: InputMaybe<Scalars['Int']['input']>;
  songRequests_GTE?: InputMaybe<Scalars['Int']['input']>;
  songRequests_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  songRequests_LT?: InputMaybe<Scalars['Int']['input']>;
  songRequests_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AiredRadioShowsConnection = {
  __typename?: 'AiredRadioShowsConnection';
  edges: Array<AiredRadioShowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Banner = {
  __typename?: 'Banner';
  id: Scalars['ID']['output'];
  pkg: File;
  pkgAggregate?: Maybe<BannerFilePkgAggregationSelection>;
  pkgConnection: BannerPkgConnection;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type BannerPkgArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type BannerPkgAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type BannerPkgConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BannerPkgConnectionSort>>;
  where?: InputMaybe<BannerPkgConnectionWhere>;
};

export type BannerAggregateSelection = {
  __typename?: 'BannerAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelection;
  title: StringAggregateSelection;
};

export type BannerConnectInput = {
  pkg?: InputMaybe<BannerPkgConnectFieldInput>;
};

export type BannerConnectOrCreateInput = {
  pkg?: InputMaybe<BannerPkgConnectOrCreateFieldInput>;
};

export type BannerCreateInput = {
  pkg?: InputMaybe<BannerPkgFieldInput>;
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type BannerDeleteInput = {
  pkg?: InputMaybe<BannerPkgDeleteFieldInput>;
};

export type BannerDisconnectInput = {
  pkg?: InputMaybe<BannerPkgDisconnectFieldInput>;
};

export type BannerEdge = {
  __typename?: 'BannerEdge';
  cursor: Scalars['String']['output'];
  node: Banner;
};

export type BannerFilePkgAggregationSelection = {
  __typename?: 'BannerFilePkgAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BannerFilePkgNodeAggregateSelection>;
};

export type BannerFilePkgNodeAggregateSelection = {
  __typename?: 'BannerFilePkgNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type BannerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BannerSort objects to sort Banners by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BannerSort>>;
};

export type BannerPkgAggregateInput = {
  AND?: InputMaybe<Array<BannerPkgAggregateInput>>;
  NOT?: InputMaybe<BannerPkgAggregateInput>;
  OR?: InputMaybe<Array<BannerPkgAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BannerPkgNodeAggregationWhereInput>;
};

export type BannerPkgConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type BannerPkgConnectOrCreateFieldInput = {
  onCreate: BannerPkgConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type BannerPkgConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type BannerPkgConnection = {
  __typename?: 'BannerPkgConnection';
  edges: Array<BannerPkgRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BannerPkgConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type BannerPkgConnectionWhere = {
  AND?: InputMaybe<Array<BannerPkgConnectionWhere>>;
  NOT?: InputMaybe<BannerPkgConnectionWhere>;
  OR?: InputMaybe<Array<BannerPkgConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type BannerPkgCreateFieldInput = {
  node: FileCreateInput;
};

export type BannerPkgDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<BannerPkgConnectionWhere>;
};

export type BannerPkgDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<BannerPkgConnectionWhere>;
};

export type BannerPkgFieldInput = {
  connect?: InputMaybe<BannerPkgConnectFieldInput>;
  connectOrCreate?: InputMaybe<BannerPkgConnectOrCreateFieldInput>;
  create?: InputMaybe<BannerPkgCreateFieldInput>;
};

export type BannerPkgNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BannerPkgNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BannerPkgNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BannerPkgNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerPkgRelationship = {
  __typename?: 'BannerPkgRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type BannerPkgUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type BannerPkgUpdateFieldInput = {
  connect?: InputMaybe<BannerPkgConnectFieldInput>;
  connectOrCreate?: InputMaybe<BannerPkgConnectOrCreateFieldInput>;
  create?: InputMaybe<BannerPkgCreateFieldInput>;
  delete?: InputMaybe<BannerPkgDeleteFieldInput>;
  disconnect?: InputMaybe<BannerPkgDisconnectFieldInput>;
  update?: InputMaybe<BannerPkgUpdateConnectionInput>;
  where?: InputMaybe<BannerPkgConnectionWhere>;
};

export type BannerRelationInput = {
  pkg?: InputMaybe<BannerPkgCreateFieldInput>;
};

/** Fields to sort Banners by. The order in which sorts are applied is not guaranteed when specifying many fields in one BannerSort object. */
export type BannerSort = {
  id?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type BannerUpdateInput = {
  pkg?: InputMaybe<BannerPkgUpdateFieldInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tags_POP?: InputMaybe<Scalars['Int']['input']>;
  tags_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BannerWhere = {
  AND?: InputMaybe<Array<BannerWhere>>;
  NOT?: InputMaybe<BannerWhere>;
  OR?: InputMaybe<Array<BannerWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  pkg?: InputMaybe<FileWhere>;
  pkgAggregate?: InputMaybe<BannerPkgAggregateInput>;
  pkgConnection?: InputMaybe<BannerPkgConnectionWhere>;
  pkgConnection_NOT?: InputMaybe<BannerPkgConnectionWhere>;
  pkg_NOT?: InputMaybe<FileWhere>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type BannersConnection = {
  __typename?: 'BannersConnection';
  edges: Array<BannerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CategoriesConnection = {
  __typename?: 'CategoriesConnection';
  edges: Array<CategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Category = {
  __typename?: 'Category';
  body: Scalars['String']['output'];
  cover: File;
  coverAggregate?: Maybe<CategoryFileCoverAggregationSelection>;
  coverConnection: CategoryCoverConnection;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  genre: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  revisions: Array<PostRevision>;
  revisionsAggregate?: Maybe<CategoryPostRevisionRevisionsAggregationSelection>;
  revisionsConnection: CategoryRevisionsConnection;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<CategoryUserUsersAggregationSelection>;
  usersConnection: CategoryUsersConnection;
  views: Scalars['Int']['output'];
};


export type CategoryCoverArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type CategoryCoverAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type CategoryCoverConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CategoryCoverConnectionSort>>;
  where?: InputMaybe<CategoryCoverConnectionWhere>;
};


export type CategoryRevisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostRevisionOptions>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type CategoryRevisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type CategoryRevisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CategoryRevisionsConnectionSort>>;
  where?: InputMaybe<CategoryRevisionsConnectionWhere>;
};


export type CategoryUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CategoryUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CategoryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CategoryUsersConnectionSort>>;
  where?: InputMaybe<CategoryUsersConnectionWhere>;
};

export type CategoryAggregateSelection = {
  __typename?: 'CategoryAggregateSelection';
  body: StringAggregateSelection;
  count: Scalars['Int']['output'];
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type CategoryConnectInput = {
  cover?: InputMaybe<CategoryCoverConnectFieldInput>;
  revisions?: InputMaybe<Array<CategoryRevisionsConnectFieldInput>>;
  users?: InputMaybe<Array<CategoryUsersConnectFieldInput>>;
};

export type CategoryConnectOrCreateInput = {
  cover?: InputMaybe<CategoryCoverConnectOrCreateFieldInput>;
  revisions?: InputMaybe<Array<CategoryRevisionsConnectOrCreateFieldInput>>;
  users?: InputMaybe<Array<CategoryUsersConnectOrCreateFieldInput>>;
};

export type CategoryConnectOrCreateWhere = {
  node: CategoryUniqueWhere;
};

export type CategoryConnectWhere = {
  node: CategoryWhere;
};

export type CategoryCoverAggregateInput = {
  AND?: InputMaybe<Array<CategoryCoverAggregateInput>>;
  NOT?: InputMaybe<CategoryCoverAggregateInput>;
  OR?: InputMaybe<Array<CategoryCoverAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CategoryCoverNodeAggregationWhereInput>;
};

export type CategoryCoverConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type CategoryCoverConnectOrCreateFieldInput = {
  onCreate: CategoryCoverConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type CategoryCoverConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type CategoryCoverConnection = {
  __typename?: 'CategoryCoverConnection';
  edges: Array<CategoryCoverRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CategoryCoverConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type CategoryCoverConnectionWhere = {
  AND?: InputMaybe<Array<CategoryCoverConnectionWhere>>;
  NOT?: InputMaybe<CategoryCoverConnectionWhere>;
  OR?: InputMaybe<Array<CategoryCoverConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type CategoryCoverCreateFieldInput = {
  node: FileCreateInput;
};

export type CategoryCoverDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<CategoryCoverConnectionWhere>;
};

export type CategoryCoverDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<CategoryCoverConnectionWhere>;
};

export type CategoryCoverFieldInput = {
  connect?: InputMaybe<CategoryCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<CategoryCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<CategoryCoverCreateFieldInput>;
};

export type CategoryCoverNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CategoryCoverNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CategoryCoverNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CategoryCoverNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCoverRelationship = {
  __typename?: 'CategoryCoverRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type CategoryCoverUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type CategoryCoverUpdateFieldInput = {
  connect?: InputMaybe<CategoryCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<CategoryCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<CategoryCoverCreateFieldInput>;
  delete?: InputMaybe<CategoryCoverDeleteFieldInput>;
  disconnect?: InputMaybe<CategoryCoverDisconnectFieldInput>;
  update?: InputMaybe<CategoryCoverUpdateConnectionInput>;
  where?: InputMaybe<CategoryCoverConnectionWhere>;
};

export type CategoryCreateInput = {
  body: Scalars['String']['input'];
  cover?: InputMaybe<CategoryCoverFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  genre: Scalars['String']['input'];
  revisions?: InputMaybe<CategoryRevisionsFieldInput>;
  title: Scalars['String']['input'];
  users?: InputMaybe<CategoryUsersFieldInput>;
  views?: Scalars['Int']['input'];
};

export type CategoryDeleteInput = {
  cover?: InputMaybe<CategoryCoverDeleteFieldInput>;
  revisions?: InputMaybe<Array<CategoryRevisionsDeleteFieldInput>>;
  users?: InputMaybe<Array<CategoryUsersDeleteFieldInput>>;
};

export type CategoryDisconnectInput = {
  cover?: InputMaybe<CategoryCoverDisconnectFieldInput>;
  revisions?: InputMaybe<Array<CategoryRevisionsDisconnectFieldInput>>;
  users?: InputMaybe<Array<CategoryUsersDisconnectFieldInput>>;
};

export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type CategoryFileCoverAggregationSelection = {
  __typename?: 'CategoryFileCoverAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CategoryFileCoverNodeAggregateSelection>;
};

export type CategoryFileCoverNodeAggregateSelection = {
  __typename?: 'CategoryFileCoverNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type CategoryOnCreateInput = {
  body: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  genre: Scalars['String']['input'];
  title: Scalars['String']['input'];
  views?: Scalars['Int']['input'];
};

export type CategoryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CategorySort objects to sort Categories by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CategorySort>>;
};

export type CategoryPostRevisionRevisionsAggregationSelection = {
  __typename?: 'CategoryPostRevisionRevisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CategoryPostRevisionRevisionsNodeAggregateSelection>;
};

export type CategoryPostRevisionRevisionsNodeAggregateSelection = {
  __typename?: 'CategoryPostRevisionRevisionsNodeAggregateSelection';
  body: StringAggregateSelection;
  coverAttribution: StringAggregateSelection;
  coverAttributionLink: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lead: StringAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type CategoryRelationInput = {
  cover?: InputMaybe<CategoryCoverCreateFieldInput>;
  revisions?: InputMaybe<Array<CategoryRevisionsCreateFieldInput>>;
  users?: InputMaybe<Array<CategoryUsersCreateFieldInput>>;
};

export type CategoryRevisionsAggregateInput = {
  AND?: InputMaybe<Array<CategoryRevisionsAggregateInput>>;
  NOT?: InputMaybe<CategoryRevisionsAggregateInput>;
  OR?: InputMaybe<Array<CategoryRevisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CategoryRevisionsNodeAggregationWhereInput>;
};

export type CategoryRevisionsConnectFieldInput = {
  connect?: InputMaybe<Array<PostRevisionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostRevisionConnectWhere>;
};

export type CategoryRevisionsConnectOrCreateFieldInput = {
  onCreate: CategoryRevisionsConnectOrCreateFieldInputOnCreate;
  where: PostRevisionConnectOrCreateWhere;
};

export type CategoryRevisionsConnectOrCreateFieldInputOnCreate = {
  node: PostRevisionOnCreateInput;
};

export type CategoryRevisionsConnection = {
  __typename?: 'CategoryRevisionsConnection';
  edges: Array<CategoryRevisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CategoryRevisionsConnectionSort = {
  node?: InputMaybe<PostRevisionSort>;
};

export type CategoryRevisionsConnectionWhere = {
  AND?: InputMaybe<Array<CategoryRevisionsConnectionWhere>>;
  NOT?: InputMaybe<CategoryRevisionsConnectionWhere>;
  OR?: InputMaybe<Array<CategoryRevisionsConnectionWhere>>;
  node?: InputMaybe<PostRevisionWhere>;
};

export type CategoryRevisionsCreateFieldInput = {
  node: PostRevisionCreateInput;
};

export type CategoryRevisionsDeleteFieldInput = {
  delete?: InputMaybe<PostRevisionDeleteInput>;
  where?: InputMaybe<CategoryRevisionsConnectionWhere>;
};

export type CategoryRevisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostRevisionDisconnectInput>;
  where?: InputMaybe<CategoryRevisionsConnectionWhere>;
};

export type CategoryRevisionsFieldInput = {
  connect?: InputMaybe<Array<CategoryRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CategoryRevisionsCreateFieldInput>>;
};

export type CategoryRevisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CategoryRevisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CategoryRevisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CategoryRevisionsNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lead_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lead_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryRevisionsRelationship = {
  __typename?: 'CategoryRevisionsRelationship';
  cursor: Scalars['String']['output'];
  node: PostRevision;
};

export type CategoryRevisionsUpdateConnectionInput = {
  node?: InputMaybe<PostRevisionUpdateInput>;
};

export type CategoryRevisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<CategoryRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CategoryRevisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<CategoryRevisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CategoryRevisionsDisconnectFieldInput>>;
  update?: InputMaybe<CategoryRevisionsUpdateConnectionInput>;
  where?: InputMaybe<CategoryRevisionsConnectionWhere>;
};

/** Fields to sort Categories by. The order in which sorts are applied is not guaranteed when specifying many fields in one CategorySort object. */
export type CategorySort = {
  body?: InputMaybe<SortDirection>;
  deletedAt?: InputMaybe<SortDirection>;
  genre?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  slug?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  views?: InputMaybe<SortDirection>;
};

export type CategoryUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<CategoryCoverUpdateFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  revisions?: InputMaybe<Array<CategoryRevisionsUpdateFieldInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<CategoryUsersUpdateFieldInput>>;
  views?: InputMaybe<Scalars['Int']['input']>;
  views_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  views_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryUserUsersAggregationSelection = {
  __typename?: 'CategoryUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CategoryUserUsersNodeAggregateSelection>;
};

export type CategoryUserUsersNodeAggregateSelection = {
  __typename?: 'CategoryUserUsersNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type CategoryUsersAggregateInput = {
  AND?: InputMaybe<Array<CategoryUsersAggregateInput>>;
  NOT?: InputMaybe<CategoryUsersAggregateInput>;
  OR?: InputMaybe<Array<CategoryUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CategoryUsersNodeAggregationWhereInput>;
};

export type CategoryUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: PostsOnCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type CategoryUsersConnectOrCreateFieldInput = {
  onCreate: CategoryUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type CategoryUsersConnectOrCreateFieldInputOnCreate = {
  edge: PostsOnCreateInput;
  node: UserOnCreateInput;
};

export type CategoryUsersConnection = {
  __typename?: 'CategoryUsersConnection';
  edges: Array<CategoryUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CategoryUsersConnectionSort = {
  edge?: InputMaybe<PostsOnSort>;
  node?: InputMaybe<UserSort>;
};

export type CategoryUsersConnectionWhere = {
  AND?: InputMaybe<Array<CategoryUsersConnectionWhere>>;
  NOT?: InputMaybe<CategoryUsersConnectionWhere>;
  OR?: InputMaybe<Array<CategoryUsersConnectionWhere>>;
  edge?: InputMaybe<PostsOnWhere>;
  node?: InputMaybe<UserWhere>;
};

export type CategoryUsersCreateFieldInput = {
  edge: PostsOnCreateInput;
  node: UserCreateInput;
};

export type CategoryUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<CategoryUsersConnectionWhere>;
};

export type CategoryUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<CategoryUsersConnectionWhere>;
};

export type CategoryUsersFieldInput = {
  connect?: InputMaybe<Array<CategoryUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CategoryUsersCreateFieldInput>>;
};

export type CategoryUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CategoryUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CategoryUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CategoryUsersNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryUsersRelationship = {
  __typename?: 'CategoryUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: PostsOn;
};

export type CategoryUsersUpdateConnectionInput = {
  edge?: InputMaybe<PostsOnUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type CategoryUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<CategoryUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CategoryUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<CategoryUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CategoryUsersDisconnectFieldInput>>;
  update?: InputMaybe<CategoryUsersUpdateConnectionInput>;
  where?: InputMaybe<CategoryUsersConnectionWhere>;
};

export type CategoryWhere = {
  AND?: InputMaybe<Array<CategoryWhere>>;
  NOT?: InputMaybe<CategoryWhere>;
  OR?: InputMaybe<Array<CategoryWhere>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  body_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  body_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  body_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<FileWhere>;
  coverAggregate?: InputMaybe<CategoryCoverAggregateInput>;
  coverConnection?: InputMaybe<CategoryCoverConnectionWhere>;
  coverConnection_NOT?: InputMaybe<CategoryCoverConnectionWhere>;
  cover_NOT?: InputMaybe<FileWhere>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  genre_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  genre_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  genre_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  genre_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  revisionsAggregate?: InputMaybe<CategoryRevisionsAggregateInput>;
  /** Return Categories where all of the related CategoryRevisionsConnections match this filter */
  revisionsConnection_ALL?: InputMaybe<CategoryRevisionsConnectionWhere>;
  /** Return Categories where none of the related CategoryRevisionsConnections match this filter */
  revisionsConnection_NONE?: InputMaybe<CategoryRevisionsConnectionWhere>;
  /** Return Categories where one of the related CategoryRevisionsConnections match this filter */
  revisionsConnection_SINGLE?: InputMaybe<CategoryRevisionsConnectionWhere>;
  /** Return Categories where some of the related CategoryRevisionsConnections match this filter */
  revisionsConnection_SOME?: InputMaybe<CategoryRevisionsConnectionWhere>;
  /** Return Categories where all of the related PostRevisions match this filter */
  revisions_ALL?: InputMaybe<PostRevisionWhere>;
  /** Return Categories where none of the related PostRevisions match this filter */
  revisions_NONE?: InputMaybe<PostRevisionWhere>;
  /** Return Categories where one of the related PostRevisions match this filter */
  revisions_SINGLE?: InputMaybe<PostRevisionWhere>;
  /** Return Categories where some of the related PostRevisions match this filter */
  revisions_SOME?: InputMaybe<PostRevisionWhere>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  slug_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<CategoryUsersAggregateInput>;
  /** Return Categories where all of the related CategoryUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<CategoryUsersConnectionWhere>;
  /** Return Categories where none of the related CategoryUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<CategoryUsersConnectionWhere>;
  /** Return Categories where one of the related CategoryUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<CategoryUsersConnectionWhere>;
  /** Return Categories where some of the related CategoryUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<CategoryUsersConnectionWhere>;
  /** Return Categories where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Categories where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Categories where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Categories where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  views?: InputMaybe<Scalars['Int']['input']>;
  views_GT?: InputMaybe<Scalars['Int']['input']>;
  views_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  views_LT?: InputMaybe<Scalars['Int']['input']>;
  views_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangePostStatusInput = {
  postId: Scalars['ID']['input'];
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PostStatus>;
};

export type CommercialBreakSchedule = {
  __typename?: 'CommercialBreakSchedule';
  days?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Int']['output']>;
  file: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Int']['output']>;
  time: Scalars['Int']['output'];
};

export type CommercialBreakScheduleAggregateSelection = {
  __typename?: 'CommercialBreakScheduleAggregateSelection';
  count: Scalars['Int']['output'];
  days: IntAggregateSelection;
  endDate: IntAggregateSelection;
  file: StringAggregateSelection;
  id: IdAggregateSelection;
  startDate: IntAggregateSelection;
  time: IntAggregateSelection;
};

export type CommercialBreakScheduleCreateInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Int']['input']>;
  time: Scalars['Int']['input'];
};

export type CommercialBreakScheduleEdge = {
  __typename?: 'CommercialBreakScheduleEdge';
  cursor: Scalars['String']['output'];
  node: CommercialBreakSchedule;
};

export type CommercialBreakScheduleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CommercialBreakScheduleSort objects to sort CommercialBreakSchedules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CommercialBreakScheduleSort>>;
};

/** Fields to sort CommercialBreakSchedules by. The order in which sorts are applied is not guaranteed when specifying many fields in one CommercialBreakScheduleSort object. */
export type CommercialBreakScheduleSort = {
  days?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  file?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  time?: InputMaybe<SortDirection>;
};

export type CommercialBreakScheduleUpdateInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  days_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  days_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endDate_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  endDate_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startDate_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  startDate_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  time_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  time_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type CommercialBreakScheduleWhere = {
  AND?: InputMaybe<Array<CommercialBreakScheduleWhere>>;
  NOT?: InputMaybe<CommercialBreakScheduleWhere>;
  OR?: InputMaybe<Array<CommercialBreakScheduleWhere>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endDate_GT?: InputMaybe<Scalars['Int']['input']>;
  endDate_GTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate_LT?: InputMaybe<Scalars['Int']['input']>;
  endDate_LTE?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  file_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  file_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  file_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  file_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startDate_GT?: InputMaybe<Scalars['Int']['input']>;
  startDate_GTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate_LT?: InputMaybe<Scalars['Int']['input']>;
  startDate_LTE?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  time_GT?: InputMaybe<Scalars['Int']['input']>;
  time_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  time_LT?: InputMaybe<Scalars['Int']['input']>;
  time_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CommercialBreakSchedulesConnection = {
  __typename?: 'CommercialBreakSchedulesConnection';
  edges: Array<CommercialBreakScheduleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateAppkeyInput = {
  name: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
};

export type CreateAppkeyResponse = {
  __typename?: 'CreateAppkeyResponse';
  credentialID: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type CreateAppkeyResponseAggregateSelection = {
  __typename?: 'CreateAppkeyResponseAggregateSelection';
  count: Scalars['Int']['output'];
  credentialID: StringAggregateSelection;
  password: StringAggregateSelection;
};

export type CreateAppkeyResponseCreateInput = {
  credentialID: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreateAppkeyResponseEdge = {
  __typename?: 'CreateAppkeyResponseEdge';
  cursor: Scalars['String']['output'];
  node: CreateAppkeyResponse;
};

export type CreateAppkeyResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CreateAppkeyResponseSort objects to sort CreateAppkeyResponses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CreateAppkeyResponseSort>>;
};

/** Fields to sort CreateAppkeyResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one CreateAppkeyResponseSort object. */
export type CreateAppkeyResponseSort = {
  credentialID?: InputMaybe<SortDirection>;
  password?: InputMaybe<SortDirection>;
};

export type CreateAppkeyResponseUpdateInput = {
  credentialID?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppkeyResponseWhere = {
  AND?: InputMaybe<Array<CreateAppkeyResponseWhere>>;
  NOT?: InputMaybe<CreateAppkeyResponseWhere>;
  OR?: InputMaybe<Array<CreateAppkeyResponseWhere>>;
  credentialID?: InputMaybe<Scalars['String']['input']>;
  credentialID_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  credentialID_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialID_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialID_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  password_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  password_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  password_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  password_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppkeyResponsesConnection = {
  __typename?: 'CreateAppkeyResponsesConnection';
  edges: Array<CreateAppkeyResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateBannersMutationResponse = {
  __typename?: 'CreateBannersMutationResponse';
  banners: Array<Banner>;
  info: CreateInfo;
};

export type CreateCategoriesMutationResponse = {
  __typename?: 'CreateCategoriesMutationResponse';
  categories: Array<Category>;
  info: CreateInfo;
};

export type CreateCommercialBreakSchedulesMutationResponse = {
  __typename?: 'CreateCommercialBreakSchedulesMutationResponse';
  commercialBreakSchedules: Array<CommercialBreakSchedule>;
  info: CreateInfo;
};

export type CreateCreateAppkeyResponsesMutationResponse = {
  __typename?: 'CreateCreateAppkeyResponsesMutationResponse';
  createAppkeyResponses: Array<CreateAppkeyResponse>;
  info: CreateInfo;
};

export type CreateDeadlinesMutationResponse = {
  __typename?: 'CreateDeadlinesMutationResponse';
  deadlines: Array<Deadline>;
  info: CreateInfo;
};

export type CreateFanGalleryItemsMutationResponse = {
  __typename?: 'CreateFanGalleryItemsMutationResponse';
  fanGalleryItems: Array<FanGalleryItem>;
  info: CreateInfo;
};

export type CreateFilesMutationResponse = {
  __typename?: 'CreateFilesMutationResponse';
  files: Array<File>;
  info: CreateInfo;
};

/** Information about the number of nodes and relationships created during a create mutation */
export type CreateInfo = {
  __typename?: 'CreateInfo';
  /** @deprecated This field has been deprecated because bookmarks are now handled by the driver. */
  bookmark?: Maybe<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
};

export type CreateOurSocialLinksMutationResponse = {
  __typename?: 'CreateOurSocialLinksMutationResponse';
  info: CreateInfo;
  ourSocialLinks: Array<OurSocialLink>;
};

export type CreatePartnersMutationResponse = {
  __typename?: 'CreatePartnersMutationResponse';
  info: CreateInfo;
  partners: Array<Partner>;
};

export type CreatePollsMutationResponse = {
  __typename?: 'CreatePollsMutationResponse';
  info: CreateInfo;
  polls: Array<Poll>;
};

export type CreatePostAbsencesMutationResponse = {
  __typename?: 'CreatePostAbsencesMutationResponse';
  info: CreateInfo;
  postAbsences: Array<PostAbsence>;
};

export type CreatePostSchedulesMutationResponse = {
  __typename?: 'CreatePostSchedulesMutationResponse';
  info: CreateInfo;
  postSchedules: Array<PostSchedule>;
};

export type CreateRadioShowSchedulesMutationResponse = {
  __typename?: 'CreateRadioShowSchedulesMutationResponse';
  info: CreateInfo;
  radioShowSchedules: Array<RadioShowSchedule>;
};

export type CreateRadioShowsMutationResponse = {
  __typename?: 'CreateRadioShowsMutationResponse';
  info: CreateInfo;
  radioShows: Array<RadioShow>;
};

export type CreateSongRequestBannedIpsMutationResponse = {
  __typename?: 'CreateSongRequestBannedIpsMutationResponse';
  info: CreateInfo;
  songRequestBannedIps: Array<SongRequestBannedIp>;
};

export type CreateSongRequestsMutationResponse = {
  __typename?: 'CreateSongRequestsMutationResponse';
  info: CreateInfo;
  songRequests: Array<SongRequest>;
};

export type CreateStreamingAbsencesMutationResponse = {
  __typename?: 'CreateStreamingAbsencesMutationResponse';
  info: CreateInfo;
  streamingAbsences: Array<StreamingAbsence>;
};

export type CreateTagsMutationResponse = {
  __typename?: 'CreateTagsMutationResponse';
  info: CreateInfo;
  tags: Array<Tag>;
};

export type CreateUserAppkeysMutationResponse = {
  __typename?: 'CreateUserAppkeysMutationResponse';
  info: CreateInfo;
  userAppkeys: Array<UserAppkey>;
};

export type CreateUserPasskeysMutationResponse = {
  __typename?: 'CreateUserPasskeysMutationResponse';
  info: CreateInfo;
  userPasskeys: Array<UserPasskey>;
};

export type CreateUsersMutationResponse = {
  __typename?: 'CreateUsersMutationResponse';
  info: CreateInfo;
  users: Array<User>;
};

export type DateTimeAggregateSelection = {
  __typename?: 'DateTimeAggregateSelection';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type Deadline = {
  __typename?: 'Deadline';
  frequency: DeadlineFrequency;
  id: Scalars['ID']['output'];
  startDate: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type DeadlineAggregateSelection = {
  __typename?: 'DeadlineAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelection;
  title: StringAggregateSelection;
  weight: IntAggregateSelection;
};

export type DeadlineCreateInput = {
  frequency: DeadlineFrequency;
  startDate: Scalars['Date']['input'];
  title: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export type DeadlineEdge = {
  __typename?: 'DeadlineEdge';
  cursor: Scalars['String']['output'];
  node: Deadline;
};

export enum DeadlineFrequency {
  Monthly = 'MONTHLY',
  Monthly_2 = 'MONTHLY_2',
  Monthly_3 = 'MONTHLY_3',
  Monthly_4 = 'MONTHLY_4',
  Monthly_6 = 'MONTHLY_6',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type DeadlineOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DeadlineSort objects to sort Deadlines by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DeadlineSort>>;
};

/** Fields to sort Deadlines by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeadlineSort object. */
export type DeadlineSort = {
  frequency?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  weight?: InputMaybe<SortDirection>;
};

export type DeadlineUpdateInput = {
  frequency?: InputMaybe<DeadlineFrequency>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type DeadlineWhere = {
  AND?: InputMaybe<Array<DeadlineWhere>>;
  NOT?: InputMaybe<DeadlineWhere>;
  OR?: InputMaybe<Array<DeadlineWhere>>;
  frequency?: InputMaybe<DeadlineFrequency>;
  frequency_IN?: InputMaybe<Array<DeadlineFrequency>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_GT?: InputMaybe<Scalars['Date']['input']>;
  startDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  startDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  startDate_LT?: InputMaybe<Scalars['Date']['input']>;
  startDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  weight_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeadlinesConnection = {
  __typename?: 'DeadlinesConnection';
  edges: Array<DeadlineEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about the number of nodes and relationships deleted during a delete mutation */
export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  /** @deprecated This field has been deprecated because bookmarks are now handled by the driver. */
  bookmark?: Maybe<Scalars['String']['output']>;
  nodesDeleted: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type FanGalleryItem = {
  __typename?: 'FanGalleryItem';
  author: Scalars['String']['output'];
  authorSocial?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: File;
  imageAggregate?: Maybe<FanGalleryItemFileImageAggregationSelection>;
  imageConnection: FanGalleryItemImageConnection;
  title: Scalars['String']['output'];
};


export type FanGalleryItemImageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type FanGalleryItemImageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type FanGalleryItemImageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FanGalleryItemImageConnectionSort>>;
  where?: InputMaybe<FanGalleryItemImageConnectionWhere>;
};

export type FanGalleryItemAggregateSelection = {
  __typename?: 'FanGalleryItemAggregateSelection';
  author: StringAggregateSelection;
  authorSocial: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  title: StringAggregateSelection;
};

export type FanGalleryItemConnectInput = {
  image?: InputMaybe<FanGalleryItemImageConnectFieldInput>;
};

export type FanGalleryItemConnectOrCreateInput = {
  image?: InputMaybe<FanGalleryItemImageConnectOrCreateFieldInput>;
};

export type FanGalleryItemCreateInput = {
  author: Scalars['String']['input'];
  authorSocial?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  image?: InputMaybe<FanGalleryItemImageFieldInput>;
  title: Scalars['String']['input'];
};

export type FanGalleryItemDeleteInput = {
  image?: InputMaybe<FanGalleryItemImageDeleteFieldInput>;
};

export type FanGalleryItemDisconnectInput = {
  image?: InputMaybe<FanGalleryItemImageDisconnectFieldInput>;
};

export type FanGalleryItemEdge = {
  __typename?: 'FanGalleryItemEdge';
  cursor: Scalars['String']['output'];
  node: FanGalleryItem;
};

export type FanGalleryItemFileImageAggregationSelection = {
  __typename?: 'FanGalleryItemFileImageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FanGalleryItemFileImageNodeAggregateSelection>;
};

export type FanGalleryItemFileImageNodeAggregateSelection = {
  __typename?: 'FanGalleryItemFileImageNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type FanGalleryItemImageAggregateInput = {
  AND?: InputMaybe<Array<FanGalleryItemImageAggregateInput>>;
  NOT?: InputMaybe<FanGalleryItemImageAggregateInput>;
  OR?: InputMaybe<Array<FanGalleryItemImageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FanGalleryItemImageNodeAggregationWhereInput>;
};

export type FanGalleryItemImageConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type FanGalleryItemImageConnectOrCreateFieldInput = {
  onCreate: FanGalleryItemImageConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type FanGalleryItemImageConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type FanGalleryItemImageConnection = {
  __typename?: 'FanGalleryItemImageConnection';
  edges: Array<FanGalleryItemImageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FanGalleryItemImageConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type FanGalleryItemImageConnectionWhere = {
  AND?: InputMaybe<Array<FanGalleryItemImageConnectionWhere>>;
  NOT?: InputMaybe<FanGalleryItemImageConnectionWhere>;
  OR?: InputMaybe<Array<FanGalleryItemImageConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type FanGalleryItemImageCreateFieldInput = {
  node: FileCreateInput;
};

export type FanGalleryItemImageDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<FanGalleryItemImageConnectionWhere>;
};

export type FanGalleryItemImageDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<FanGalleryItemImageConnectionWhere>;
};

export type FanGalleryItemImageFieldInput = {
  connect?: InputMaybe<FanGalleryItemImageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FanGalleryItemImageConnectOrCreateFieldInput>;
  create?: InputMaybe<FanGalleryItemImageCreateFieldInput>;
};

export type FanGalleryItemImageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FanGalleryItemImageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FanGalleryItemImageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FanGalleryItemImageNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FanGalleryItemImageRelationship = {
  __typename?: 'FanGalleryItemImageRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FanGalleryItemImageUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type FanGalleryItemImageUpdateFieldInput = {
  connect?: InputMaybe<FanGalleryItemImageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FanGalleryItemImageConnectOrCreateFieldInput>;
  create?: InputMaybe<FanGalleryItemImageCreateFieldInput>;
  delete?: InputMaybe<FanGalleryItemImageDeleteFieldInput>;
  disconnect?: InputMaybe<FanGalleryItemImageDisconnectFieldInput>;
  update?: InputMaybe<FanGalleryItemImageUpdateConnectionInput>;
  where?: InputMaybe<FanGalleryItemImageConnectionWhere>;
};

export type FanGalleryItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FanGalleryItemSort objects to sort FanGalleryItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FanGalleryItemSort>>;
};

export type FanGalleryItemRelationInput = {
  image?: InputMaybe<FanGalleryItemImageCreateFieldInput>;
};

/** Fields to sort FanGalleryItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one FanGalleryItemSort object. */
export type FanGalleryItemSort = {
  author?: InputMaybe<SortDirection>;
  authorSocial?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  deletedAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type FanGalleryItemUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorSocial?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FanGalleryItemImageUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FanGalleryItemWhere = {
  AND?: InputMaybe<Array<FanGalleryItemWhere>>;
  NOT?: InputMaybe<FanGalleryItemWhere>;
  OR?: InputMaybe<Array<FanGalleryItemWhere>>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorSocial?: InputMaybe<Scalars['String']['input']>;
  authorSocial_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  authorSocial_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  authorSocial_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorSocial_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  author_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  author_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  author_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  author_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<FileWhere>;
  imageAggregate?: InputMaybe<FanGalleryItemImageAggregateInput>;
  imageConnection?: InputMaybe<FanGalleryItemImageConnectionWhere>;
  imageConnection_NOT?: InputMaybe<FanGalleryItemImageConnectionWhere>;
  image_NOT?: InputMaybe<FileWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FanGalleryItemsConnection = {
  __typename?: 'FanGalleryItemsConnection';
  edges: Array<FanGalleryItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type File = {
  __typename?: 'File';
  attachedToPosts: Array<Post>;
  attachedToPostsAggregate?: Maybe<FilePostAttachedToPostsAggregationSelection>;
  attachedToPostsConnection: FileAttachedToPostsConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdByAggregate?: Maybe<FileUserCreatedByAggregationSelection>;
  createdByConnection: FileCreatedByConnection;
  description?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};


export type FileAttachedToPostsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type FileAttachedToPostsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type FileAttachedToPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileAttachedToPostsConnectionSort>>;
  where?: InputMaybe<FileAttachedToPostsConnectionWhere>;
};


export type FileCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FileCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FileCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileCreatedByConnectionSort>>;
  where?: InputMaybe<FileCreatedByConnectionWhere>;
};

export type FileAggregateSelection = {
  __typename?: 'FileAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type FileAttachedToPostsAggregateInput = {
  AND?: InputMaybe<Array<FileAttachedToPostsAggregateInput>>;
  NOT?: InputMaybe<FileAttachedToPostsAggregateInput>;
  OR?: InputMaybe<Array<FileAttachedToPostsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileAttachedToPostsNodeAggregationWhereInput>;
};

export type FileAttachedToPostsConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type FileAttachedToPostsConnectOrCreateFieldInput = {
  onCreate: FileAttachedToPostsConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type FileAttachedToPostsConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type FileAttachedToPostsConnection = {
  __typename?: 'FileAttachedToPostsConnection';
  edges: Array<FileAttachedToPostsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileAttachedToPostsConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type FileAttachedToPostsConnectionWhere = {
  AND?: InputMaybe<Array<FileAttachedToPostsConnectionWhere>>;
  NOT?: InputMaybe<FileAttachedToPostsConnectionWhere>;
  OR?: InputMaybe<Array<FileAttachedToPostsConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type FileAttachedToPostsCreateFieldInput = {
  node: PostCreateInput;
};

export type FileAttachedToPostsDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<FileAttachedToPostsConnectionWhere>;
};

export type FileAttachedToPostsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<FileAttachedToPostsConnectionWhere>;
};

export type FileAttachedToPostsFieldInput = {
  connect?: InputMaybe<Array<FileAttachedToPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FileAttachedToPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FileAttachedToPostsCreateFieldInput>>;
};

export type FileAttachedToPostsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileAttachedToPostsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileAttachedToPostsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileAttachedToPostsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  oldId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileAttachedToPostsRelationship = {
  __typename?: 'FileAttachedToPostsRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type FileAttachedToPostsUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type FileAttachedToPostsUpdateFieldInput = {
  connect?: InputMaybe<Array<FileAttachedToPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FileAttachedToPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FileAttachedToPostsCreateFieldInput>>;
  delete?: InputMaybe<Array<FileAttachedToPostsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<FileAttachedToPostsDisconnectFieldInput>>;
  update?: InputMaybe<FileAttachedToPostsUpdateConnectionInput>;
  where?: InputMaybe<FileAttachedToPostsConnectionWhere>;
};

export type FileConnectInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsConnectFieldInput>>;
  createdBy?: InputMaybe<FileCreatedByConnectFieldInput>;
};

export type FileConnectOrCreateInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsConnectOrCreateFieldInput>>;
  createdBy?: InputMaybe<FileCreatedByConnectOrCreateFieldInput>;
};

export type FileConnectOrCreateWhere = {
  node: FileUniqueWhere;
};

export type FileConnectWhere = {
  node: FileWhere;
};

export type FileCreateInput = {
  attachedToPosts?: InputMaybe<FileAttachedToPostsFieldInput>;
  createdBy?: InputMaybe<FileCreatedByFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FileCreatedByAggregateInput = {
  AND?: InputMaybe<Array<FileCreatedByAggregateInput>>;
  NOT?: InputMaybe<FileCreatedByAggregateInput>;
  OR?: InputMaybe<Array<FileCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileCreatedByNodeAggregationWhereInput>;
};

export type FileCreatedByConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FileCreatedByConnectOrCreateFieldInput = {
  onCreate: FileCreatedByConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FileCreatedByConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type FileCreatedByConnection = {
  __typename?: 'FileCreatedByConnection';
  edges: Array<FileCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FileCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<FileCreatedByConnectionWhere>>;
  NOT?: InputMaybe<FileCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<FileCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FileCreatedByCreateFieldInput = {
  node: UserCreateInput;
};

export type FileCreatedByDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FileCreatedByConnectionWhere>;
};

export type FileCreatedByDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FileCreatedByConnectionWhere>;
};

export type FileCreatedByFieldInput = {
  connect?: InputMaybe<FileCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<FileCreatedByCreateFieldInput>;
};

export type FileCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileCreatedByNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreatedByRelationship = {
  __typename?: 'FileCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FileCreatedByUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type FileCreatedByUpdateFieldInput = {
  connect?: InputMaybe<FileCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<FileCreatedByCreateFieldInput>;
  delete?: InputMaybe<FileCreatedByDeleteFieldInput>;
  disconnect?: InputMaybe<FileCreatedByDisconnectFieldInput>;
  update?: InputMaybe<FileCreatedByUpdateConnectionInput>;
  where?: InputMaybe<FileCreatedByConnectionWhere>;
};

export type FileDeleteInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsDeleteFieldInput>>;
  createdBy?: InputMaybe<FileCreatedByDeleteFieldInput>;
};

export type FileDisconnectInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsDisconnectFieldInput>>;
  createdBy?: InputMaybe<FileCreatedByDisconnectFieldInput>;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FileOnCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FileSort objects to sort Files by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FileSort>>;
};

export type FilePostAttachedToPostsAggregationSelection = {
  __typename?: 'FilePostAttachedToPostsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FilePostAttachedToPostsNodeAggregateSelection>;
};

export type FilePostAttachedToPostsNodeAggregateSelection = {
  __typename?: 'FilePostAttachedToPostsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type FileRelationInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsCreateFieldInput>>;
  createdBy?: InputMaybe<FileCreatedByCreateFieldInput>;
};

/** Fields to sort Files by. The order in which sorts are applied is not guaranteed when specifying many fields in one FileSort object. */
export type FileSort = {
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  hash?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  mimeType?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  usageCount?: InputMaybe<SortDirection>;
};

export type FileUniqueWhere = {
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FileUpdateInput = {
  attachedToPosts?: InputMaybe<Array<FileAttachedToPostsUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<FileCreatedByUpdateFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FileUserCreatedByAggregationSelection = {
  __typename?: 'FileUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileUserCreatedByNodeAggregateSelection>;
};

export type FileUserCreatedByNodeAggregateSelection = {
  __typename?: 'FileUserCreatedByNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type FileWhere = {
  AND?: InputMaybe<Array<FileWhere>>;
  NOT?: InputMaybe<FileWhere>;
  OR?: InputMaybe<Array<FileWhere>>;
  attachedToPostsAggregate?: InputMaybe<FileAttachedToPostsAggregateInput>;
  /** Return Files where all of the related FileAttachedToPostsConnections match this filter */
  attachedToPostsConnection_ALL?: InputMaybe<FileAttachedToPostsConnectionWhere>;
  /** Return Files where none of the related FileAttachedToPostsConnections match this filter */
  attachedToPostsConnection_NONE?: InputMaybe<FileAttachedToPostsConnectionWhere>;
  /** Return Files where one of the related FileAttachedToPostsConnections match this filter */
  attachedToPostsConnection_SINGLE?: InputMaybe<FileAttachedToPostsConnectionWhere>;
  /** Return Files where some of the related FileAttachedToPostsConnections match this filter */
  attachedToPostsConnection_SOME?: InputMaybe<FileAttachedToPostsConnectionWhere>;
  /** Return Files where all of the related Posts match this filter */
  attachedToPosts_ALL?: InputMaybe<PostWhere>;
  /** Return Files where none of the related Posts match this filter */
  attachedToPosts_NONE?: InputMaybe<PostWhere>;
  /** Return Files where one of the related Posts match this filter */
  attachedToPosts_SINGLE?: InputMaybe<PostWhere>;
  /** Return Files where some of the related Posts match this filter */
  attachedToPosts_SOME?: InputMaybe<PostWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<FileCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<FileCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<FileCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  hash_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hash_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hash_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  hash_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  mimeType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mimeType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mimeType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  mimeType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_GT?: InputMaybe<Scalars['Int']['input']>;
  size_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  size_LT?: InputMaybe<Scalars['Int']['input']>;
  size_LTE?: InputMaybe<Scalars['Int']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
  usageCount_GT?: InputMaybe<Scalars['Int']['input']>;
  usageCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  usageCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  usageCount_LT?: InputMaybe<Scalars['Int']['input']>;
  usageCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FilesConnection = {
  __typename?: 'FilesConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FloatAggregateSelection = {
  __typename?: 'FloatAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type HourlyListenersStatPoint = {
  __typename?: 'HourlyListenersStatPoint';
  listeners: Scalars['Float']['output'];
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type HourlyListenersStatPointAggregateSelection = {
  __typename?: 'HourlyListenersStatPointAggregateSelection';
  count: Scalars['Int']['output'];
  listeners: FloatAggregateSelection;
  time: DateTimeAggregateSelection;
};

export type HourlyListenersStatPointEdge = {
  __typename?: 'HourlyListenersStatPointEdge';
  cursor: Scalars['String']['output'];
  node: HourlyListenersStatPoint;
};

export type HourlyListenersStatPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more HourlyListenersStatPointSort objects to sort HourlyListenersStatPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<HourlyListenersStatPointSort>>;
};

/** Fields to sort HourlyListenersStatPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one HourlyListenersStatPointSort object. */
export type HourlyListenersStatPointSort = {
  listeners?: InputMaybe<SortDirection>;
  time?: InputMaybe<SortDirection>;
};

export type HourlyListenersStatPointWhere = {
  AND?: InputMaybe<Array<HourlyListenersStatPointWhere>>;
  NOT?: InputMaybe<HourlyListenersStatPointWhere>;
  OR?: InputMaybe<Array<HourlyListenersStatPointWhere>>;
  listeners?: InputMaybe<Scalars['Float']['input']>;
  listeners_GT?: InputMaybe<Scalars['Float']['input']>;
  listeners_GTE?: InputMaybe<Scalars['Float']['input']>;
  listeners_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  listeners_LT?: InputMaybe<Scalars['Float']['input']>;
  listeners_LTE?: InputMaybe<Scalars['Float']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  time_GT?: InputMaybe<Scalars['DateTime']['input']>;
  time_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  time_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  time_LT?: InputMaybe<Scalars['DateTime']['input']>;
  time_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HourlyListenersStatPointsConnection = {
  __typename?: 'HourlyListenersStatPointsConnection';
  edges: Array<HourlyListenersStatPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelection = {
  __typename?: 'IDAggregateSelection';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export type InternalQueuedSong = {
  __typename?: 'InternalQueuedSong';
  album?: Maybe<Scalars['String']['output']>;
  artist?: Maybe<Scalars['String']['output']>;
  cover: Scalars['String']['output'];
  file: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rid: Scalars['Int']['output'];
  time: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type InternalRequestedSong = {
  __typename?: 'InternalRequestedSong';
  album?: Maybe<Scalars['String']['output']>;
  artist?: Maybe<Scalars['String']['output']>;
  cover: Scalars['String']['output'];
  file: Scalars['String']['output'];
  numberOfRequests: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  weeksAgo: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Post.revisions
 * * PostRevision.post
 */
export type IsRevisionOf = {
  __typename?: 'IsRevisionOf';
  status: PostRevisionStatus;
};

export type IsRevisionOfCreateInput = {
  status: PostRevisionStatus;
};

export type IsRevisionOfSort = {
  status?: InputMaybe<SortDirection>;
};

export type IsRevisionOfUpdateInput = {
  status?: InputMaybe<PostRevisionStatus>;
};

export type IsRevisionOfWhere = {
  AND?: InputMaybe<Array<IsRevisionOfWhere>>;
  NOT?: InputMaybe<IsRevisionOfWhere>;
  OR?: InputMaybe<Array<IsRevisionOfWhere>>;
  status?: InputMaybe<PostRevisionStatus>;
  status_IN?: InputMaybe<Array<PostRevisionStatus>>;
};

export type LogSuccessfulSongRequestInput = {
  file: Scalars['String']['input'];
  fileMeta: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  result: Scalars['String']['output'];
  roles: Array<UserRole>;
  securityCodes: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAiredRadioShow: Scalars['Boolean']['output'];
  changePostStatus: Scalars['Boolean']['output'];
  createAppkey: CreateAppkeyResponse;
  createBanners: CreateBannersMutationResponse;
  createCategories: CreateCategoriesMutationResponse;
  createCommercialBreakSchedules: CreateCommercialBreakSchedulesMutationResponse;
  createCreateAppkeyResponses: CreateCreateAppkeyResponsesMutationResponse;
  createDeadlines: CreateDeadlinesMutationResponse;
  createFanGalleryItems: CreateFanGalleryItemsMutationResponse;
  createFiles: CreateFilesMutationResponse;
  createOurSocialLinks: CreateOurSocialLinksMutationResponse;
  createPartners: CreatePartnersMutationResponse;
  createPolls: CreatePollsMutationResponse;
  createPostAbsences: CreatePostAbsencesMutationResponse;
  createPostSchedules: CreatePostSchedulesMutationResponse;
  createRadioShowSchedules: CreateRadioShowSchedulesMutationResponse;
  createRadioShows: CreateRadioShowsMutationResponse;
  createSongRequestBannedIps: CreateSongRequestBannedIpsMutationResponse;
  createSongRequests: CreateSongRequestsMutationResponse;
  createStreamingAbsences: CreateStreamingAbsencesMutationResponse;
  createTags: CreateTagsMutationResponse;
  createUserAppkeys: CreateUserAppkeysMutationResponse;
  createUserPasskeys: CreateUserPasskeysMutationResponse;
  createUsers: CreateUsersMutationResponse;
  deleteBanners: DeleteInfo;
  deleteCategories: DeleteInfo;
  deleteCommercialBreakSchedules: DeleteInfo;
  deleteCreateAppkeyResponses: DeleteInfo;
  deleteDeadlines: DeleteInfo;
  deleteFanGalleryItems: DeleteInfo;
  deleteFiles: DeleteInfo;
  deleteOurSocialLinks: DeleteInfo;
  deletePartners: DeleteInfo;
  deletePolls: DeleteInfo;
  deletePostAbsences: DeleteInfo;
  deletePostSchedules: DeleteInfo;
  deleteRadioShowSchedules: DeleteInfo;
  deleteRadioShows: DeleteInfo;
  deleteSongRequestBannedIps: DeleteInfo;
  deleteSongRequests: DeleteInfo;
  deleteStreamingAbsences: DeleteInfo;
  deleteTags: DeleteInfo;
  deleteUserAppkeys: DeleteInfo;
  deleteUserPasskeys: DeleteInfo;
  deleteUsers: DeleteInfo;
  discardPostRevision: Scalars['DateTime']['output'];
  forgotPassword: Scalars['Boolean']['output'];
  logSuccessfulSongRequest: Scalars['Boolean']['output'];
  login: LoginResponse;
  logout: Scalars['Boolean']['output'];
  mergeTags: Tag;
  resetPassword: Scalars['Boolean']['output'];
  saveSongRequest: Scalars['Boolean']['output'];
  sendMessage: Scalars['Int']['output'];
  setBasePlaylist: Scalars['Boolean']['output'];
  setCommercialBreakPlayerDescription: Scalars['Boolean']['output'];
  setCommercialBreakPlayerImage: Scalars['Boolean']['output'];
  setCommercialBreakPlayerName: Scalars['Boolean']['output'];
  setListeners: Scalars['Boolean']['output'];
  setMyNotes: Scalars['Boolean']['output'];
  setStreamingNeedsRestart: Scalars['Boolean']['output'];
  setTimeAnnouncerInterval: Scalars['Boolean']['output'];
  setTimeAnnouncerVoice: Scalars['Boolean']['output'];
  shedPostRevision: Scalars['DateTime']['output'];
  startRadioShow: RadioShow;
  stopRadioShow: Scalars['Boolean']['output'];
  unsetMyPassword: Scalars['Boolean']['output'];
  updateAuthSettings: UserSettingsResponse;
  updateBanners: UpdateBannersMutationResponse;
  updateCategories: UpdateCategoriesMutationResponse;
  updateCommercialBreakSchedules: UpdateCommercialBreakSchedulesMutationResponse;
  updateCreateAppkeyResponses: UpdateCreateAppkeyResponsesMutationResponse;
  updateDeadlines: UpdateDeadlinesMutationResponse;
  updateFanGalleryItems: UpdateFanGalleryItemsMutationResponse;
  updateFiles: UpdateFilesMutationResponse;
  updateOurSocialLinks: UpdateOurSocialLinksMutationResponse;
  updatePartners: UpdatePartnersMutationResponse;
  updatePolls: UpdatePollsMutationResponse;
  updatePost: Scalars['DateTime']['output'];
  updatePostAbsences: UpdatePostAbsencesMutationResponse;
  updatePostSchedules: UpdatePostSchedulesMutationResponse;
  updateRadioShowSchedules: UpdateRadioShowSchedulesMutationResponse;
  updateRadioShows: UpdateRadioShowsMutationResponse;
  updateSongRequestBannedIps: UpdateSongRequestBannedIpsMutationResponse;
  updateSongRequests: UpdateSongRequestsMutationResponse;
  updateStreamingAbsences: UpdateStreamingAbsencesMutationResponse;
  updateTags: UpdateTagsMutationResponse;
  updateUserAppkeys: UpdateUserAppkeysMutationResponse;
  updateUserPasskeys: UpdateUserPasskeysMutationResponse;
  updateUsers: UpdateUsersMutationResponse;
  voteOnPoll: Scalars['Boolean']['output'];
};


export type MutationAddAiredRadioShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangePostStatusArgs = {
  input: ChangePostStatusInput;
};


export type MutationCreateAppkeyArgs = {
  input: CreateAppkeyInput;
};


export type MutationCreateBannersArgs = {
  input: Array<BannerCreateInput>;
};


export type MutationCreateCategoriesArgs = {
  input: Array<CategoryCreateInput>;
};


export type MutationCreateCommercialBreakSchedulesArgs = {
  input: Array<CommercialBreakScheduleCreateInput>;
};


export type MutationCreateCreateAppkeyResponsesArgs = {
  input: Array<CreateAppkeyResponseCreateInput>;
};


export type MutationCreateDeadlinesArgs = {
  input: Array<DeadlineCreateInput>;
};


export type MutationCreateFanGalleryItemsArgs = {
  input: Array<FanGalleryItemCreateInput>;
};


export type MutationCreateFilesArgs = {
  input: Array<FileCreateInput>;
};


export type MutationCreateOurSocialLinksArgs = {
  input: Array<OurSocialLinkCreateInput>;
};


export type MutationCreatePartnersArgs = {
  input: Array<PartnerCreateInput>;
};


export type MutationCreatePollsArgs = {
  input: Array<PollCreateInput>;
};


export type MutationCreatePostAbsencesArgs = {
  input: Array<PostAbsenceCreateInput>;
};


export type MutationCreatePostSchedulesArgs = {
  input: Array<PostScheduleCreateInput>;
};


export type MutationCreateRadioShowSchedulesArgs = {
  input: Array<RadioShowScheduleCreateInput>;
};


export type MutationCreateRadioShowsArgs = {
  input: Array<RadioShowCreateInput>;
};


export type MutationCreateSongRequestBannedIpsArgs = {
  input: Array<SongRequestBannedIpCreateInput>;
};


export type MutationCreateSongRequestsArgs = {
  input: Array<SongRequestCreateInput>;
};


export type MutationCreateStreamingAbsencesArgs = {
  input: Array<StreamingAbsenceCreateInput>;
};


export type MutationCreateTagsArgs = {
  input: Array<TagCreateInput>;
};


export type MutationCreateUserAppkeysArgs = {
  input: Array<UserAppkeyCreateInput>;
};


export type MutationCreateUserPasskeysArgs = {
  input: Array<UserPasskeyCreateInput>;
};


export type MutationCreateUsersArgs = {
  input: Array<UserCreateInput>;
};


export type MutationDeleteBannersArgs = {
  delete?: InputMaybe<BannerDeleteInput>;
  where?: InputMaybe<BannerWhere>;
};


export type MutationDeleteCategoriesArgs = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<CategoryWhere>;
};


export type MutationDeleteCommercialBreakSchedulesArgs = {
  where?: InputMaybe<CommercialBreakScheduleWhere>;
};


export type MutationDeleteCreateAppkeyResponsesArgs = {
  where?: InputMaybe<CreateAppkeyResponseWhere>;
};


export type MutationDeleteDeadlinesArgs = {
  where?: InputMaybe<DeadlineWhere>;
};


export type MutationDeleteFanGalleryItemsArgs = {
  delete?: InputMaybe<FanGalleryItemDeleteInput>;
  where?: InputMaybe<FanGalleryItemWhere>;
};


export type MutationDeleteFilesArgs = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<FileWhere>;
};


export type MutationDeleteOurSocialLinksArgs = {
  where?: InputMaybe<OurSocialLinkWhere>;
};


export type MutationDeletePartnersArgs = {
  delete?: InputMaybe<PartnerDeleteInput>;
  where?: InputMaybe<PartnerWhere>;
};


export type MutationDeletePollsArgs = {
  delete?: InputMaybe<PollDeleteInput>;
  where?: InputMaybe<PollWhere>;
};


export type MutationDeletePostAbsencesArgs = {
  delete?: InputMaybe<PostAbsenceDeleteInput>;
  where?: InputMaybe<PostAbsenceWhere>;
};


export type MutationDeletePostSchedulesArgs = {
  delete?: InputMaybe<PostScheduleDeleteInput>;
  where?: InputMaybe<PostScheduleWhere>;
};


export type MutationDeleteRadioShowSchedulesArgs = {
  delete?: InputMaybe<RadioShowScheduleDeleteInput>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type MutationDeleteRadioShowsArgs = {
  delete?: InputMaybe<RadioShowDeleteInput>;
  where?: InputMaybe<RadioShowWhere>;
};


export type MutationDeleteSongRequestBannedIpsArgs = {
  delete?: InputMaybe<SongRequestBannedIpDeleteInput>;
  where?: InputMaybe<SongRequestBannedIpWhere>;
};


export type MutationDeleteSongRequestsArgs = {
  delete?: InputMaybe<SongRequestDeleteInput>;
  where?: InputMaybe<SongRequestWhere>;
};


export type MutationDeleteStreamingAbsencesArgs = {
  delete?: InputMaybe<StreamingAbsenceDeleteInput>;
  where?: InputMaybe<StreamingAbsenceWhere>;
};


export type MutationDeleteTagsArgs = {
  delete?: InputMaybe<TagDeleteInput>;
  where?: InputMaybe<TagWhere>;
};


export type MutationDeleteUserAppkeysArgs = {
  delete?: InputMaybe<UserAppkeyDeleteInput>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type MutationDeleteUserPasskeysArgs = {
  delete?: InputMaybe<UserPasskeyDeleteInput>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type MutationDeleteUsersArgs = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<UserWhere>;
};


export type MutationDiscardPostRevisionArgs = {
  postId: Scalars['ID']['input'];
};


export type MutationForgotPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationLogSuccessfulSongRequestArgs = {
  input: LogSuccessfulSongRequestInput;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  tfaCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationMergeTagsArgs = {
  newTag: Scalars['String']['input'];
  where?: InputMaybe<TagWhere>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveSongRequestArgs = {
  input: SaveSongRequestInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSetBasePlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetCommercialBreakPlayerDescriptionArgs = {
  value: Scalars['String']['input'];
};


export type MutationSetCommercialBreakPlayerImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetCommercialBreakPlayerNameArgs = {
  value: Scalars['String']['input'];
};


export type MutationSetListenersArgs = {
  value: Scalars['Int']['input'];
};


export type MutationSetMyNotesArgs = {
  notes: Scalars['String']['input'];
};


export type MutationSetStreamingNeedsRestartArgs = {
  value: Scalars['Boolean']['input'];
};


export type MutationSetTimeAnnouncerIntervalArgs = {
  value: Scalars['Int']['input'];
};


export type MutationSetTimeAnnouncerVoiceArgs = {
  value: Scalars['String']['input'];
};


export type MutationShedPostRevisionArgs = {
  input: ShedPostRevisionInput;
};


export type MutationStartRadioShowArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUnsetMyPasswordArgs = {
  currentPassword: Scalars['String']['input'];
};


export type MutationUpdateAuthSettingsArgs = {
  settings: UpdateAuthSettingsInput;
};


export type MutationUpdateBannersArgs = {
  update?: InputMaybe<BannerUpdateInput>;
  where?: InputMaybe<BannerWhere>;
};


export type MutationUpdateCategoriesArgs = {
  update?: InputMaybe<CategoryUpdateInput>;
  where?: InputMaybe<CategoryWhere>;
};


export type MutationUpdateCommercialBreakSchedulesArgs = {
  update?: InputMaybe<CommercialBreakScheduleUpdateInput>;
  where?: InputMaybe<CommercialBreakScheduleWhere>;
};


export type MutationUpdateCreateAppkeyResponsesArgs = {
  update?: InputMaybe<CreateAppkeyResponseUpdateInput>;
  where?: InputMaybe<CreateAppkeyResponseWhere>;
};


export type MutationUpdateDeadlinesArgs = {
  update?: InputMaybe<DeadlineUpdateInput>;
  where?: InputMaybe<DeadlineWhere>;
};


export type MutationUpdateFanGalleryItemsArgs = {
  update?: InputMaybe<FanGalleryItemUpdateInput>;
  where?: InputMaybe<FanGalleryItemWhere>;
};


export type MutationUpdateFilesArgs = {
  update?: InputMaybe<FileUpdateInput>;
  where?: InputMaybe<FileWhere>;
};


export type MutationUpdateOurSocialLinksArgs = {
  update?: InputMaybe<OurSocialLinkUpdateInput>;
  where?: InputMaybe<OurSocialLinkWhere>;
};


export type MutationUpdatePartnersArgs = {
  update?: InputMaybe<PartnerUpdateInput>;
  where?: InputMaybe<PartnerWhere>;
};


export type MutationUpdatePollsArgs = {
  update?: InputMaybe<PollUpdateInput>;
  where?: InputMaybe<PollWhere>;
};


export type MutationUpdatePostArgs = {
  input?: InputMaybe<PostInput>;
};


export type MutationUpdatePostAbsencesArgs = {
  update?: InputMaybe<PostAbsenceUpdateInput>;
  where?: InputMaybe<PostAbsenceWhere>;
};


export type MutationUpdatePostSchedulesArgs = {
  update?: InputMaybe<PostScheduleUpdateInput>;
  where?: InputMaybe<PostScheduleWhere>;
};


export type MutationUpdateRadioShowSchedulesArgs = {
  update?: InputMaybe<RadioShowScheduleUpdateInput>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type MutationUpdateRadioShowsArgs = {
  update?: InputMaybe<RadioShowUpdateInput>;
  where?: InputMaybe<RadioShowWhere>;
};


export type MutationUpdateSongRequestBannedIpsArgs = {
  update?: InputMaybe<SongRequestBannedIpUpdateInput>;
  where?: InputMaybe<SongRequestBannedIpWhere>;
};


export type MutationUpdateSongRequestsArgs = {
  update?: InputMaybe<SongRequestUpdateInput>;
  where?: InputMaybe<SongRequestWhere>;
};


export type MutationUpdateStreamingAbsencesArgs = {
  update?: InputMaybe<StreamingAbsenceUpdateInput>;
  where?: InputMaybe<StreamingAbsenceWhere>;
};


export type MutationUpdateTagsArgs = {
  update?: InputMaybe<TagUpdateInput>;
  where?: InputMaybe<TagWhere>;
};


export type MutationUpdateUserAppkeysArgs = {
  update?: InputMaybe<UserAppkeyUpdateInput>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type MutationUpdateUserPasskeysArgs = {
  update?: InputMaybe<UserPasskeyUpdateInput>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type MutationUpdateUsersArgs = {
  update?: InputMaybe<UserUpdateInput>;
  where?: InputMaybe<UserWhere>;
};


export type MutationVoteOnPollArgs = {
  optionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
};

export type OurSocialLink = {
  __typename?: 'OurSocialLink';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: SocialType;
  weight: Scalars['Int']['output'];
};

export type OurSocialLinkAggregateSelection = {
  __typename?: 'OurSocialLinkAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelection;
  link: StringAggregateSelection;
  weight: IntAggregateSelection;
};

export type OurSocialLinkCreateInput = {
  link: Scalars['String']['input'];
  type: SocialType;
  weight: Scalars['Int']['input'];
};

export type OurSocialLinkEdge = {
  __typename?: 'OurSocialLinkEdge';
  cursor: Scalars['String']['output'];
  node: OurSocialLink;
};

export type OurSocialLinkOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OurSocialLinkSort objects to sort OurSocialLinks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OurSocialLinkSort>>;
};

/** Fields to sort OurSocialLinks by. The order in which sorts are applied is not guaranteed when specifying many fields in one OurSocialLinkSort object. */
export type OurSocialLinkSort = {
  id?: InputMaybe<SortDirection>;
  link?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  weight?: InputMaybe<SortDirection>;
};

export type OurSocialLinkUpdateInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SocialType>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type OurSocialLinkWhere = {
  AND?: InputMaybe<Array<OurSocialLinkWhere>>;
  NOT?: InputMaybe<OurSocialLinkWhere>;
  OR?: InputMaybe<Array<OurSocialLinkWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  link_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  link_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SocialType>;
  type_IN?: InputMaybe<Array<SocialType>>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  weight_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OurSocialLinksConnection = {
  __typename?: 'OurSocialLinksConnection';
  edges: Array<OurSocialLinkEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  picture: File;
  pictureAggregate?: Maybe<PartnerFilePictureAggregationSelection>;
  pictureConnection: PartnerPictureConnection;
  title: Scalars['String']['output'];
  type: PartnerType;
};


export type PartnerPictureArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type PartnerPictureAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type PartnerPictureConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartnerPictureConnectionSort>>;
  where?: InputMaybe<PartnerPictureConnectionWhere>;
};

export type PartnerAggregateSelection = {
  __typename?: 'PartnerAggregateSelection';
  count: Scalars['Int']['output'];
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  link: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type PartnerConnectInput = {
  picture?: InputMaybe<PartnerPictureConnectFieldInput>;
};

export type PartnerConnectOrCreateInput = {
  picture?: InputMaybe<PartnerPictureConnectOrCreateFieldInput>;
};

export type PartnerCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  link: Scalars['String']['input'];
  picture?: InputMaybe<PartnerPictureFieldInput>;
  title: Scalars['String']['input'];
  type: PartnerType;
};

export type PartnerDeleteInput = {
  picture?: InputMaybe<PartnerPictureDeleteFieldInput>;
};

export type PartnerDisconnectInput = {
  picture?: InputMaybe<PartnerPictureDisconnectFieldInput>;
};

export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  cursor: Scalars['String']['output'];
  node: Partner;
};

export type PartnerFilePictureAggregationSelection = {
  __typename?: 'PartnerFilePictureAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PartnerFilePictureNodeAggregateSelection>;
};

export type PartnerFilePictureNodeAggregateSelection = {
  __typename?: 'PartnerFilePictureNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type PartnerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PartnerSort objects to sort Partners by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PartnerSort>>;
};

export type PartnerPictureAggregateInput = {
  AND?: InputMaybe<Array<PartnerPictureAggregateInput>>;
  NOT?: InputMaybe<PartnerPictureAggregateInput>;
  OR?: InputMaybe<Array<PartnerPictureAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PartnerPictureNodeAggregationWhereInput>;
};

export type PartnerPictureConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type PartnerPictureConnectOrCreateFieldInput = {
  onCreate: PartnerPictureConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type PartnerPictureConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type PartnerPictureConnection = {
  __typename?: 'PartnerPictureConnection';
  edges: Array<PartnerPictureRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartnerPictureConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type PartnerPictureConnectionWhere = {
  AND?: InputMaybe<Array<PartnerPictureConnectionWhere>>;
  NOT?: InputMaybe<PartnerPictureConnectionWhere>;
  OR?: InputMaybe<Array<PartnerPictureConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type PartnerPictureCreateFieldInput = {
  node: FileCreateInput;
};

export type PartnerPictureDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<PartnerPictureConnectionWhere>;
};

export type PartnerPictureDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<PartnerPictureConnectionWhere>;
};

export type PartnerPictureFieldInput = {
  connect?: InputMaybe<PartnerPictureConnectFieldInput>;
  connectOrCreate?: InputMaybe<PartnerPictureConnectOrCreateFieldInput>;
  create?: InputMaybe<PartnerPictureCreateFieldInput>;
};

export type PartnerPictureNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartnerPictureNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PartnerPictureNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PartnerPictureNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerPictureRelationship = {
  __typename?: 'PartnerPictureRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type PartnerPictureUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type PartnerPictureUpdateFieldInput = {
  connect?: InputMaybe<PartnerPictureConnectFieldInput>;
  connectOrCreate?: InputMaybe<PartnerPictureConnectOrCreateFieldInput>;
  create?: InputMaybe<PartnerPictureCreateFieldInput>;
  delete?: InputMaybe<PartnerPictureDeleteFieldInput>;
  disconnect?: InputMaybe<PartnerPictureDisconnectFieldInput>;
  update?: InputMaybe<PartnerPictureUpdateConnectionInput>;
  where?: InputMaybe<PartnerPictureConnectionWhere>;
};

export type PartnerRelationInput = {
  picture?: InputMaybe<PartnerPictureCreateFieldInput>;
};

/** Fields to sort Partners by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartnerSort object. */
export type PartnerSort = {
  deletedAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  link?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum PartnerType {
  Live = 'LIVE',
  Normal = 'NORMAL',
  Top = 'TOP'
}

export type PartnerUpdateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PartnerPictureUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PartnerType>;
};

export type PartnerWhere = {
  AND?: InputMaybe<Array<PartnerWhere>>;
  NOT?: InputMaybe<PartnerWhere>;
  OR?: InputMaybe<Array<PartnerWhere>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  link_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  link_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<FileWhere>;
  pictureAggregate?: InputMaybe<PartnerPictureAggregateInput>;
  pictureConnection?: InputMaybe<PartnerPictureConnectionWhere>;
  pictureConnection_NOT?: InputMaybe<PartnerPictureConnectionWhere>;
  picture_NOT?: InputMaybe<FileWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PartnerType>;
  type_IN?: InputMaybe<Array<PartnerType>>;
};

export type PartnersConnection = {
  __typename?: 'PartnersConnection';
  edges: Array<PartnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Poll = {
  __typename?: 'Poll';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  options: Array<PollOption>;
  optionsAggregate?: Maybe<PollPollOptionOptionsAggregationSelection>;
  optionsConnection: PollOptionsConnection;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type PollOptionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PollOptionOptions>;
  where?: InputMaybe<PollOptionWhere>;
};


export type PollOptionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PollOptionWhere>;
};


export type PollOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PollOptionsConnectionSort>>;
  where?: InputMaybe<PollOptionsConnectionWhere>;
};

export type PollAggregateSelection = {
  __typename?: 'PollAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type PollConnectInput = {
  options?: InputMaybe<Array<PollOptionsConnectFieldInput>>;
};

export type PollConnectOrCreateInput = {
  options?: InputMaybe<Array<PollOptionsConnectOrCreateFieldInput>>;
};

export type PollCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isOpen: Scalars['Boolean']['input'];
  options?: InputMaybe<PollOptionsFieldInput>;
  title: Scalars['String']['input'];
};

export type PollDeleteInput = {
  options?: InputMaybe<Array<PollOptionsDeleteFieldInput>>;
};

export type PollDisconnectInput = {
  options?: InputMaybe<Array<PollOptionsDisconnectFieldInput>>;
};

export type PollEdge = {
  __typename?: 'PollEdge';
  cursor: Scalars['String']['output'];
  node: Poll;
};

export type PollOption = {
  __typename?: 'PollOption';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  votes: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type PollOptionConnectOrCreateWhere = {
  node: PollOptionUniqueWhere;
};

export type PollOptionConnectWhere = {
  node: PollOptionWhere;
};

export type PollOptionCreateInput = {
  title: Scalars['String']['input'];
  votes: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type PollOptionOnCreateInput = {
  title: Scalars['String']['input'];
  votes: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type PollOptionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PollOptionSort objects to sort PollOptions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PollOptionSort>>;
};

/** Fields to sort PollOptions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PollOptionSort object. */
export type PollOptionSort = {
  id?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  votes?: InputMaybe<SortDirection>;
  weight?: InputMaybe<SortDirection>;
};

export type PollOptionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PollOptionUpdateInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  votes?: InputMaybe<Scalars['Int']['input']>;
  votes_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  votes_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type PollOptionWhere = {
  AND?: InputMaybe<Array<PollOptionWhere>>;
  NOT?: InputMaybe<PollOptionWhere>;
  OR?: InputMaybe<Array<PollOptionWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  votes?: InputMaybe<Scalars['Int']['input']>;
  votes_GT?: InputMaybe<Scalars['Int']['input']>;
  votes_GTE?: InputMaybe<Scalars['Int']['input']>;
  votes_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  votes_LT?: InputMaybe<Scalars['Int']['input']>;
  votes_LTE?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  weight_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PollOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PollSort objects to sort Polls by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PollSort>>;
};

export type PollOptionsAggregateInput = {
  AND?: InputMaybe<Array<PollOptionsAggregateInput>>;
  NOT?: InputMaybe<PollOptionsAggregateInput>;
  OR?: InputMaybe<Array<PollOptionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PollOptionsNodeAggregationWhereInput>;
};

export type PollOptionsConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PollOptionConnectWhere>;
};

export type PollOptionsConnectOrCreateFieldInput = {
  onCreate: PollOptionsConnectOrCreateFieldInputOnCreate;
  where: PollOptionConnectOrCreateWhere;
};

export type PollOptionsConnectOrCreateFieldInputOnCreate = {
  node: PollOptionOnCreateInput;
};

export type PollOptionsConnection = {
  __typename?: 'PollOptionsConnection';
  edges: Array<PollOptionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PollOptionsConnectionSort = {
  node?: InputMaybe<PollOptionSort>;
};

export type PollOptionsConnectionWhere = {
  AND?: InputMaybe<Array<PollOptionsConnectionWhere>>;
  NOT?: InputMaybe<PollOptionsConnectionWhere>;
  OR?: InputMaybe<Array<PollOptionsConnectionWhere>>;
  node?: InputMaybe<PollOptionWhere>;
};

export type PollOptionsCreateFieldInput = {
  node: PollOptionCreateInput;
};

export type PollOptionsDeleteFieldInput = {
  where?: InputMaybe<PollOptionsConnectionWhere>;
};

export type PollOptionsDisconnectFieldInput = {
  where?: InputMaybe<PollOptionsConnectionWhere>;
};

export type PollOptionsFieldInput = {
  connect?: InputMaybe<Array<PollOptionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PollOptionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PollOptionsCreateFieldInput>>;
};

export type PollOptionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PollOptionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PollOptionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PollOptionsNodeAggregationWhereInput>>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  votes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  votes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  votes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  votes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  votes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  votes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  votes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  votes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  votes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  votes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  votes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  votes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  votes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  votes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  votes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  votes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  votes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  votes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  votes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  votes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  weight_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weight_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  weight_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weight_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  weight_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weight_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PollOptionsRelationship = {
  __typename?: 'PollOptionsRelationship';
  cursor: Scalars['String']['output'];
  node: PollOption;
};

export type PollOptionsUpdateConnectionInput = {
  node?: InputMaybe<PollOptionUpdateInput>;
};

export type PollOptionsUpdateFieldInput = {
  connect?: InputMaybe<Array<PollOptionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PollOptionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PollOptionsCreateFieldInput>>;
  delete?: InputMaybe<Array<PollOptionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PollOptionsDisconnectFieldInput>>;
  update?: InputMaybe<PollOptionsUpdateConnectionInput>;
  where?: InputMaybe<PollOptionsConnectionWhere>;
};

export type PollPollOptionOptionsAggregationSelection = {
  __typename?: 'PollPollOptionOptionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PollPollOptionOptionsNodeAggregateSelection>;
};

export type PollPollOptionOptionsNodeAggregateSelection = {
  __typename?: 'PollPollOptionOptionsNodeAggregateSelection';
  id: IdAggregateSelection;
  title: StringAggregateSelection;
  votes: IntAggregateSelection;
  weight: IntAggregateSelection;
};

export type PollRelationInput = {
  options?: InputMaybe<Array<PollOptionsCreateFieldInput>>;
};

/** Fields to sort Polls by. The order in which sorts are applied is not guaranteed when specifying many fields in one PollSort object. */
export type PollSort = {
  createdAt?: InputMaybe<SortDirection>;
  deletedAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isOpen?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type PollUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<PollOptionsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PollWhere = {
  AND?: InputMaybe<Array<PollWhere>>;
  NOT?: InputMaybe<PollWhere>;
  OR?: InputMaybe<Array<PollWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  optionsAggregate?: InputMaybe<PollOptionsAggregateInput>;
  /** Return Polls where all of the related PollOptionsConnections match this filter */
  optionsConnection_ALL?: InputMaybe<PollOptionsConnectionWhere>;
  /** Return Polls where none of the related PollOptionsConnections match this filter */
  optionsConnection_NONE?: InputMaybe<PollOptionsConnectionWhere>;
  /** Return Polls where one of the related PollOptionsConnections match this filter */
  optionsConnection_SINGLE?: InputMaybe<PollOptionsConnectionWhere>;
  /** Return Polls where some of the related PollOptionsConnections match this filter */
  optionsConnection_SOME?: InputMaybe<PollOptionsConnectionWhere>;
  /** Return Polls where all of the related PollOptions match this filter */
  options_ALL?: InputMaybe<PollOptionWhere>;
  /** Return Polls where none of the related PollOptions match this filter */
  options_NONE?: InputMaybe<PollOptionWhere>;
  /** Return Polls where one of the related PollOptions match this filter */
  options_SINGLE?: InputMaybe<PollOptionWhere>;
  /** Return Polls where some of the related PollOptions match this filter */
  options_SOME?: InputMaybe<PollOptionWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PollsConnection = {
  __typename?: 'PollsConnection';
  edges: Array<PollEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Post = {
  __typename?: 'Post';
  attachments: Array<File>;
  attachmentsAggregate?: Maybe<PostFileAttachmentsAggregationSelection>;
  attachmentsConnection: PostAttachmentsConnection;
  author: User;
  authorAggregate?: Maybe<PostUserAuthorAggregationSelection>;
  authorConnection: PostAuthorConnection;
  category?: Maybe<Category>;
  categoryAggregate?: Maybe<PostCategoryCategoryAggregationSelection>;
  categoryConnection: PostCategoryConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasPendingModifications: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  oldId?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related: Array<Post>;
  relatedAggregate?: Maybe<PostPostRelatedAggregationSelection>;
  relatedConnection: PostRelatedConnection;
  revisions: Array<PostRevision>;
  revisionsAggregate?: Maybe<PostPostRevisionRevisionsAggregationSelection>;
  revisionsConnection: PostRevisionsConnection;
  slug?: Maybe<Scalars['String']['output']>;
  status: PostStatus;
  sticky: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: PostType;
  updatedAt: Scalars['DateTime']['output'];
  views: Scalars['Int']['output'];
  words: Array<PostWord>;
  wordsAggregate?: Maybe<PostPostWordWordsAggregationSelection>;
  wordsConnection: PostWordsConnection;
};


export type PostAttachmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type PostAttachmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type PostAttachmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAttachmentsConnectionSort>>;
  where?: InputMaybe<PostAttachmentsConnectionWhere>;
};


export type PostAuthorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostAuthorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostAuthorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAuthorConnectionSort>>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};


export type PostCategoryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostCategoryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostCategoryConnectionSort>>;
  where?: InputMaybe<PostCategoryConnectionWhere>;
};


export type PostRelatedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type PostRelatedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type PostRelatedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRelatedConnectionSort>>;
  where?: InputMaybe<PostRelatedConnectionWhere>;
};


export type PostRevisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostRevisionOptions>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type PostRevisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type PostRevisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionsConnectionSort>>;
  where?: InputMaybe<PostRevisionsConnectionWhere>;
};


export type PostWordsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostWordOptions>;
  where?: InputMaybe<PostWordWhere>;
};


export type PostWordsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWordWhere>;
};


export type PostWordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostWordsConnectionSort>>;
  where?: InputMaybe<PostWordsConnectionWhere>;
};

export type PostAbsence = {
  __typename?: 'PostAbsence';
  category: Category;
  categoryAggregate?: Maybe<PostAbsenceCategoryCategoryAggregationSelection>;
  categoryConnection: PostAbsenceCategoryConnection;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<PostAbsenceUserCreatedByAggregationSelection>;
  createdByConnection: PostAbsenceCreatedByConnection;
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  justification?: Maybe<Scalars['String']['output']>;
  user: User;
  userAggregate?: Maybe<PostAbsenceUserUserAggregationSelection>;
  userConnection: PostAbsenceUserConnection;
};


export type PostAbsenceCategoryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostAbsenceCategoryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostAbsenceCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAbsenceCategoryConnectionSort>>;
  where?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
};


export type PostAbsenceCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostAbsenceCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostAbsenceCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAbsenceCreatedByConnectionSort>>;
  where?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
};


export type PostAbsenceUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostAbsenceUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostAbsenceUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAbsenceUserConnectionSort>>;
  where?: InputMaybe<PostAbsenceUserConnectionWhere>;
};

export type PostAbsenceAggregateSelection = {
  __typename?: 'PostAbsenceAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  justification: StringAggregateSelection;
};

export type PostAbsenceCategoryAggregateInput = {
  AND?: InputMaybe<Array<PostAbsenceCategoryAggregateInput>>;
  NOT?: InputMaybe<PostAbsenceCategoryAggregateInput>;
  OR?: InputMaybe<Array<PostAbsenceCategoryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAbsenceCategoryNodeAggregationWhereInput>;
};

export type PostAbsenceCategoryCategoryAggregationSelection = {
  __typename?: 'PostAbsenceCategoryCategoryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostAbsenceCategoryCategoryNodeAggregateSelection>;
};

export type PostAbsenceCategoryCategoryNodeAggregateSelection = {
  __typename?: 'PostAbsenceCategoryCategoryNodeAggregateSelection';
  body: StringAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type PostAbsenceCategoryConnectFieldInput = {
  connect?: InputMaybe<CategoryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CategoryConnectWhere>;
};

export type PostAbsenceCategoryConnectOrCreateFieldInput = {
  onCreate: PostAbsenceCategoryConnectOrCreateFieldInputOnCreate;
  where: CategoryConnectOrCreateWhere;
};

export type PostAbsenceCategoryConnectOrCreateFieldInputOnCreate = {
  node: CategoryOnCreateInput;
};

export type PostAbsenceCategoryConnection = {
  __typename?: 'PostAbsenceCategoryConnection';
  edges: Array<PostAbsenceCategoryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAbsenceCategoryConnectionSort = {
  node?: InputMaybe<CategorySort>;
};

export type PostAbsenceCategoryConnectionWhere = {
  AND?: InputMaybe<Array<PostAbsenceCategoryConnectionWhere>>;
  NOT?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
  OR?: InputMaybe<Array<PostAbsenceCategoryConnectionWhere>>;
  node?: InputMaybe<CategoryWhere>;
};

export type PostAbsenceCategoryCreateFieldInput = {
  node: CategoryCreateInput;
};

export type PostAbsenceCategoryDeleteFieldInput = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
};

export type PostAbsenceCategoryDisconnectFieldInput = {
  disconnect?: InputMaybe<CategoryDisconnectInput>;
  where?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
};

export type PostAbsenceCategoryFieldInput = {
  connect?: InputMaybe<PostAbsenceCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceCategoryCreateFieldInput>;
};

export type PostAbsenceCategoryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAbsenceCategoryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAbsenceCategoryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAbsenceCategoryNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAbsenceCategoryRelationship = {
  __typename?: 'PostAbsenceCategoryRelationship';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type PostAbsenceCategoryUpdateConnectionInput = {
  node?: InputMaybe<CategoryUpdateInput>;
};

export type PostAbsenceCategoryUpdateFieldInput = {
  connect?: InputMaybe<PostAbsenceCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceCategoryCreateFieldInput>;
  delete?: InputMaybe<PostAbsenceCategoryDeleteFieldInput>;
  disconnect?: InputMaybe<PostAbsenceCategoryDisconnectFieldInput>;
  update?: InputMaybe<PostAbsenceCategoryUpdateConnectionInput>;
  where?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
};

export type PostAbsenceConnectInput = {
  category?: InputMaybe<PostAbsenceCategoryConnectFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByConnectFieldInput>;
  user?: InputMaybe<PostAbsenceUserConnectFieldInput>;
};

export type PostAbsenceConnectOrCreateInput = {
  category?: InputMaybe<PostAbsenceCategoryConnectOrCreateFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByConnectOrCreateFieldInput>;
  user?: InputMaybe<PostAbsenceUserConnectOrCreateFieldInput>;
};

export type PostAbsenceCreateInput = {
  category?: InputMaybe<PostAbsenceCategoryFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByFieldInput>;
  date: Scalars['Date']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<PostAbsenceUserFieldInput>;
};

export type PostAbsenceCreatedByAggregateInput = {
  AND?: InputMaybe<Array<PostAbsenceCreatedByAggregateInput>>;
  NOT?: InputMaybe<PostAbsenceCreatedByAggregateInput>;
  OR?: InputMaybe<Array<PostAbsenceCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAbsenceCreatedByNodeAggregationWhereInput>;
};

export type PostAbsenceCreatedByConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostAbsenceCreatedByConnectOrCreateFieldInput = {
  onCreate: PostAbsenceCreatedByConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostAbsenceCreatedByConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostAbsenceCreatedByConnection = {
  __typename?: 'PostAbsenceCreatedByConnection';
  edges: Array<PostAbsenceCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAbsenceCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostAbsenceCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<PostAbsenceCreatedByConnectionWhere>>;
  NOT?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<PostAbsenceCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostAbsenceCreatedByCreateFieldInput = {
  node: UserCreateInput;
};

export type PostAbsenceCreatedByDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
};

export type PostAbsenceCreatedByDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
};

export type PostAbsenceCreatedByFieldInput = {
  connect?: InputMaybe<PostAbsenceCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceCreatedByCreateFieldInput>;
};

export type PostAbsenceCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAbsenceCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAbsenceCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAbsenceCreatedByNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAbsenceCreatedByRelationship = {
  __typename?: 'PostAbsenceCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostAbsenceCreatedByUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostAbsenceCreatedByUpdateFieldInput = {
  connect?: InputMaybe<PostAbsenceCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceCreatedByCreateFieldInput>;
  delete?: InputMaybe<PostAbsenceCreatedByDeleteFieldInput>;
  disconnect?: InputMaybe<PostAbsenceCreatedByDisconnectFieldInput>;
  update?: InputMaybe<PostAbsenceCreatedByUpdateConnectionInput>;
  where?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
};

export type PostAbsenceDeleteInput = {
  category?: InputMaybe<PostAbsenceCategoryDeleteFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByDeleteFieldInput>;
  user?: InputMaybe<PostAbsenceUserDeleteFieldInput>;
};

export type PostAbsenceDisconnectInput = {
  category?: InputMaybe<PostAbsenceCategoryDisconnectFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByDisconnectFieldInput>;
  user?: InputMaybe<PostAbsenceUserDisconnectFieldInput>;
};

export type PostAbsenceEdge = {
  __typename?: 'PostAbsenceEdge';
  cursor: Scalars['String']['output'];
  node: PostAbsence;
};

export type PostAbsenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostAbsenceSort objects to sort PostAbsences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostAbsenceSort>>;
};

export type PostAbsenceRelationInput = {
  category?: InputMaybe<PostAbsenceCategoryCreateFieldInput>;
  createdBy?: InputMaybe<PostAbsenceCreatedByCreateFieldInput>;
  user?: InputMaybe<PostAbsenceUserCreateFieldInput>;
};

/** Fields to sort PostAbsences by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostAbsenceSort object. */
export type PostAbsenceSort = {
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  justification?: InputMaybe<SortDirection>;
};

export type PostAbsenceUpdateInput = {
  category?: InputMaybe<PostAbsenceCategoryUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<PostAbsenceCreatedByUpdateFieldInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<PostAbsenceUserUpdateFieldInput>;
};

export type PostAbsenceUserAggregateInput = {
  AND?: InputMaybe<Array<PostAbsenceUserAggregateInput>>;
  NOT?: InputMaybe<PostAbsenceUserAggregateInput>;
  OR?: InputMaybe<Array<PostAbsenceUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAbsenceUserNodeAggregationWhereInput>;
};

export type PostAbsenceUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostAbsenceUserConnectOrCreateFieldInput = {
  onCreate: PostAbsenceUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostAbsenceUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostAbsenceUserConnection = {
  __typename?: 'PostAbsenceUserConnection';
  edges: Array<PostAbsenceUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAbsenceUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostAbsenceUserConnectionWhere = {
  AND?: InputMaybe<Array<PostAbsenceUserConnectionWhere>>;
  NOT?: InputMaybe<PostAbsenceUserConnectionWhere>;
  OR?: InputMaybe<Array<PostAbsenceUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostAbsenceUserCreateFieldInput = {
  node: UserCreateInput;
};

export type PostAbsenceUserCreatedByAggregationSelection = {
  __typename?: 'PostAbsenceUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostAbsenceUserCreatedByNodeAggregateSelection>;
};

export type PostAbsenceUserCreatedByNodeAggregateSelection = {
  __typename?: 'PostAbsenceUserCreatedByNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type PostAbsenceUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostAbsenceUserConnectionWhere>;
};

export type PostAbsenceUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostAbsenceUserConnectionWhere>;
};

export type PostAbsenceUserFieldInput = {
  connect?: InputMaybe<PostAbsenceUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceUserConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceUserCreateFieldInput>;
};

export type PostAbsenceUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAbsenceUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAbsenceUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAbsenceUserNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAbsenceUserRelationship = {
  __typename?: 'PostAbsenceUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostAbsenceUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostAbsenceUserUpdateFieldInput = {
  connect?: InputMaybe<PostAbsenceUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAbsenceUserConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAbsenceUserCreateFieldInput>;
  delete?: InputMaybe<PostAbsenceUserDeleteFieldInput>;
  disconnect?: InputMaybe<PostAbsenceUserDisconnectFieldInput>;
  update?: InputMaybe<PostAbsenceUserUpdateConnectionInput>;
  where?: InputMaybe<PostAbsenceUserConnectionWhere>;
};

export type PostAbsenceUserUserAggregationSelection = {
  __typename?: 'PostAbsenceUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostAbsenceUserUserNodeAggregateSelection>;
};

export type PostAbsenceUserUserNodeAggregateSelection = {
  __typename?: 'PostAbsenceUserUserNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type PostAbsenceWhere = {
  AND?: InputMaybe<Array<PostAbsenceWhere>>;
  NOT?: InputMaybe<PostAbsenceWhere>;
  OR?: InputMaybe<Array<PostAbsenceWhere>>;
  category?: InputMaybe<CategoryWhere>;
  categoryAggregate?: InputMaybe<PostAbsenceCategoryAggregateInput>;
  categoryConnection?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
  categoryConnection_NOT?: InputMaybe<PostAbsenceCategoryConnectionWhere>;
  category_NOT?: InputMaybe<CategoryWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<PostAbsenceCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<PostAbsenceCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  justification_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  justification_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  justification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  justification_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<PostAbsenceUserAggregateInput>;
  userConnection?: InputMaybe<PostAbsenceUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<PostAbsenceUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type PostAbsencesConnection = {
  __typename?: 'PostAbsencesConnection';
  edges: Array<PostAbsenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAggregateSelection = {
  __typename?: 'PostAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type PostAttachmentsAggregateInput = {
  AND?: InputMaybe<Array<PostAttachmentsAggregateInput>>;
  NOT?: InputMaybe<PostAttachmentsAggregateInput>;
  OR?: InputMaybe<Array<PostAttachmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAttachmentsNodeAggregationWhereInput>;
};

export type PostAttachmentsConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type PostAttachmentsConnectOrCreateFieldInput = {
  onCreate: PostAttachmentsConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type PostAttachmentsConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type PostAttachmentsConnection = {
  __typename?: 'PostAttachmentsConnection';
  edges: Array<PostAttachmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAttachmentsConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type PostAttachmentsConnectionWhere = {
  AND?: InputMaybe<Array<PostAttachmentsConnectionWhere>>;
  NOT?: InputMaybe<PostAttachmentsConnectionWhere>;
  OR?: InputMaybe<Array<PostAttachmentsConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type PostAttachmentsCreateFieldInput = {
  node: FileCreateInput;
};

export type PostAttachmentsDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<PostAttachmentsConnectionWhere>;
};

export type PostAttachmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<PostAttachmentsConnectionWhere>;
};

export type PostAttachmentsFieldInput = {
  connect?: InputMaybe<Array<PostAttachmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostAttachmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostAttachmentsCreateFieldInput>>;
};

export type PostAttachmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAttachmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAttachmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAttachmentsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAttachmentsRelationship = {
  __typename?: 'PostAttachmentsRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type PostAttachmentsUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type PostAttachmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<PostAttachmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostAttachmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostAttachmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<PostAttachmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostAttachmentsDisconnectFieldInput>>;
  update?: InputMaybe<PostAttachmentsUpdateConnectionInput>;
  where?: InputMaybe<PostAttachmentsConnectionWhere>;
};

export type PostAuthorAggregateInput = {
  AND?: InputMaybe<Array<PostAuthorAggregateInput>>;
  NOT?: InputMaybe<PostAuthorAggregateInput>;
  OR?: InputMaybe<Array<PostAuthorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAuthorNodeAggregationWhereInput>;
};

export type PostAuthorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostAuthorConnectOrCreateFieldInput = {
  onCreate: PostAuthorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostAuthorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostAuthorConnection = {
  __typename?: 'PostAuthorConnection';
  edges: Array<PostAuthorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAuthorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostAuthorConnectionWhere = {
  AND?: InputMaybe<Array<PostAuthorConnectionWhere>>;
  NOT?: InputMaybe<PostAuthorConnectionWhere>;
  OR?: InputMaybe<Array<PostAuthorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostAuthorCreateFieldInput = {
  node: UserCreateInput;
};

export type PostAuthorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostAuthorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostAuthorFieldInput = {
  connect?: InputMaybe<PostAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAuthorCreateFieldInput>;
};

export type PostAuthorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAuthorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAuthorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAuthorNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAuthorRelationship = {
  __typename?: 'PostAuthorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostAuthorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostAuthorUpdateFieldInput = {
  connect?: InputMaybe<PostAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAuthorCreateFieldInput>;
  delete?: InputMaybe<PostAuthorDeleteFieldInput>;
  disconnect?: InputMaybe<PostAuthorDisconnectFieldInput>;
  update?: InputMaybe<PostAuthorUpdateConnectionInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostCategoryAggregateInput = {
  AND?: InputMaybe<Array<PostCategoryAggregateInput>>;
  NOT?: InputMaybe<PostCategoryAggregateInput>;
  OR?: InputMaybe<Array<PostCategoryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostCategoryNodeAggregationWhereInput>;
};

export type PostCategoryCategoryAggregationSelection = {
  __typename?: 'PostCategoryCategoryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostCategoryCategoryNodeAggregateSelection>;
};

export type PostCategoryCategoryNodeAggregateSelection = {
  __typename?: 'PostCategoryCategoryNodeAggregateSelection';
  body: StringAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type PostCategoryConnectFieldInput = {
  connect?: InputMaybe<CategoryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CategoryConnectWhere>;
};

export type PostCategoryConnectOrCreateFieldInput = {
  onCreate: PostCategoryConnectOrCreateFieldInputOnCreate;
  where: CategoryConnectOrCreateWhere;
};

export type PostCategoryConnectOrCreateFieldInputOnCreate = {
  node: CategoryOnCreateInput;
};

export type PostCategoryConnection = {
  __typename?: 'PostCategoryConnection';
  edges: Array<PostCategoryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostCategoryConnectionSort = {
  node?: InputMaybe<CategorySort>;
};

export type PostCategoryConnectionWhere = {
  AND?: InputMaybe<Array<PostCategoryConnectionWhere>>;
  NOT?: InputMaybe<PostCategoryConnectionWhere>;
  OR?: InputMaybe<Array<PostCategoryConnectionWhere>>;
  node?: InputMaybe<CategoryWhere>;
};

export type PostCategoryCreateFieldInput = {
  node: CategoryCreateInput;
};

export type PostCategoryDeleteFieldInput = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<PostCategoryConnectionWhere>;
};

export type PostCategoryDisconnectFieldInput = {
  disconnect?: InputMaybe<CategoryDisconnectInput>;
  where?: InputMaybe<PostCategoryConnectionWhere>;
};

export type PostCategoryFieldInput = {
  connect?: InputMaybe<PostCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostCategoryCreateFieldInput>;
};

export type PostCategoryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostCategoryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostCategoryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostCategoryNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostCategoryRelationship = {
  __typename?: 'PostCategoryRelationship';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type PostCategoryUpdateConnectionInput = {
  node?: InputMaybe<CategoryUpdateInput>;
};

export type PostCategoryUpdateFieldInput = {
  connect?: InputMaybe<PostCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostCategoryCreateFieldInput>;
  delete?: InputMaybe<PostCategoryDeleteFieldInput>;
  disconnect?: InputMaybe<PostCategoryDisconnectFieldInput>;
  update?: InputMaybe<PostCategoryUpdateConnectionInput>;
  where?: InputMaybe<PostCategoryConnectionWhere>;
};

export type PostConnectInput = {
  attachments?: InputMaybe<Array<PostAttachmentsConnectFieldInput>>;
  author?: InputMaybe<PostAuthorConnectFieldInput>;
  category?: InputMaybe<PostCategoryConnectFieldInput>;
  related?: InputMaybe<Array<PostRelatedConnectFieldInput>>;
  revisions?: InputMaybe<Array<PostRevisionsConnectFieldInput>>;
  words?: InputMaybe<Array<PostWordsConnectFieldInput>>;
};

export type PostConnectOrCreateWhere = {
  node: PostUniqueWhere;
};

export type PostConnectWhere = {
  node: PostWhere;
};

export type PostCreateInput = {
  attachments?: InputMaybe<PostAttachmentsFieldInput>;
  author?: InputMaybe<PostAuthorFieldInput>;
  category?: InputMaybe<PostCategoryFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  related?: InputMaybe<PostRelatedFieldInput>;
  revisions?: InputMaybe<PostRevisionsFieldInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: PostStatus;
  sticky: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: PostType;
  views?: Scalars['Int']['input'];
  words?: InputMaybe<PostWordsFieldInput>;
};

export type PostDeleteInput = {
  attachments?: InputMaybe<Array<PostAttachmentsDeleteFieldInput>>;
  author?: InputMaybe<PostAuthorDeleteFieldInput>;
  category?: InputMaybe<PostCategoryDeleteFieldInput>;
  related?: InputMaybe<Array<PostRelatedDeleteFieldInput>>;
  revisions?: InputMaybe<Array<PostRevisionsDeleteFieldInput>>;
  words?: InputMaybe<Array<PostWordsDeleteFieldInput>>;
};

export type PostDisconnectInput = {
  attachments?: InputMaybe<Array<PostAttachmentsDisconnectFieldInput>>;
  author?: InputMaybe<PostAuthorDisconnectFieldInput>;
  category?: InputMaybe<PostCategoryDisconnectFieldInput>;
  related?: InputMaybe<Array<PostRelatedDisconnectFieldInput>>;
  revisions?: InputMaybe<Array<PostRevisionsDisconnectFieldInput>>;
  words?: InputMaybe<Array<PostWordsDisconnectFieldInput>>;
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostFileAttachmentsAggregationSelection = {
  __typename?: 'PostFileAttachmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostFileAttachmentsNodeAggregateSelection>;
};

export type PostFileAttachmentsNodeAggregateSelection = {
  __typename?: 'PostFileAttachmentsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type PostInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  coverAttribution?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink?: InputMaybe<Scalars['String']['input']>;
  coverId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  lead?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostOnCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: PostStatus;
  sticky: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: PostType;
  views?: Scalars['Int']['input'];
};

export type PostOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostSort objects to sort Posts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostSort>>;
};

export type PostPostRelatedAggregationSelection = {
  __typename?: 'PostPostRelatedAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostPostRelatedNodeAggregateSelection>;
};

export type PostPostRelatedNodeAggregateSelection = {
  __typename?: 'PostPostRelatedNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type PostPostRevisionRevisionsAggregationSelection = {
  __typename?: 'PostPostRevisionRevisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostPostRevisionRevisionsNodeAggregateSelection>;
};

export type PostPostRevisionRevisionsNodeAggregateSelection = {
  __typename?: 'PostPostRevisionRevisionsNodeAggregateSelection';
  body: StringAggregateSelection;
  coverAttribution: StringAggregateSelection;
  coverAttributionLink: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lead: StringAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type PostPostWordWordsAggregationSelection = {
  __typename?: 'PostPostWordWordsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostPostWordWordsNodeAggregateSelection>;
};

export type PostPostWordWordsNodeAggregateSelection = {
  __typename?: 'PostPostWordWordsNodeAggregateSelection';
  weight: FloatAggregateSelection;
  word: StringAggregateSelection;
};

export type PostRelatedAggregateInput = {
  AND?: InputMaybe<Array<PostRelatedAggregateInput>>;
  NOT?: InputMaybe<PostRelatedAggregateInput>;
  OR?: InputMaybe<Array<PostRelatedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRelatedNodeAggregationWhereInput>;
};

export type PostRelatedConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type PostRelatedConnectOrCreateFieldInput = {
  onCreate: PostRelatedConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type PostRelatedConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type PostRelatedConnection = {
  __typename?: 'PostRelatedConnection';
  edges: Array<PostRelatedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRelatedConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type PostRelatedConnectionWhere = {
  AND?: InputMaybe<Array<PostRelatedConnectionWhere>>;
  NOT?: InputMaybe<PostRelatedConnectionWhere>;
  OR?: InputMaybe<Array<PostRelatedConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type PostRelatedCreateFieldInput = {
  node: PostCreateInput;
};

export type PostRelatedDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<PostRelatedConnectionWhere>;
};

export type PostRelatedDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<PostRelatedConnectionWhere>;
};

export type PostRelatedFieldInput = {
  connect?: InputMaybe<Array<PostRelatedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRelatedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRelatedCreateFieldInput>>;
};

export type PostRelatedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRelatedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRelatedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRelatedNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  oldId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRelatedRelationship = {
  __typename?: 'PostRelatedRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostRelatedUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type PostRelatedUpdateFieldInput = {
  connect?: InputMaybe<Array<PostRelatedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRelatedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRelatedCreateFieldInput>>;
  delete?: InputMaybe<Array<PostRelatedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostRelatedDisconnectFieldInput>>;
  update?: InputMaybe<PostRelatedUpdateConnectionInput>;
  where?: InputMaybe<PostRelatedConnectionWhere>;
};

export type PostRevision = {
  __typename?: 'PostRevision';
  author: User;
  authorAggregate?: Maybe<PostRevisionUserAuthorAggregationSelection>;
  authorConnection: PostRevisionAuthorConnection;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  categoryAggregate?: Maybe<PostRevisionCategoryCategoryAggregationSelection>;
  categoryConnection: PostRevisionCategoryConnection;
  cover?: Maybe<File>;
  coverAggregate?: Maybe<PostRevisionFileCoverAggregationSelection>;
  coverAttribution?: Maybe<Scalars['String']['output']>;
  coverAttributionLink?: Maybe<Scalars['String']['output']>;
  coverConnection: PostRevisionCoverConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lead?: Maybe<Scalars['String']['output']>;
  post: Post;
  postAggregate?: Maybe<PostRevisionPostPostAggregationSelection>;
  postConnection: PostRevisionPostConnection;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sticky: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  tagsAggregate?: Maybe<PostRevisionTagTagsAggregationSelection>;
  tagsConnection: PostRevisionTagsConnection;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PostRevisionAuthorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostRevisionAuthorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostRevisionAuthorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionAuthorConnectionSort>>;
  where?: InputMaybe<PostRevisionAuthorConnectionWhere>;
};


export type PostRevisionCategoryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostRevisionCategoryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostRevisionCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionCategoryConnectionSort>>;
  where?: InputMaybe<PostRevisionCategoryConnectionWhere>;
};


export type PostRevisionCoverArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type PostRevisionCoverAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type PostRevisionCoverConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionCoverConnectionSort>>;
  where?: InputMaybe<PostRevisionCoverConnectionWhere>;
};


export type PostRevisionPostArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type PostRevisionPostAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type PostRevisionPostConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionPostConnectionSort>>;
  where?: InputMaybe<PostRevisionPostConnectionWhere>;
};


export type PostRevisionTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TagOptions>;
  where?: InputMaybe<TagWhere>;
};


export type PostRevisionTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TagWhere>;
};


export type PostRevisionTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRevisionTagsConnectionSort>>;
  where?: InputMaybe<PostRevisionTagsConnectionWhere>;
};

export type PostRevisionAuthorAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionAuthorAggregateInput>>;
  NOT?: InputMaybe<PostRevisionAuthorAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionAuthorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionAuthorNodeAggregationWhereInput>;
};

export type PostRevisionAuthorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostRevisionAuthorConnectOrCreateFieldInput = {
  onCreate: PostRevisionAuthorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostRevisionAuthorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostRevisionAuthorConnection = {
  __typename?: 'PostRevisionAuthorConnection';
  edges: Array<PostRevisionAuthorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionAuthorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostRevisionAuthorConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionAuthorConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionAuthorConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionAuthorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostRevisionAuthorCreateFieldInput = {
  node: UserCreateInput;
};

export type PostRevisionAuthorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostRevisionAuthorConnectionWhere>;
};

export type PostRevisionAuthorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostRevisionAuthorConnectionWhere>;
};

export type PostRevisionAuthorFieldInput = {
  connect?: InputMaybe<PostRevisionAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionAuthorCreateFieldInput>;
};

export type PostRevisionAuthorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionAuthorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionAuthorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionAuthorNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRevisionAuthorRelationship = {
  __typename?: 'PostRevisionAuthorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostRevisionAuthorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostRevisionAuthorUpdateFieldInput = {
  connect?: InputMaybe<PostRevisionAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionAuthorCreateFieldInput>;
  delete?: InputMaybe<PostRevisionAuthorDeleteFieldInput>;
  disconnect?: InputMaybe<PostRevisionAuthorDisconnectFieldInput>;
  update?: InputMaybe<PostRevisionAuthorUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionAuthorConnectionWhere>;
};

export type PostRevisionCategoryAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionCategoryAggregateInput>>;
  NOT?: InputMaybe<PostRevisionCategoryAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionCategoryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionCategoryNodeAggregationWhereInput>;
};

export type PostRevisionCategoryCategoryAggregationSelection = {
  __typename?: 'PostRevisionCategoryCategoryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostRevisionCategoryCategoryNodeAggregateSelection>;
};

export type PostRevisionCategoryCategoryNodeAggregateSelection = {
  __typename?: 'PostRevisionCategoryCategoryNodeAggregateSelection';
  body: StringAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type PostRevisionCategoryConnectFieldInput = {
  connect?: InputMaybe<CategoryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CategoryConnectWhere>;
};

export type PostRevisionCategoryConnectOrCreateFieldInput = {
  onCreate: PostRevisionCategoryConnectOrCreateFieldInputOnCreate;
  where: CategoryConnectOrCreateWhere;
};

export type PostRevisionCategoryConnectOrCreateFieldInputOnCreate = {
  node: CategoryOnCreateInput;
};

export type PostRevisionCategoryConnection = {
  __typename?: 'PostRevisionCategoryConnection';
  edges: Array<PostRevisionCategoryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionCategoryConnectionSort = {
  node?: InputMaybe<CategorySort>;
};

export type PostRevisionCategoryConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionCategoryConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionCategoryConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionCategoryConnectionWhere>>;
  node?: InputMaybe<CategoryWhere>;
};

export type PostRevisionCategoryCreateFieldInput = {
  node: CategoryCreateInput;
};

export type PostRevisionCategoryDeleteFieldInput = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<PostRevisionCategoryConnectionWhere>;
};

export type PostRevisionCategoryDisconnectFieldInput = {
  disconnect?: InputMaybe<CategoryDisconnectInput>;
  where?: InputMaybe<PostRevisionCategoryConnectionWhere>;
};

export type PostRevisionCategoryFieldInput = {
  connect?: InputMaybe<PostRevisionCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionCategoryCreateFieldInput>;
};

export type PostRevisionCategoryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionCategoryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionCategoryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionCategoryNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRevisionCategoryRelationship = {
  __typename?: 'PostRevisionCategoryRelationship';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type PostRevisionCategoryUpdateConnectionInput = {
  node?: InputMaybe<CategoryUpdateInput>;
};

export type PostRevisionCategoryUpdateFieldInput = {
  connect?: InputMaybe<PostRevisionCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionCategoryCreateFieldInput>;
  delete?: InputMaybe<PostRevisionCategoryDeleteFieldInput>;
  disconnect?: InputMaybe<PostRevisionCategoryDisconnectFieldInput>;
  update?: InputMaybe<PostRevisionCategoryUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionCategoryConnectionWhere>;
};

export type PostRevisionConnectInput = {
  author?: InputMaybe<PostRevisionAuthorConnectFieldInput>;
  category?: InputMaybe<PostRevisionCategoryConnectFieldInput>;
  cover?: InputMaybe<PostRevisionCoverConnectFieldInput>;
  post?: InputMaybe<PostRevisionPostConnectFieldInput>;
  tags?: InputMaybe<Array<PostRevisionTagsConnectFieldInput>>;
};

export type PostRevisionConnectOrCreateWhere = {
  node: PostRevisionUniqueWhere;
};

export type PostRevisionConnectWhere = {
  node: PostRevisionWhere;
};

export type PostRevisionCoverAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionCoverAggregateInput>>;
  NOT?: InputMaybe<PostRevisionCoverAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionCoverAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionCoverNodeAggregationWhereInput>;
};

export type PostRevisionCoverConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type PostRevisionCoverConnectOrCreateFieldInput = {
  onCreate: PostRevisionCoverConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type PostRevisionCoverConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type PostRevisionCoverConnection = {
  __typename?: 'PostRevisionCoverConnection';
  edges: Array<PostRevisionCoverRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionCoverConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type PostRevisionCoverConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionCoverConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionCoverConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionCoverConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type PostRevisionCoverCreateFieldInput = {
  node: FileCreateInput;
};

export type PostRevisionCoverDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<PostRevisionCoverConnectionWhere>;
};

export type PostRevisionCoverDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<PostRevisionCoverConnectionWhere>;
};

export type PostRevisionCoverFieldInput = {
  connect?: InputMaybe<PostRevisionCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionCoverCreateFieldInput>;
};

export type PostRevisionCoverNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionCoverNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionCoverNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionCoverNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRevisionCoverRelationship = {
  __typename?: 'PostRevisionCoverRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type PostRevisionCoverUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type PostRevisionCoverUpdateFieldInput = {
  connect?: InputMaybe<PostRevisionCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionCoverCreateFieldInput>;
  delete?: InputMaybe<PostRevisionCoverDeleteFieldInput>;
  disconnect?: InputMaybe<PostRevisionCoverDisconnectFieldInput>;
  update?: InputMaybe<PostRevisionCoverUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionCoverConnectionWhere>;
};

export type PostRevisionCreateInput = {
  author?: InputMaybe<PostRevisionAuthorFieldInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<PostRevisionCategoryFieldInput>;
  cover?: InputMaybe<PostRevisionCoverFieldInput>;
  coverAttribution?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostRevisionPostFieldInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sticky: Scalars['Boolean']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<PostRevisionTagsFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostRevisionDeleteInput = {
  author?: InputMaybe<PostRevisionAuthorDeleteFieldInput>;
  category?: InputMaybe<PostRevisionCategoryDeleteFieldInput>;
  cover?: InputMaybe<PostRevisionCoverDeleteFieldInput>;
  post?: InputMaybe<PostRevisionPostDeleteFieldInput>;
  tags?: InputMaybe<Array<PostRevisionTagsDeleteFieldInput>>;
};

export type PostRevisionDisconnectInput = {
  author?: InputMaybe<PostRevisionAuthorDisconnectFieldInput>;
  category?: InputMaybe<PostRevisionCategoryDisconnectFieldInput>;
  cover?: InputMaybe<PostRevisionCoverDisconnectFieldInput>;
  post?: InputMaybe<PostRevisionPostDisconnectFieldInput>;
  tags?: InputMaybe<Array<PostRevisionTagsDisconnectFieldInput>>;
};

export type PostRevisionFileCoverAggregationSelection = {
  __typename?: 'PostRevisionFileCoverAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostRevisionFileCoverNodeAggregateSelection>;
};

export type PostRevisionFileCoverNodeAggregateSelection = {
  __typename?: 'PostRevisionFileCoverNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type PostRevisionOnCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  coverAttribution?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sticky: Scalars['Boolean']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostRevisionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostRevisionSort objects to sort PostRevisions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostRevisionSort>>;
};

export type PostRevisionPostAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionPostAggregateInput>>;
  NOT?: InputMaybe<PostRevisionPostAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionPostAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionPostNodeAggregationWhereInput>;
};

export type PostRevisionPostConnectFieldInput = {
  connect?: InputMaybe<PostConnectInput>;
  edge: IsRevisionOfCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type PostRevisionPostConnectOrCreateFieldInput = {
  onCreate: PostRevisionPostConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type PostRevisionPostConnectOrCreateFieldInputOnCreate = {
  edge: IsRevisionOfCreateInput;
  node: PostOnCreateInput;
};

export type PostRevisionPostConnection = {
  __typename?: 'PostRevisionPostConnection';
  edges: Array<PostRevisionPostRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionPostConnectionSort = {
  edge?: InputMaybe<IsRevisionOfSort>;
  node?: InputMaybe<PostSort>;
};

export type PostRevisionPostConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionPostConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionPostConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionPostConnectionWhere>>;
  edge?: InputMaybe<IsRevisionOfWhere>;
  node?: InputMaybe<PostWhere>;
};

export type PostRevisionPostCreateFieldInput = {
  edge: IsRevisionOfCreateInput;
  node: PostCreateInput;
};

export type PostRevisionPostDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<PostRevisionPostConnectionWhere>;
};

export type PostRevisionPostDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<PostRevisionPostConnectionWhere>;
};

export type PostRevisionPostFieldInput = {
  connect?: InputMaybe<PostRevisionPostConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionPostConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionPostCreateFieldInput>;
};

export type PostRevisionPostNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionPostNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionPostNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionPostNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  oldId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRevisionPostPostAggregationSelection = {
  __typename?: 'PostRevisionPostPostAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostRevisionPostPostNodeAggregateSelection>;
};

export type PostRevisionPostPostNodeAggregateSelection = {
  __typename?: 'PostRevisionPostPostNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type PostRevisionPostRelationship = {
  __typename?: 'PostRevisionPostRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
  properties: IsRevisionOf;
};

export type PostRevisionPostUpdateConnectionInput = {
  edge?: InputMaybe<IsRevisionOfUpdateInput>;
  node?: InputMaybe<PostUpdateInput>;
};

export type PostRevisionPostUpdateFieldInput = {
  connect?: InputMaybe<PostRevisionPostConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostRevisionPostConnectOrCreateFieldInput>;
  create?: InputMaybe<PostRevisionPostCreateFieldInput>;
  delete?: InputMaybe<PostRevisionPostDeleteFieldInput>;
  disconnect?: InputMaybe<PostRevisionPostDisconnectFieldInput>;
  update?: InputMaybe<PostRevisionPostUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionPostConnectionWhere>;
};

/** Fields to sort PostRevisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostRevisionSort object. */
export type PostRevisionSort = {
  body?: InputMaybe<SortDirection>;
  coverAttribution?: InputMaybe<SortDirection>;
  coverAttributionLink?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lead?: InputMaybe<SortDirection>;
  publishedAt?: InputMaybe<SortDirection>;
  sticky?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum PostRevisionStatus {
  Archived = 'ARCHIVED',
  Current = 'CURRENT',
  Future = 'FUTURE'
}

export type PostRevisionTagTagsAggregationSelection = {
  __typename?: 'PostRevisionTagTagsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostRevisionTagTagsNodeAggregateSelection>;
};

export type PostRevisionTagTagsNodeAggregateSelection = {
  __typename?: 'PostRevisionTagTagsNodeAggregateSelection';
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type PostRevisionTagsAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionTagsAggregateInput>>;
  NOT?: InputMaybe<PostRevisionTagsAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionTagsNodeAggregationWhereInput>;
};

export type PostRevisionTagsConnectFieldInput = {
  connect?: InputMaybe<Array<TagConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TagConnectWhere>;
};

export type PostRevisionTagsConnectOrCreateFieldInput = {
  onCreate: PostRevisionTagsConnectOrCreateFieldInputOnCreate;
  where: TagConnectOrCreateWhere;
};

export type PostRevisionTagsConnectOrCreateFieldInputOnCreate = {
  node: TagOnCreateInput;
};

export type PostRevisionTagsConnection = {
  __typename?: 'PostRevisionTagsConnection';
  edges: Array<PostRevisionTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionTagsConnectionSort = {
  node?: InputMaybe<TagSort>;
};

export type PostRevisionTagsConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionTagsConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionTagsConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionTagsConnectionWhere>>;
  node?: InputMaybe<TagWhere>;
};

export type PostRevisionTagsCreateFieldInput = {
  node: TagCreateInput;
};

export type PostRevisionTagsDeleteFieldInput = {
  delete?: InputMaybe<TagDeleteInput>;
  where?: InputMaybe<PostRevisionTagsConnectionWhere>;
};

export type PostRevisionTagsDisconnectFieldInput = {
  disconnect?: InputMaybe<TagDisconnectInput>;
  where?: InputMaybe<PostRevisionTagsConnectionWhere>;
};

export type PostRevisionTagsFieldInput = {
  connect?: InputMaybe<Array<PostRevisionTagsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRevisionTagsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRevisionTagsCreateFieldInput>>;
};

export type PostRevisionTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionTagsNodeAggregationWhereInput>>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRevisionTagsRelationship = {
  __typename?: 'PostRevisionTagsRelationship';
  cursor: Scalars['String']['output'];
  node: Tag;
};

export type PostRevisionTagsUpdateConnectionInput = {
  node?: InputMaybe<TagUpdateInput>;
};

export type PostRevisionTagsUpdateFieldInput = {
  connect?: InputMaybe<Array<PostRevisionTagsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRevisionTagsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRevisionTagsCreateFieldInput>>;
  delete?: InputMaybe<Array<PostRevisionTagsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostRevisionTagsDisconnectFieldInput>>;
  update?: InputMaybe<PostRevisionTagsUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionTagsConnectionWhere>;
};

export type PostRevisionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PostRevisionUpdateInput = {
  author?: InputMaybe<PostRevisionAuthorUpdateFieldInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<PostRevisionCategoryUpdateFieldInput>;
  cover?: InputMaybe<PostRevisionCoverUpdateFieldInput>;
  coverAttribution?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostRevisionPostUpdateFieldInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<PostRevisionTagsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostRevisionUserAuthorAggregationSelection = {
  __typename?: 'PostRevisionUserAuthorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostRevisionUserAuthorNodeAggregateSelection>;
};

export type PostRevisionUserAuthorNodeAggregateSelection = {
  __typename?: 'PostRevisionUserAuthorNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type PostRevisionWhere = {
  AND?: InputMaybe<Array<PostRevisionWhere>>;
  NOT?: InputMaybe<PostRevisionWhere>;
  OR?: InputMaybe<Array<PostRevisionWhere>>;
  author?: InputMaybe<UserWhere>;
  authorAggregate?: InputMaybe<PostRevisionAuthorAggregateInput>;
  authorConnection?: InputMaybe<PostRevisionAuthorConnectionWhere>;
  authorConnection_NOT?: InputMaybe<PostRevisionAuthorConnectionWhere>;
  author_NOT?: InputMaybe<UserWhere>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  body_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  body_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryWhere>;
  categoryAggregate?: InputMaybe<PostRevisionCategoryAggregateInput>;
  categoryConnection?: InputMaybe<PostRevisionCategoryConnectionWhere>;
  categoryConnection_NOT?: InputMaybe<PostRevisionCategoryConnectionWhere>;
  category_NOT?: InputMaybe<CategoryWhere>;
  cover?: InputMaybe<FileWhere>;
  coverAggregate?: InputMaybe<PostRevisionCoverAggregateInput>;
  coverAttribution?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coverAttributionLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coverAttributionLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coverAttribution_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coverAttribution_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coverAttribution_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coverAttribution_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coverConnection?: InputMaybe<PostRevisionCoverConnectionWhere>;
  coverConnection_NOT?: InputMaybe<PostRevisionCoverConnectionWhere>;
  cover_NOT?: InputMaybe<FileWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  lead_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lead_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lead_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lead_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<PostWhere>;
  postAggregate?: InputMaybe<PostRevisionPostAggregateInput>;
  postConnection?: InputMaybe<PostRevisionPostConnectionWhere>;
  postConnection_NOT?: InputMaybe<PostRevisionPostConnectionWhere>;
  post_NOT?: InputMaybe<PostWhere>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagsAggregate?: InputMaybe<PostRevisionTagsAggregateInput>;
  /** Return PostRevisions where all of the related PostRevisionTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<PostRevisionTagsConnectionWhere>;
  /** Return PostRevisions where none of the related PostRevisionTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<PostRevisionTagsConnectionWhere>;
  /** Return PostRevisions where one of the related PostRevisionTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<PostRevisionTagsConnectionWhere>;
  /** Return PostRevisions where some of the related PostRevisionTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<PostRevisionTagsConnectionWhere>;
  /** Return PostRevisions where all of the related Tags match this filter */
  tags_ALL?: InputMaybe<TagWhere>;
  /** Return PostRevisions where none of the related Tags match this filter */
  tags_NONE?: InputMaybe<TagWhere>;
  /** Return PostRevisions where one of the related Tags match this filter */
  tags_SINGLE?: InputMaybe<TagWhere>;
  /** Return PostRevisions where some of the related Tags match this filter */
  tags_SOME?: InputMaybe<TagWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostRevisionsAggregateInput = {
  AND?: InputMaybe<Array<PostRevisionsAggregateInput>>;
  NOT?: InputMaybe<PostRevisionsAggregateInput>;
  OR?: InputMaybe<Array<PostRevisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRevisionsNodeAggregationWhereInput>;
};

export type PostRevisionsConnectFieldInput = {
  connect?: InputMaybe<Array<PostRevisionConnectInput>>;
  edge: IsRevisionOfCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostRevisionConnectWhere>;
};

export type PostRevisionsConnectOrCreateFieldInput = {
  onCreate: PostRevisionsConnectOrCreateFieldInputOnCreate;
  where: PostRevisionConnectOrCreateWhere;
};

export type PostRevisionsConnectOrCreateFieldInputOnCreate = {
  edge: IsRevisionOfCreateInput;
  node: PostRevisionOnCreateInput;
};

export type PostRevisionsConnection = {
  __typename?: 'PostRevisionsConnection';
  edges: Array<PostRevisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRevisionsConnectionSort = {
  edge?: InputMaybe<IsRevisionOfSort>;
  node?: InputMaybe<PostRevisionSort>;
};

export type PostRevisionsConnectionWhere = {
  AND?: InputMaybe<Array<PostRevisionsConnectionWhere>>;
  NOT?: InputMaybe<PostRevisionsConnectionWhere>;
  OR?: InputMaybe<Array<PostRevisionsConnectionWhere>>;
  edge?: InputMaybe<IsRevisionOfWhere>;
  node?: InputMaybe<PostRevisionWhere>;
};

export type PostRevisionsCreateFieldInput = {
  edge: IsRevisionOfCreateInput;
  node: PostRevisionCreateInput;
};

export type PostRevisionsDeleteFieldInput = {
  delete?: InputMaybe<PostRevisionDeleteInput>;
  where?: InputMaybe<PostRevisionsConnectionWhere>;
};

export type PostRevisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostRevisionDisconnectInput>;
  where?: InputMaybe<PostRevisionsConnectionWhere>;
};

export type PostRevisionsFieldInput = {
  connect?: InputMaybe<Array<PostRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRevisionsCreateFieldInput>>;
};

export type PostRevisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRevisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRevisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRevisionsNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lead_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lead_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostRevisionsRelationship = {
  __typename?: 'PostRevisionsRelationship';
  cursor: Scalars['String']['output'];
  node: PostRevision;
  properties: IsRevisionOf;
};

export type PostRevisionsUpdateConnectionInput = {
  edge?: InputMaybe<IsRevisionOfUpdateInput>;
  node?: InputMaybe<PostRevisionUpdateInput>;
};

export type PostRevisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<PostRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRevisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<PostRevisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostRevisionsDisconnectFieldInput>>;
  update?: InputMaybe<PostRevisionsUpdateConnectionInput>;
  where?: InputMaybe<PostRevisionsConnectionWhere>;
};

export type PostSchedule = {
  __typename?: 'PostSchedule';
  category: Category;
  categoryAggregate?: Maybe<PostScheduleCategoryCategoryAggregationSelection>;
  categoryConnection: PostScheduleCategoryConnection;
  id: Scalars['ID']['output'];
  user: User;
  userAggregate?: Maybe<PostScheduleUserUserAggregationSelection>;
  userConnection: PostScheduleUserConnection;
  weekday: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};


export type PostScheduleCategoryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostScheduleCategoryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryWhere>;
};


export type PostScheduleCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostScheduleCategoryConnectionSort>>;
  where?: InputMaybe<PostScheduleCategoryConnectionWhere>;
};


export type PostScheduleUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostScheduleUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostScheduleUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostScheduleUserConnectionSort>>;
  where?: InputMaybe<PostScheduleUserConnectionWhere>;
};

export type PostScheduleAggregateSelection = {
  __typename?: 'PostScheduleAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelection;
  weekday: IntAggregateSelection;
  weight: IntAggregateSelection;
};

export type PostScheduleCategoryAggregateInput = {
  AND?: InputMaybe<Array<PostScheduleCategoryAggregateInput>>;
  NOT?: InputMaybe<PostScheduleCategoryAggregateInput>;
  OR?: InputMaybe<Array<PostScheduleCategoryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostScheduleCategoryNodeAggregationWhereInput>;
};

export type PostScheduleCategoryCategoryAggregationSelection = {
  __typename?: 'PostScheduleCategoryCategoryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostScheduleCategoryCategoryNodeAggregateSelection>;
};

export type PostScheduleCategoryCategoryNodeAggregateSelection = {
  __typename?: 'PostScheduleCategoryCategoryNodeAggregateSelection';
  body: StringAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type PostScheduleCategoryConnectFieldInput = {
  connect?: InputMaybe<CategoryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CategoryConnectWhere>;
};

export type PostScheduleCategoryConnectOrCreateFieldInput = {
  onCreate: PostScheduleCategoryConnectOrCreateFieldInputOnCreate;
  where: CategoryConnectOrCreateWhere;
};

export type PostScheduleCategoryConnectOrCreateFieldInputOnCreate = {
  node: CategoryOnCreateInput;
};

export type PostScheduleCategoryConnection = {
  __typename?: 'PostScheduleCategoryConnection';
  edges: Array<PostScheduleCategoryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostScheduleCategoryConnectionSort = {
  node?: InputMaybe<CategorySort>;
};

export type PostScheduleCategoryConnectionWhere = {
  AND?: InputMaybe<Array<PostScheduleCategoryConnectionWhere>>;
  NOT?: InputMaybe<PostScheduleCategoryConnectionWhere>;
  OR?: InputMaybe<Array<PostScheduleCategoryConnectionWhere>>;
  node?: InputMaybe<CategoryWhere>;
};

export type PostScheduleCategoryCreateFieldInput = {
  node: CategoryCreateInput;
};

export type PostScheduleCategoryDeleteFieldInput = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<PostScheduleCategoryConnectionWhere>;
};

export type PostScheduleCategoryDisconnectFieldInput = {
  disconnect?: InputMaybe<CategoryDisconnectInput>;
  where?: InputMaybe<PostScheduleCategoryConnectionWhere>;
};

export type PostScheduleCategoryFieldInput = {
  connect?: InputMaybe<PostScheduleCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostScheduleCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostScheduleCategoryCreateFieldInput>;
};

export type PostScheduleCategoryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostScheduleCategoryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostScheduleCategoryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostScheduleCategoryNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostScheduleCategoryRelationship = {
  __typename?: 'PostScheduleCategoryRelationship';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type PostScheduleCategoryUpdateConnectionInput = {
  node?: InputMaybe<CategoryUpdateInput>;
};

export type PostScheduleCategoryUpdateFieldInput = {
  connect?: InputMaybe<PostScheduleCategoryConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostScheduleCategoryConnectOrCreateFieldInput>;
  create?: InputMaybe<PostScheduleCategoryCreateFieldInput>;
  delete?: InputMaybe<PostScheduleCategoryDeleteFieldInput>;
  disconnect?: InputMaybe<PostScheduleCategoryDisconnectFieldInput>;
  update?: InputMaybe<PostScheduleCategoryUpdateConnectionInput>;
  where?: InputMaybe<PostScheduleCategoryConnectionWhere>;
};

export type PostScheduleConnectInput = {
  category?: InputMaybe<PostScheduleCategoryConnectFieldInput>;
  user?: InputMaybe<PostScheduleUserConnectFieldInput>;
};

export type PostScheduleConnectOrCreateInput = {
  category?: InputMaybe<PostScheduleCategoryConnectOrCreateFieldInput>;
  user?: InputMaybe<PostScheduleUserConnectOrCreateFieldInput>;
};

export type PostScheduleCreateInput = {
  category?: InputMaybe<PostScheduleCategoryFieldInput>;
  user?: InputMaybe<PostScheduleUserFieldInput>;
  weekday: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type PostScheduleDeleteInput = {
  category?: InputMaybe<PostScheduleCategoryDeleteFieldInput>;
  user?: InputMaybe<PostScheduleUserDeleteFieldInput>;
};

export type PostScheduleDisconnectInput = {
  category?: InputMaybe<PostScheduleCategoryDisconnectFieldInput>;
  user?: InputMaybe<PostScheduleUserDisconnectFieldInput>;
};

export type PostScheduleEdge = {
  __typename?: 'PostScheduleEdge';
  cursor: Scalars['String']['output'];
  node: PostSchedule;
};

export type PostScheduleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostScheduleSort objects to sort PostSchedules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostScheduleSort>>;
};

export type PostScheduleRelationInput = {
  category?: InputMaybe<PostScheduleCategoryCreateFieldInput>;
  user?: InputMaybe<PostScheduleUserCreateFieldInput>;
};

/** Fields to sort PostSchedules by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostScheduleSort object. */
export type PostScheduleSort = {
  id?: InputMaybe<SortDirection>;
  weekday?: InputMaybe<SortDirection>;
  weight?: InputMaybe<SortDirection>;
};

export type PostScheduleUpdateInput = {
  category?: InputMaybe<PostScheduleCategoryUpdateFieldInput>;
  user?: InputMaybe<PostScheduleUserUpdateFieldInput>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
  weekday_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  weekday_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  weight_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type PostScheduleUserAggregateInput = {
  AND?: InputMaybe<Array<PostScheduleUserAggregateInput>>;
  NOT?: InputMaybe<PostScheduleUserAggregateInput>;
  OR?: InputMaybe<Array<PostScheduleUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostScheduleUserNodeAggregationWhereInput>;
};

export type PostScheduleUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostScheduleUserConnectOrCreateFieldInput = {
  onCreate: PostScheduleUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostScheduleUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostScheduleUserConnection = {
  __typename?: 'PostScheduleUserConnection';
  edges: Array<PostScheduleUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostScheduleUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostScheduleUserConnectionWhere = {
  AND?: InputMaybe<Array<PostScheduleUserConnectionWhere>>;
  NOT?: InputMaybe<PostScheduleUserConnectionWhere>;
  OR?: InputMaybe<Array<PostScheduleUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostScheduleUserCreateFieldInput = {
  node: UserCreateInput;
};

export type PostScheduleUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostScheduleUserConnectionWhere>;
};

export type PostScheduleUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostScheduleUserConnectionWhere>;
};

export type PostScheduleUserFieldInput = {
  connect?: InputMaybe<PostScheduleUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostScheduleUserConnectOrCreateFieldInput>;
  create?: InputMaybe<PostScheduleUserCreateFieldInput>;
};

export type PostScheduleUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostScheduleUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostScheduleUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostScheduleUserNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostScheduleUserRelationship = {
  __typename?: 'PostScheduleUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostScheduleUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostScheduleUserUpdateFieldInput = {
  connect?: InputMaybe<PostScheduleUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostScheduleUserConnectOrCreateFieldInput>;
  create?: InputMaybe<PostScheduleUserCreateFieldInput>;
  delete?: InputMaybe<PostScheduleUserDeleteFieldInput>;
  disconnect?: InputMaybe<PostScheduleUserDisconnectFieldInput>;
  update?: InputMaybe<PostScheduleUserUpdateConnectionInput>;
  where?: InputMaybe<PostScheduleUserConnectionWhere>;
};

export type PostScheduleUserUserAggregationSelection = {
  __typename?: 'PostScheduleUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostScheduleUserUserNodeAggregateSelection>;
};

export type PostScheduleUserUserNodeAggregateSelection = {
  __typename?: 'PostScheduleUserUserNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type PostScheduleWhere = {
  AND?: InputMaybe<Array<PostScheduleWhere>>;
  NOT?: InputMaybe<PostScheduleWhere>;
  OR?: InputMaybe<Array<PostScheduleWhere>>;
  category?: InputMaybe<CategoryWhere>;
  categoryAggregate?: InputMaybe<PostScheduleCategoryAggregateInput>;
  categoryConnection?: InputMaybe<PostScheduleCategoryConnectionWhere>;
  categoryConnection_NOT?: InputMaybe<PostScheduleCategoryConnectionWhere>;
  category_NOT?: InputMaybe<CategoryWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<PostScheduleUserAggregateInput>;
  userConnection?: InputMaybe<PostScheduleUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<PostScheduleUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
  weekday_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekday_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LTE?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_GT?: InputMaybe<Scalars['Int']['input']>;
  weight_GTE?: InputMaybe<Scalars['Int']['input']>;
  weight_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  weight_LT?: InputMaybe<Scalars['Int']['input']>;
  weight_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostSchedulesConnection = {
  __typename?: 'PostSchedulesConnection';
  edges: Array<PostScheduleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Posts by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostSort object. */
export type PostSort = {
  createdAt?: InputMaybe<SortDirection>;
  deletedAt?: InputMaybe<SortDirection>;
  hasPendingModifications?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  oldId?: InputMaybe<SortDirection>;
  publishedAt?: InputMaybe<SortDirection>;
  slug?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  sticky?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  views?: InputMaybe<SortDirection>;
};

export enum PostStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export enum PostType {
  Article = 'ARTICLE',
  Page = 'PAGE'
}

export type PostUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PostUpdateInput = {
  attachments?: InputMaybe<Array<PostAttachmentsUpdateFieldInput>>;
  author?: InputMaybe<PostAuthorUpdateFieldInput>;
  category?: InputMaybe<PostCategoryUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oldId_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  oldId_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  related?: InputMaybe<Array<PostRelatedUpdateFieldInput>>;
  revisions?: InputMaybe<Array<PostRevisionsUpdateFieldInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PostStatus>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  views?: InputMaybe<Scalars['Int']['input']>;
  views_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  views_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  words?: InputMaybe<Array<PostWordsUpdateFieldInput>>;
};

export type PostUserAuthorAggregationSelection = {
  __typename?: 'PostUserAuthorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostUserAuthorNodeAggregateSelection>;
};

export type PostUserAuthorNodeAggregateSelection = {
  __typename?: 'PostUserAuthorNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type PostWhere = {
  AND?: InputMaybe<Array<PostWhere>>;
  NOT?: InputMaybe<PostWhere>;
  OR?: InputMaybe<Array<PostWhere>>;
  attachmentsAggregate?: InputMaybe<PostAttachmentsAggregateInput>;
  /** Return Posts where all of the related PostAttachmentsConnections match this filter */
  attachmentsConnection_ALL?: InputMaybe<PostAttachmentsConnectionWhere>;
  /** Return Posts where none of the related PostAttachmentsConnections match this filter */
  attachmentsConnection_NONE?: InputMaybe<PostAttachmentsConnectionWhere>;
  /** Return Posts where one of the related PostAttachmentsConnections match this filter */
  attachmentsConnection_SINGLE?: InputMaybe<PostAttachmentsConnectionWhere>;
  /** Return Posts where some of the related PostAttachmentsConnections match this filter */
  attachmentsConnection_SOME?: InputMaybe<PostAttachmentsConnectionWhere>;
  /** Return Posts where all of the related Files match this filter */
  attachments_ALL?: InputMaybe<FileWhere>;
  /** Return Posts where none of the related Files match this filter */
  attachments_NONE?: InputMaybe<FileWhere>;
  /** Return Posts where one of the related Files match this filter */
  attachments_SINGLE?: InputMaybe<FileWhere>;
  /** Return Posts where some of the related Files match this filter */
  attachments_SOME?: InputMaybe<FileWhere>;
  author?: InputMaybe<UserWhere>;
  authorAggregate?: InputMaybe<PostAuthorAggregateInput>;
  authorConnection?: InputMaybe<PostAuthorConnectionWhere>;
  authorConnection_NOT?: InputMaybe<PostAuthorConnectionWhere>;
  author_NOT?: InputMaybe<UserWhere>;
  category?: InputMaybe<CategoryWhere>;
  categoryAggregate?: InputMaybe<PostCategoryAggregateInput>;
  categoryConnection?: InputMaybe<PostCategoryConnectionWhere>;
  categoryConnection_NOT?: InputMaybe<PostCategoryConnectionWhere>;
  category_NOT?: InputMaybe<CategoryWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hasPendingModifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oldId_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  oldId_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  relatedAggregate?: InputMaybe<PostRelatedAggregateInput>;
  /** Return Posts where all of the related PostRelatedConnections match this filter */
  relatedConnection_ALL?: InputMaybe<PostRelatedConnectionWhere>;
  /** Return Posts where none of the related PostRelatedConnections match this filter */
  relatedConnection_NONE?: InputMaybe<PostRelatedConnectionWhere>;
  /** Return Posts where one of the related PostRelatedConnections match this filter */
  relatedConnection_SINGLE?: InputMaybe<PostRelatedConnectionWhere>;
  /** Return Posts where some of the related PostRelatedConnections match this filter */
  relatedConnection_SOME?: InputMaybe<PostRelatedConnectionWhere>;
  /** Return Posts where all of the related Posts match this filter */
  related_ALL?: InputMaybe<PostWhere>;
  /** Return Posts where none of the related Posts match this filter */
  related_NONE?: InputMaybe<PostWhere>;
  /** Return Posts where one of the related Posts match this filter */
  related_SINGLE?: InputMaybe<PostWhere>;
  /** Return Posts where some of the related Posts match this filter */
  related_SOME?: InputMaybe<PostWhere>;
  revisionsAggregate?: InputMaybe<PostRevisionsAggregateInput>;
  /** Return Posts where all of the related PostRevisionsConnections match this filter */
  revisionsConnection_ALL?: InputMaybe<PostRevisionsConnectionWhere>;
  /** Return Posts where none of the related PostRevisionsConnections match this filter */
  revisionsConnection_NONE?: InputMaybe<PostRevisionsConnectionWhere>;
  /** Return Posts where one of the related PostRevisionsConnections match this filter */
  revisionsConnection_SINGLE?: InputMaybe<PostRevisionsConnectionWhere>;
  /** Return Posts where some of the related PostRevisionsConnections match this filter */
  revisionsConnection_SOME?: InputMaybe<PostRevisionsConnectionWhere>;
  /** Return Posts where all of the related PostRevisions match this filter */
  revisions_ALL?: InputMaybe<PostRevisionWhere>;
  /** Return Posts where none of the related PostRevisions match this filter */
  revisions_NONE?: InputMaybe<PostRevisionWhere>;
  /** Return Posts where one of the related PostRevisions match this filter */
  revisions_SINGLE?: InputMaybe<PostRevisionWhere>;
  /** Return Posts where some of the related PostRevisions match this filter */
  revisions_SOME?: InputMaybe<PostRevisionWhere>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  slug_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PostStatus>;
  status_IN?: InputMaybe<Array<PostStatus>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PostType>;
  type_IN?: InputMaybe<Array<PostType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
  views_GT?: InputMaybe<Scalars['Int']['input']>;
  views_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  views_LT?: InputMaybe<Scalars['Int']['input']>;
  views_LTE?: InputMaybe<Scalars['Int']['input']>;
  wordsAggregate?: InputMaybe<PostWordsAggregateInput>;
  /** Return Posts where all of the related PostWordsConnections match this filter */
  wordsConnection_ALL?: InputMaybe<PostWordsConnectionWhere>;
  /** Return Posts where none of the related PostWordsConnections match this filter */
  wordsConnection_NONE?: InputMaybe<PostWordsConnectionWhere>;
  /** Return Posts where one of the related PostWordsConnections match this filter */
  wordsConnection_SINGLE?: InputMaybe<PostWordsConnectionWhere>;
  /** Return Posts where some of the related PostWordsConnections match this filter */
  wordsConnection_SOME?: InputMaybe<PostWordsConnectionWhere>;
  /** Return Posts where all of the related PostWords match this filter */
  words_ALL?: InputMaybe<PostWordWhere>;
  /** Return Posts where none of the related PostWords match this filter */
  words_NONE?: InputMaybe<PostWordWhere>;
  /** Return Posts where one of the related PostWords match this filter */
  words_SINGLE?: InputMaybe<PostWordWhere>;
  /** Return Posts where some of the related PostWords match this filter */
  words_SOME?: InputMaybe<PostWordWhere>;
};

export type PostWord = {
  __typename?: 'PostWord';
  post: Post;
  postAggregate?: Maybe<PostWordPostPostAggregationSelection>;
  postConnection: PostWordPostConnection;
  weight: Scalars['Float']['output'];
  word: Scalars['String']['output'];
};


export type PostWordPostArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type PostWordPostAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type PostWordPostConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostWordPostConnectionSort>>;
  where?: InputMaybe<PostWordPostConnectionWhere>;
};

export type PostWordConnectInput = {
  post?: InputMaybe<PostWordPostConnectFieldInput>;
};

export type PostWordConnectWhere = {
  node: PostWordWhere;
};

export type PostWordCreateInput = {
  post?: InputMaybe<PostWordPostFieldInput>;
  weight: Scalars['Float']['input'];
  word: Scalars['String']['input'];
};

export type PostWordDeleteInput = {
  post?: InputMaybe<PostWordPostDeleteFieldInput>;
};

export type PostWordDisconnectInput = {
  post?: InputMaybe<PostWordPostDisconnectFieldInput>;
};

export type PostWordOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostWordSort objects to sort PostWords by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostWordSort>>;
};

export type PostWordPostAggregateInput = {
  AND?: InputMaybe<Array<PostWordPostAggregateInput>>;
  NOT?: InputMaybe<PostWordPostAggregateInput>;
  OR?: InputMaybe<Array<PostWordPostAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostWordPostNodeAggregationWhereInput>;
};

export type PostWordPostConnectFieldInput = {
  connect?: InputMaybe<PostConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type PostWordPostConnectOrCreateFieldInput = {
  onCreate: PostWordPostConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type PostWordPostConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type PostWordPostConnection = {
  __typename?: 'PostWordPostConnection';
  edges: Array<PostWordPostRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostWordPostConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type PostWordPostConnectionWhere = {
  AND?: InputMaybe<Array<PostWordPostConnectionWhere>>;
  NOT?: InputMaybe<PostWordPostConnectionWhere>;
  OR?: InputMaybe<Array<PostWordPostConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type PostWordPostCreateFieldInput = {
  node: PostCreateInput;
};

export type PostWordPostDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<PostWordPostConnectionWhere>;
};

export type PostWordPostDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<PostWordPostConnectionWhere>;
};

export type PostWordPostFieldInput = {
  connect?: InputMaybe<PostWordPostConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostWordPostConnectOrCreateFieldInput>;
  create?: InputMaybe<PostWordPostCreateFieldInput>;
};

export type PostWordPostNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostWordPostNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostWordPostNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostWordPostNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  oldId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostWordPostPostAggregationSelection = {
  __typename?: 'PostWordPostPostAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostWordPostPostNodeAggregateSelection>;
};

export type PostWordPostPostNodeAggregateSelection = {
  __typename?: 'PostWordPostPostNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type PostWordPostRelationship = {
  __typename?: 'PostWordPostRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostWordPostUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type PostWordPostUpdateFieldInput = {
  connect?: InputMaybe<PostWordPostConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostWordPostConnectOrCreateFieldInput>;
  create?: InputMaybe<PostWordPostCreateFieldInput>;
  delete?: InputMaybe<PostWordPostDeleteFieldInput>;
  disconnect?: InputMaybe<PostWordPostDisconnectFieldInput>;
  update?: InputMaybe<PostWordPostUpdateConnectionInput>;
  where?: InputMaybe<PostWordPostConnectionWhere>;
};

/** Fields to sort PostWords by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostWordSort object. */
export type PostWordSort = {
  weight?: InputMaybe<SortDirection>;
  word?: InputMaybe<SortDirection>;
};

export type PostWordUpdateInput = {
  post?: InputMaybe<PostWordPostUpdateFieldInput>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_ADD?: InputMaybe<Scalars['Float']['input']>;
  weight_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weight_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weight_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  word?: InputMaybe<Scalars['String']['input']>;
};

export type PostWordWhere = {
  AND?: InputMaybe<Array<PostWordWhere>>;
  NOT?: InputMaybe<PostWordWhere>;
  OR?: InputMaybe<Array<PostWordWhere>>;
  post?: InputMaybe<PostWhere>;
  postAggregate?: InputMaybe<PostWordPostAggregateInput>;
  postConnection?: InputMaybe<PostWordPostConnectionWhere>;
  postConnection_NOT?: InputMaybe<PostWordPostConnectionWhere>;
  post_NOT?: InputMaybe<PostWhere>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weight_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_LTE?: InputMaybe<Scalars['Float']['input']>;
  word?: InputMaybe<Scalars['String']['input']>;
  word_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  word_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  word_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  word_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PostWordsAggregateInput = {
  AND?: InputMaybe<Array<PostWordsAggregateInput>>;
  NOT?: InputMaybe<PostWordsAggregateInput>;
  OR?: InputMaybe<Array<PostWordsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostWordsNodeAggregationWhereInput>;
};

export type PostWordsConnectFieldInput = {
  connect?: InputMaybe<Array<PostWordConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostWordConnectWhere>;
};

export type PostWordsConnection = {
  __typename?: 'PostWordsConnection';
  edges: Array<PostWordsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostWordsConnectionSort = {
  node?: InputMaybe<PostWordSort>;
};

export type PostWordsConnectionWhere = {
  AND?: InputMaybe<Array<PostWordsConnectionWhere>>;
  NOT?: InputMaybe<PostWordsConnectionWhere>;
  OR?: InputMaybe<Array<PostWordsConnectionWhere>>;
  node?: InputMaybe<PostWordWhere>;
};

export type PostWordsCreateFieldInput = {
  node: PostWordCreateInput;
};

export type PostWordsDeleteFieldInput = {
  delete?: InputMaybe<PostWordDeleteInput>;
  where?: InputMaybe<PostWordsConnectionWhere>;
};

export type PostWordsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostWordDisconnectInput>;
  where?: InputMaybe<PostWordsConnectionWhere>;
};

export type PostWordsFieldInput = {
  connect?: InputMaybe<Array<PostWordsConnectFieldInput>>;
  create?: InputMaybe<Array<PostWordsCreateFieldInput>>;
};

export type PostWordsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostWordsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostWordsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostWordsNodeAggregationWhereInput>>;
  weight_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weight_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weight_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weight_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weight_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weight_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weight_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weight_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  word_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  word_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  word_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  word_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  word_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  word_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  word_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  word_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  word_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  word_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  word_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  word_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  word_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  word_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  word_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostWordsRelationship = {
  __typename?: 'PostWordsRelationship';
  cursor: Scalars['String']['output'];
  node: PostWord;
};

export type PostWordsUpdateConnectionInput = {
  node?: InputMaybe<PostWordUpdateInput>;
};

export type PostWordsUpdateFieldInput = {
  connect?: InputMaybe<Array<PostWordsConnectFieldInput>>;
  create?: InputMaybe<Array<PostWordsCreateFieldInput>>;
  delete?: InputMaybe<Array<PostWordsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostWordsDisconnectFieldInput>>;
  update?: InputMaybe<PostWordsUpdateConnectionInput>;
  where?: InputMaybe<PostWordsConnectionWhere>;
};

export type PostsConnection = {
  __typename?: 'PostsConnection';
  edges: Array<PostEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * User.categories
 * * Category.users
 */
export type PostsOn = {
  __typename?: 'PostsOn';
  isAdmin: Scalars['Boolean']['output'];
};

export type PostsOnCreateInput = {
  isAdmin: Scalars['Boolean']['input'];
};

export type PostsOnSort = {
  isAdmin?: InputMaybe<SortDirection>;
};

export type PostsOnUpdateInput = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostsOnWhere = {
  AND?: InputMaybe<Array<PostsOnWhere>>;
  NOT?: InputMaybe<PostsOnWhere>;
  OR?: InputMaybe<Array<PostsOnWhere>>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  airedRadioShows: Array<AiredRadioShow>;
  airedRadioShowsAggregate: AiredRadioShowAggregateSelection;
  airedRadioShowsConnection: AiredRadioShowsConnection;
  analytics?: Maybe<Scalars['String']['output']>;
  banners: Array<Banner>;
  bannersAggregate: BannerAggregateSelection;
  bannersConnection: BannersConnection;
  basePlaylist: RadioShow;
  canEditPost: Scalars['Boolean']['output'];
  categories: Array<Category>;
  categoriesAggregate: CategoryAggregateSelection;
  categoriesConnection: CategoriesConnection;
  commercialBreakPlayerDescription?: Maybe<Scalars['String']['output']>;
  commercialBreakPlayerImage?: Maybe<File>;
  commercialBreakPlayerName?: Maybe<Scalars['String']['output']>;
  commercialBreakSchedules: Array<CommercialBreakSchedule>;
  commercialBreakSchedulesAggregate: CommercialBreakScheduleAggregateSelection;
  commercialBreakSchedulesConnection: CommercialBreakSchedulesConnection;
  createAppkeyResponses: Array<CreateAppkeyResponse>;
  createAppkeyResponsesAggregate: CreateAppkeyResponseAggregateSelection;
  createAppkeyResponsesConnection: CreateAppkeyResponsesConnection;
  deadlines: Array<Deadline>;
  deadlinesAggregate: DeadlineAggregateSelection;
  deadlinesConnection: DeadlinesConnection;
  djOnAir?: Maybe<User>;
  fanGalleryItems: Array<FanGalleryItem>;
  fanGalleryItemsAggregate: FanGalleryItemAggregateSelection;
  fanGalleryItemsConnection: FanGalleryItemsConnection;
  files: Array<File>;
  filesAggregate: FileAggregateSelection;
  filesConnection: FilesConnection;
  hourlyListenersStatPoints: Array<HourlyListenersStatPoint>;
  hourlyListenersStatPointsAggregate: HourlyListenersStatPointAggregateSelection;
  hourlyListenersStatPointsConnection: HourlyListenersStatPointsConnection;
  internalTopSongs: Array<InternalRequestedSong>;
  isIpBanned: Scalars['Boolean']['output'];
  latestCategories: Array<Category>;
  latestRadioShows: Array<RadioShow>;
  me: User;
  myCategories: Array<Category>;
  myNotes: Scalars['String']['output'];
  myPosts: Array<Post>;
  myRadioShows: Array<RadioShow>;
  ourSocialLinks: Array<OurSocialLink>;
  ourSocialLinksAggregate: OurSocialLinkAggregateSelection;
  ourSocialLinksConnection: OurSocialLinksConnection;
  partners: Array<Partner>;
  partnersAggregate: PartnerAggregateSelection;
  partnersConnection: PartnersConnection;
  polls: Array<Poll>;
  pollsAggregate: PollAggregateSelection;
  pollsConnection: PollsConnection;
  postAbsences: Array<PostAbsence>;
  postAbsencesAggregate: PostAbsenceAggregateSelection;
  postAbsencesConnection: PostAbsencesConnection;
  postSchedules: Array<PostSchedule>;
  postSchedulesAggregate: PostScheduleAggregateSelection;
  postSchedulesConnection: PostSchedulesConnection;
  posts: Array<Post>;
  postsAggregate: PostAggregateSelection;
  postsConnection: PostsConnection;
  radioShowSchedules: Array<RadioShowSchedule>;
  radioShowSchedulesAggregate: RadioShowScheduleAggregateSelection;
  radioShowSchedulesConnection: RadioShowSchedulesConnection;
  radioShows: Array<RadioShow>;
  radioShowsAggregate: RadioShowAggregateSelection;
  radioShowsConnection: RadioShowsConnection;
  relatedPosts: Array<Post>;
  requestedSongs: Array<RequestedSong>;
  requestedSongsAggregate: RequestedSongAggregateSelection;
  requestedSongsConnection: RequestedSongsConnection;
  songRequestBannedIps: Array<SongRequestBannedIp>;
  songRequestBannedIpsAggregate: SongRequestBannedIpAggregateSelection;
  songRequestBannedIpsConnection: SongRequestBannedIpsConnection;
  songRequestQueue: Array<InternalQueuedSong>;
  songRequests: Array<SongRequest>;
  songRequestsAggregate: SongRequestAggregateSelection;
  songRequestsConnection: SongRequestsConnection;
  streamingAbsences: Array<StreamingAbsence>;
  streamingAbsencesAggregate: StreamingAbsenceAggregateSelection;
  streamingAbsencesConnection: StreamingAbsencesConnection;
  streamingNeedsRestart: Scalars['Boolean']['output'];
  tags: Array<Tag>;
  tagsAggregate: TagAggregateSelection;
  tagsConnection: TagsConnection;
  timeAnnouncerInterval: Scalars['Int']['output'];
  timeAnnouncerVoice: Scalars['String']['output'];
  topMonthlyAuthors: Array<User>;
  userAppkeys: Array<UserAppkey>;
  userAppkeysAggregate: UserAppkeyAggregateSelection;
  userAppkeysConnection: UserAppkeysConnection;
  userPasskeys: Array<UserPasskey>;
  userPasskeysAggregate: UserPasskeyAggregateSelection;
  userPasskeysConnection: UserPasskeysConnection;
  users: Array<User>;
  usersAggregate: UserAggregateSelection;
  usersConnection: UsersConnection;
  weeklyListeners: Scalars['Int']['output'];
};


export type QueryAiredRadioShowsArgs = {
  options?: InputMaybe<AiredRadioShowOptions>;
  where?: InputMaybe<AiredRadioShowWhere>;
};


export type QueryAiredRadioShowsAggregateArgs = {
  where?: InputMaybe<AiredRadioShowWhere>;
};


export type QueryAiredRadioShowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AiredRadioShowSort>>>;
  where?: InputMaybe<AiredRadioShowWhere>;
};


export type QueryBannersArgs = {
  options?: InputMaybe<BannerOptions>;
  where?: InputMaybe<BannerWhere>;
};


export type QueryBannersAggregateArgs = {
  where?: InputMaybe<BannerWhere>;
};


export type QueryBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BannerSort>>>;
  where?: InputMaybe<BannerWhere>;
};


export type QueryCanEditPostArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type QueryCategoriesAggregateArgs = {
  where?: InputMaybe<CategoryWhere>;
};


export type QueryCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CategorySort>>>;
  where?: InputMaybe<CategoryWhere>;
};


export type QueryCommercialBreakSchedulesArgs = {
  options?: InputMaybe<CommercialBreakScheduleOptions>;
  where?: InputMaybe<CommercialBreakScheduleWhere>;
};


export type QueryCommercialBreakSchedulesAggregateArgs = {
  where?: InputMaybe<CommercialBreakScheduleWhere>;
};


export type QueryCommercialBreakSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CommercialBreakScheduleSort>>>;
  where?: InputMaybe<CommercialBreakScheduleWhere>;
};


export type QueryCreateAppkeyResponsesArgs = {
  options?: InputMaybe<CreateAppkeyResponseOptions>;
  where?: InputMaybe<CreateAppkeyResponseWhere>;
};


export type QueryCreateAppkeyResponsesAggregateArgs = {
  where?: InputMaybe<CreateAppkeyResponseWhere>;
};


export type QueryCreateAppkeyResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CreateAppkeyResponseSort>>>;
  where?: InputMaybe<CreateAppkeyResponseWhere>;
};


export type QueryDeadlinesArgs = {
  options?: InputMaybe<DeadlineOptions>;
  where?: InputMaybe<DeadlineWhere>;
};


export type QueryDeadlinesAggregateArgs = {
  where?: InputMaybe<DeadlineWhere>;
};


export type QueryDeadlinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DeadlineSort>>>;
  where?: InputMaybe<DeadlineWhere>;
};


export type QueryFanGalleryItemsArgs = {
  options?: InputMaybe<FanGalleryItemOptions>;
  where?: InputMaybe<FanGalleryItemWhere>;
};


export type QueryFanGalleryItemsAggregateArgs = {
  where?: InputMaybe<FanGalleryItemWhere>;
};


export type QueryFanGalleryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FanGalleryItemSort>>>;
  where?: InputMaybe<FanGalleryItemWhere>;
};


export type QueryFilesArgs = {
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type QueryFilesAggregateArgs = {
  where?: InputMaybe<FileWhere>;
};


export type QueryFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FileSort>>>;
  where?: InputMaybe<FileWhere>;
};


export type QueryHourlyListenersStatPointsArgs = {
  options?: InputMaybe<HourlyListenersStatPointOptions>;
  where?: InputMaybe<HourlyListenersStatPointWhere>;
};


export type QueryHourlyListenersStatPointsAggregateArgs = {
  where?: InputMaybe<HourlyListenersStatPointWhere>;
};


export type QueryHourlyListenersStatPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<HourlyListenersStatPointSort>>>;
  where?: InputMaybe<HourlyListenersStatPointWhere>;
};


export type QueryIsIpBannedArgs = {
  ip: Scalars['String']['input'];
};


export type QueryMyCategoriesArgs = {
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type QueryMyPostsArgs = {
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type QueryMyRadioShowsArgs = {
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type QueryOurSocialLinksArgs = {
  options?: InputMaybe<OurSocialLinkOptions>;
  where?: InputMaybe<OurSocialLinkWhere>;
};


export type QueryOurSocialLinksAggregateArgs = {
  where?: InputMaybe<OurSocialLinkWhere>;
};


export type QueryOurSocialLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OurSocialLinkSort>>>;
  where?: InputMaybe<OurSocialLinkWhere>;
};


export type QueryPartnersArgs = {
  options?: InputMaybe<PartnerOptions>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPartnersAggregateArgs = {
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartnerSort>>>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPollsArgs = {
  options?: InputMaybe<PollOptions>;
  where?: InputMaybe<PollWhere>;
};


export type QueryPollsAggregateArgs = {
  where?: InputMaybe<PollWhere>;
};


export type QueryPollsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PollSort>>>;
  where?: InputMaybe<PollWhere>;
};


export type QueryPostAbsencesArgs = {
  options?: InputMaybe<PostAbsenceOptions>;
  where?: InputMaybe<PostAbsenceWhere>;
};


export type QueryPostAbsencesAggregateArgs = {
  where?: InputMaybe<PostAbsenceWhere>;
};


export type QueryPostAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PostAbsenceSort>>>;
  where?: InputMaybe<PostAbsenceWhere>;
};


export type QueryPostSchedulesArgs = {
  options?: InputMaybe<PostScheduleOptions>;
  where?: InputMaybe<PostScheduleWhere>;
};


export type QueryPostSchedulesAggregateArgs = {
  where?: InputMaybe<PostScheduleWhere>;
};


export type QueryPostSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PostScheduleSort>>>;
  where?: InputMaybe<PostScheduleWhere>;
};


export type QueryPostsArgs = {
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type QueryPostsAggregateArgs = {
  where?: InputMaybe<PostWhere>;
};


export type QueryPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PostSort>>>;
  where?: InputMaybe<PostWhere>;
};


export type QueryRadioShowSchedulesArgs = {
  options?: InputMaybe<RadioShowScheduleOptions>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type QueryRadioShowSchedulesAggregateArgs = {
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type QueryRadioShowSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RadioShowScheduleSort>>>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type QueryRadioShowsArgs = {
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type QueryRadioShowsAggregateArgs = {
  where?: InputMaybe<RadioShowWhere>;
};


export type QueryRadioShowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RadioShowSort>>>;
  where?: InputMaybe<RadioShowWhere>;
};


export type QueryRelatedPostsArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryRequestedSongsArgs = {
  options?: InputMaybe<RequestedSongOptions>;
  where?: InputMaybe<RequestedSongWhere>;
};


export type QueryRequestedSongsAggregateArgs = {
  where?: InputMaybe<RequestedSongWhere>;
};


export type QueryRequestedSongsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RequestedSongSort>>>;
  where?: InputMaybe<RequestedSongWhere>;
};


export type QuerySongRequestBannedIpsArgs = {
  options?: InputMaybe<SongRequestBannedIpOptions>;
  where?: InputMaybe<SongRequestBannedIpWhere>;
};


export type QuerySongRequestBannedIpsAggregateArgs = {
  where?: InputMaybe<SongRequestBannedIpWhere>;
};


export type QuerySongRequestBannedIpsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SongRequestBannedIpSort>>>;
  where?: InputMaybe<SongRequestBannedIpWhere>;
};


export type QuerySongRequestsArgs = {
  options?: InputMaybe<SongRequestOptions>;
  where?: InputMaybe<SongRequestWhere>;
};


export type QuerySongRequestsAggregateArgs = {
  where?: InputMaybe<SongRequestWhere>;
};


export type QuerySongRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SongRequestSort>>>;
  where?: InputMaybe<SongRequestWhere>;
};


export type QueryStreamingAbsencesArgs = {
  options?: InputMaybe<StreamingAbsenceOptions>;
  where?: InputMaybe<StreamingAbsenceWhere>;
};


export type QueryStreamingAbsencesAggregateArgs = {
  where?: InputMaybe<StreamingAbsenceWhere>;
};


export type QueryStreamingAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StreamingAbsenceSort>>>;
  where?: InputMaybe<StreamingAbsenceWhere>;
};


export type QueryTagsArgs = {
  options?: InputMaybe<TagOptions>;
  where?: InputMaybe<TagWhere>;
};


export type QueryTagsAggregateArgs = {
  where?: InputMaybe<TagWhere>;
};


export type QueryTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSort>>>;
  where?: InputMaybe<TagWhere>;
};


export type QueryUserAppkeysArgs = {
  options?: InputMaybe<UserAppkeyOptions>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type QueryUserAppkeysAggregateArgs = {
  where?: InputMaybe<UserAppkeyWhere>;
};


export type QueryUserAppkeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserAppkeySort>>>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type QueryUserPasskeysArgs = {
  options?: InputMaybe<UserPasskeyOptions>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type QueryUserPasskeysAggregateArgs = {
  where?: InputMaybe<UserPasskeyWhere>;
};


export type QueryUserPasskeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserPasskeySort>>>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type QueryUsersArgs = {
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QueryUsersAggregateArgs = {
  where?: InputMaybe<UserWhere>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSort>>>;
  where?: InputMaybe<UserWhere>;
};

export type RadioShow = {
  __typename?: 'RadioShow';
  cover: File;
  coverAggregate?: Maybe<RadioShowFileCoverAggregationSelection>;
  coverConnection: RadioShowCoverConnection;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  djs: Array<User>;
  djsAggregate?: Maybe<RadioShowUserDjsAggregationSelection>;
  djsConnection: RadioShowDjsConnection;
  genre: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  schedule: Array<RadioShowSchedule>;
  scheduleAggregate?: Maybe<RadioShowRadioShowScheduleScheduleAggregationSelection>;
  scheduleConnection: RadioShowScheduleConnection;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: RadioShowType;
};


export type RadioShowCoverArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type RadioShowCoverAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type RadioShowCoverConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RadioShowCoverConnectionSort>>;
  where?: InputMaybe<RadioShowCoverConnectionWhere>;
};


export type RadioShowDjsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RadioShowDjsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RadioShowDjsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RadioShowDjsConnectionSort>>;
  where?: InputMaybe<RadioShowDjsConnectionWhere>;
};


export type RadioShowScheduleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RadioShowScheduleOptions>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type RadioShowScheduleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RadioShowScheduleWhere>;
};


export type RadioShowScheduleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RadioShowScheduleConnectionSort>>;
  where?: InputMaybe<RadioShowScheduleConnectionWhere>;
};

export type RadioShowAggregateSelection = {
  __typename?: 'RadioShowAggregateSelection';
  count: Scalars['Int']['output'];
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type RadioShowConnectInput = {
  cover?: InputMaybe<RadioShowCoverConnectFieldInput>;
  djs?: InputMaybe<Array<RadioShowDjsConnectFieldInput>>;
  schedule?: InputMaybe<Array<RadioShowScheduleConnectFieldInput>>;
};

export type RadioShowConnectOrCreateInput = {
  cover?: InputMaybe<RadioShowCoverConnectOrCreateFieldInput>;
  djs?: InputMaybe<Array<RadioShowDjsConnectOrCreateFieldInput>>;
  schedule?: InputMaybe<Array<RadioShowScheduleConnectOrCreateFieldInput>>;
};

export type RadioShowConnectOrCreateWhere = {
  node: RadioShowUniqueWhere;
};

export type RadioShowConnectWhere = {
  node: RadioShowWhere;
};

export type RadioShowCoverAggregateInput = {
  AND?: InputMaybe<Array<RadioShowCoverAggregateInput>>;
  NOT?: InputMaybe<RadioShowCoverAggregateInput>;
  OR?: InputMaybe<Array<RadioShowCoverAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RadioShowCoverNodeAggregationWhereInput>;
};

export type RadioShowCoverConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type RadioShowCoverConnectOrCreateFieldInput = {
  onCreate: RadioShowCoverConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type RadioShowCoverConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type RadioShowCoverConnection = {
  __typename?: 'RadioShowCoverConnection';
  edges: Array<RadioShowCoverRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RadioShowCoverConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type RadioShowCoverConnectionWhere = {
  AND?: InputMaybe<Array<RadioShowCoverConnectionWhere>>;
  NOT?: InputMaybe<RadioShowCoverConnectionWhere>;
  OR?: InputMaybe<Array<RadioShowCoverConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type RadioShowCoverCreateFieldInput = {
  node: FileCreateInput;
};

export type RadioShowCoverDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<RadioShowCoverConnectionWhere>;
};

export type RadioShowCoverDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<RadioShowCoverConnectionWhere>;
};

export type RadioShowCoverFieldInput = {
  connect?: InputMaybe<RadioShowCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<RadioShowCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<RadioShowCoverCreateFieldInput>;
};

export type RadioShowCoverNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RadioShowCoverNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RadioShowCoverNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RadioShowCoverNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowCoverRelationship = {
  __typename?: 'RadioShowCoverRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type RadioShowCoverUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type RadioShowCoverUpdateFieldInput = {
  connect?: InputMaybe<RadioShowCoverConnectFieldInput>;
  connectOrCreate?: InputMaybe<RadioShowCoverConnectOrCreateFieldInput>;
  create?: InputMaybe<RadioShowCoverCreateFieldInput>;
  delete?: InputMaybe<RadioShowCoverDeleteFieldInput>;
  disconnect?: InputMaybe<RadioShowCoverDisconnectFieldInput>;
  update?: InputMaybe<RadioShowCoverUpdateConnectionInput>;
  where?: InputMaybe<RadioShowCoverConnectionWhere>;
};

export type RadioShowCreateInput = {
  cover?: InputMaybe<RadioShowCoverFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  djs?: InputMaybe<RadioShowDjsFieldInput>;
  genre: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  schedule?: InputMaybe<RadioShowScheduleFieldInput>;
  title: Scalars['String']['input'];
  type: RadioShowType;
};

export type RadioShowDeleteInput = {
  cover?: InputMaybe<RadioShowCoverDeleteFieldInput>;
  djs?: InputMaybe<Array<RadioShowDjsDeleteFieldInput>>;
  schedule?: InputMaybe<Array<RadioShowScheduleDeleteFieldInput>>;
};

export type RadioShowDisconnectInput = {
  cover?: InputMaybe<RadioShowCoverDisconnectFieldInput>;
  djs?: InputMaybe<Array<RadioShowDjsDisconnectFieldInput>>;
  schedule?: InputMaybe<Array<RadioShowScheduleDisconnectFieldInput>>;
};

export type RadioShowDjsAggregateInput = {
  AND?: InputMaybe<Array<RadioShowDjsAggregateInput>>;
  NOT?: InputMaybe<RadioShowDjsAggregateInput>;
  OR?: InputMaybe<Array<RadioShowDjsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RadioShowDjsNodeAggregationWhereInput>;
};

export type RadioShowDjsConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type RadioShowDjsConnectOrCreateFieldInput = {
  onCreate: RadioShowDjsConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type RadioShowDjsConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type RadioShowDjsConnection = {
  __typename?: 'RadioShowDjsConnection';
  edges: Array<RadioShowDjsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RadioShowDjsConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type RadioShowDjsConnectionWhere = {
  AND?: InputMaybe<Array<RadioShowDjsConnectionWhere>>;
  NOT?: InputMaybe<RadioShowDjsConnectionWhere>;
  OR?: InputMaybe<Array<RadioShowDjsConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type RadioShowDjsCreateFieldInput = {
  node: UserCreateInput;
};

export type RadioShowDjsDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<RadioShowDjsConnectionWhere>;
};

export type RadioShowDjsDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<RadioShowDjsConnectionWhere>;
};

export type RadioShowDjsFieldInput = {
  connect?: InputMaybe<Array<RadioShowDjsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RadioShowDjsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RadioShowDjsCreateFieldInput>>;
};

export type RadioShowDjsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RadioShowDjsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RadioShowDjsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RadioShowDjsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowDjsRelationship = {
  __typename?: 'RadioShowDjsRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type RadioShowDjsUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type RadioShowDjsUpdateFieldInput = {
  connect?: InputMaybe<Array<RadioShowDjsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RadioShowDjsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RadioShowDjsCreateFieldInput>>;
  delete?: InputMaybe<Array<RadioShowDjsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RadioShowDjsDisconnectFieldInput>>;
  update?: InputMaybe<RadioShowDjsUpdateConnectionInput>;
  where?: InputMaybe<RadioShowDjsConnectionWhere>;
};

export type RadioShowEdge = {
  __typename?: 'RadioShowEdge';
  cursor: Scalars['String']['output'];
  node: RadioShow;
};

export type RadioShowFileCoverAggregationSelection = {
  __typename?: 'RadioShowFileCoverAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RadioShowFileCoverNodeAggregateSelection>;
};

export type RadioShowFileCoverNodeAggregateSelection = {
  __typename?: 'RadioShowFileCoverNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type RadioShowOnCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  genre: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: RadioShowType;
};

export type RadioShowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RadioShowSort objects to sort RadioShows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RadioShowSort>>;
};

export type RadioShowRadioShowScheduleScheduleAggregationSelection = {
  __typename?: 'RadioShowRadioShowScheduleScheduleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RadioShowRadioShowScheduleScheduleNodeAggregateSelection>;
};

export type RadioShowRadioShowScheduleScheduleNodeAggregateSelection = {
  __typename?: 'RadioShowRadioShowScheduleScheduleNodeAggregateSelection';
  days: IntAggregateSelection;
  endDate: IntAggregateSelection;
  endTime: IntAggregateSelection;
  id: IdAggregateSelection;
  startDate: IntAggregateSelection;
  startTime: IntAggregateSelection;
};

export type RadioShowRelationInput = {
  cover?: InputMaybe<RadioShowCoverCreateFieldInput>;
  djs?: InputMaybe<Array<RadioShowDjsCreateFieldInput>>;
  schedule?: InputMaybe<Array<RadioShowScheduleCreateFieldInput>>;
};

export type RadioShowSchedule = {
  __typename?: 'RadioShowSchedule';
  days?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Int']['output']>;
  endTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  radioShow: RadioShow;
  radioShowAggregate?: Maybe<RadioShowScheduleRadioShowRadioShowAggregationSelection>;
  radioShowConnection: RadioShowScheduleRadioShowConnection;
  startDate?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Int']['output'];
};


export type RadioShowScheduleRadioShowArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type RadioShowScheduleRadioShowAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RadioShowWhere>;
};


export type RadioShowScheduleRadioShowConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RadioShowScheduleRadioShowConnectionSort>>;
  where?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
};

export type RadioShowScheduleAggregateInput = {
  AND?: InputMaybe<Array<RadioShowScheduleAggregateInput>>;
  NOT?: InputMaybe<RadioShowScheduleAggregateInput>;
  OR?: InputMaybe<Array<RadioShowScheduleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RadioShowScheduleNodeAggregationWhereInput>;
};

export type RadioShowScheduleAggregateSelection = {
  __typename?: 'RadioShowScheduleAggregateSelection';
  count: Scalars['Int']['output'];
  days: IntAggregateSelection;
  endDate: IntAggregateSelection;
  endTime: IntAggregateSelection;
  id: IdAggregateSelection;
  startDate: IntAggregateSelection;
  startTime: IntAggregateSelection;
};

export type RadioShowScheduleConnectFieldInput = {
  connect?: InputMaybe<Array<RadioShowScheduleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RadioShowScheduleConnectWhere>;
};

export type RadioShowScheduleConnectInput = {
  radioShow?: InputMaybe<RadioShowScheduleRadioShowConnectFieldInput>;
};

export type RadioShowScheduleConnectOrCreateFieldInput = {
  onCreate: RadioShowScheduleConnectOrCreateFieldInputOnCreate;
  where: RadioShowScheduleConnectOrCreateWhere;
};

export type RadioShowScheduleConnectOrCreateFieldInputOnCreate = {
  node: RadioShowScheduleOnCreateInput;
};

export type RadioShowScheduleConnectOrCreateInput = {
  radioShow?: InputMaybe<RadioShowScheduleRadioShowConnectOrCreateFieldInput>;
};

export type RadioShowScheduleConnectOrCreateWhere = {
  node: RadioShowScheduleUniqueWhere;
};

export type RadioShowScheduleConnectWhere = {
  node: RadioShowScheduleWhere;
};

export type RadioShowScheduleConnection = {
  __typename?: 'RadioShowScheduleConnection';
  edges: Array<RadioShowScheduleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RadioShowScheduleConnectionSort = {
  node?: InputMaybe<RadioShowScheduleSort>;
};

export type RadioShowScheduleConnectionWhere = {
  AND?: InputMaybe<Array<RadioShowScheduleConnectionWhere>>;
  NOT?: InputMaybe<RadioShowScheduleConnectionWhere>;
  OR?: InputMaybe<Array<RadioShowScheduleConnectionWhere>>;
  node?: InputMaybe<RadioShowScheduleWhere>;
};

export type RadioShowScheduleCreateFieldInput = {
  node: RadioShowScheduleCreateInput;
};

export type RadioShowScheduleCreateInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endTime: Scalars['Int']['input'];
  radioShow?: InputMaybe<RadioShowScheduleRadioShowFieldInput>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['Int']['input'];
};

export type RadioShowScheduleDeleteFieldInput = {
  delete?: InputMaybe<RadioShowScheduleDeleteInput>;
  where?: InputMaybe<RadioShowScheduleConnectionWhere>;
};

export type RadioShowScheduleDeleteInput = {
  radioShow?: InputMaybe<RadioShowScheduleRadioShowDeleteFieldInput>;
};

export type RadioShowScheduleDisconnectFieldInput = {
  disconnect?: InputMaybe<RadioShowScheduleDisconnectInput>;
  where?: InputMaybe<RadioShowScheduleConnectionWhere>;
};

export type RadioShowScheduleDisconnectInput = {
  radioShow?: InputMaybe<RadioShowScheduleRadioShowDisconnectFieldInput>;
};

export type RadioShowScheduleEdge = {
  __typename?: 'RadioShowScheduleEdge';
  cursor: Scalars['String']['output'];
  node: RadioShowSchedule;
};

export type RadioShowScheduleFieldInput = {
  connect?: InputMaybe<Array<RadioShowScheduleConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RadioShowScheduleConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RadioShowScheduleCreateFieldInput>>;
};

export type RadioShowScheduleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RadioShowScheduleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RadioShowScheduleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RadioShowScheduleNodeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endDate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endDate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endDate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endDate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endDate_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  endDate_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  endDate_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endTime_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endTime_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endTime_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endTime_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endTime_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endTime_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  endTime_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  endTime_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endTime_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  endTime_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  endTime_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endTime_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  endTime_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  endTime_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  startDate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  startDate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  startDate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startDate_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  startDate_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  startDate_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  startTime_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  startTime_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  startTime_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  startTime_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  startTime_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startTime_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  startTime_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  startTime_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startTime_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  startTime_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  startTime_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startTime_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  startTime_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  startTime_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowScheduleOnCreateInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endTime: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['Int']['input'];
};

export type RadioShowScheduleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RadioShowScheduleSort objects to sort RadioShowSchedules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RadioShowScheduleSort>>;
};

export type RadioShowScheduleRadioShowAggregateInput = {
  AND?: InputMaybe<Array<RadioShowScheduleRadioShowAggregateInput>>;
  NOT?: InputMaybe<RadioShowScheduleRadioShowAggregateInput>;
  OR?: InputMaybe<Array<RadioShowScheduleRadioShowAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RadioShowScheduleRadioShowNodeAggregationWhereInput>;
};

export type RadioShowScheduleRadioShowConnectFieldInput = {
  connect?: InputMaybe<RadioShowConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RadioShowConnectWhere>;
};

export type RadioShowScheduleRadioShowConnectOrCreateFieldInput = {
  onCreate: RadioShowScheduleRadioShowConnectOrCreateFieldInputOnCreate;
  where: RadioShowConnectOrCreateWhere;
};

export type RadioShowScheduleRadioShowConnectOrCreateFieldInputOnCreate = {
  node: RadioShowOnCreateInput;
};

export type RadioShowScheduleRadioShowConnection = {
  __typename?: 'RadioShowScheduleRadioShowConnection';
  edges: Array<RadioShowScheduleRadioShowRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RadioShowScheduleRadioShowConnectionSort = {
  node?: InputMaybe<RadioShowSort>;
};

export type RadioShowScheduleRadioShowConnectionWhere = {
  AND?: InputMaybe<Array<RadioShowScheduleRadioShowConnectionWhere>>;
  NOT?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
  OR?: InputMaybe<Array<RadioShowScheduleRadioShowConnectionWhere>>;
  node?: InputMaybe<RadioShowWhere>;
};

export type RadioShowScheduleRadioShowCreateFieldInput = {
  node: RadioShowCreateInput;
};

export type RadioShowScheduleRadioShowDeleteFieldInput = {
  delete?: InputMaybe<RadioShowDeleteInput>;
  where?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
};

export type RadioShowScheduleRadioShowDisconnectFieldInput = {
  disconnect?: InputMaybe<RadioShowDisconnectInput>;
  where?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
};

export type RadioShowScheduleRadioShowFieldInput = {
  connect?: InputMaybe<RadioShowScheduleRadioShowConnectFieldInput>;
  connectOrCreate?: InputMaybe<RadioShowScheduleRadioShowConnectOrCreateFieldInput>;
  create?: InputMaybe<RadioShowScheduleRadioShowCreateFieldInput>;
};

export type RadioShowScheduleRadioShowNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RadioShowScheduleRadioShowNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RadioShowScheduleRadioShowNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RadioShowScheduleRadioShowNodeAggregationWhereInput>>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowScheduleRadioShowRadioShowAggregationSelection = {
  __typename?: 'RadioShowScheduleRadioShowRadioShowAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RadioShowScheduleRadioShowRadioShowNodeAggregateSelection>;
};

export type RadioShowScheduleRadioShowRadioShowNodeAggregateSelection = {
  __typename?: 'RadioShowScheduleRadioShowRadioShowNodeAggregateSelection';
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type RadioShowScheduleRadioShowRelationship = {
  __typename?: 'RadioShowScheduleRadioShowRelationship';
  cursor: Scalars['String']['output'];
  node: RadioShow;
};

export type RadioShowScheduleRadioShowUpdateConnectionInput = {
  node?: InputMaybe<RadioShowUpdateInput>;
};

export type RadioShowScheduleRadioShowUpdateFieldInput = {
  connect?: InputMaybe<RadioShowScheduleRadioShowConnectFieldInput>;
  connectOrCreate?: InputMaybe<RadioShowScheduleRadioShowConnectOrCreateFieldInput>;
  create?: InputMaybe<RadioShowScheduleRadioShowCreateFieldInput>;
  delete?: InputMaybe<RadioShowScheduleRadioShowDeleteFieldInput>;
  disconnect?: InputMaybe<RadioShowScheduleRadioShowDisconnectFieldInput>;
  update?: InputMaybe<RadioShowScheduleRadioShowUpdateConnectionInput>;
  where?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
};

export type RadioShowScheduleRelationInput = {
  radioShow?: InputMaybe<RadioShowScheduleRadioShowCreateFieldInput>;
};

export type RadioShowScheduleRelationship = {
  __typename?: 'RadioShowScheduleRelationship';
  cursor: Scalars['String']['output'];
  node: RadioShowSchedule;
};

/** Fields to sort RadioShowSchedules by. The order in which sorts are applied is not guaranteed when specifying many fields in one RadioShowScheduleSort object. */
export type RadioShowScheduleSort = {
  days?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  endTime?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  startTime?: InputMaybe<SortDirection>;
};

export type RadioShowScheduleUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RadioShowScheduleUpdateConnectionInput = {
  node?: InputMaybe<RadioShowScheduleUpdateInput>;
};

export type RadioShowScheduleUpdateFieldInput = {
  connect?: InputMaybe<Array<RadioShowScheduleConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RadioShowScheduleConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RadioShowScheduleCreateFieldInput>>;
  delete?: InputMaybe<Array<RadioShowScheduleDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RadioShowScheduleDisconnectFieldInput>>;
  update?: InputMaybe<RadioShowScheduleUpdateConnectionInput>;
  where?: InputMaybe<RadioShowScheduleConnectionWhere>;
};

export type RadioShowScheduleUpdateInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  days_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  days_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endDate_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  endDate_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  endTime_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  endTime_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  radioShow?: InputMaybe<RadioShowScheduleRadioShowUpdateFieldInput>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startDate_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  startDate_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  startTime_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  startTime_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowScheduleWhere = {
  AND?: InputMaybe<Array<RadioShowScheduleWhere>>;
  NOT?: InputMaybe<RadioShowScheduleWhere>;
  OR?: InputMaybe<Array<RadioShowScheduleWhere>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  endDate_GT?: InputMaybe<Scalars['Int']['input']>;
  endDate_GTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate_LT?: InputMaybe<Scalars['Int']['input']>;
  endDate_LTE?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  endTime_GT?: InputMaybe<Scalars['Int']['input']>;
  endTime_GTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  endTime_LT?: InputMaybe<Scalars['Int']['input']>;
  endTime_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  radioShow?: InputMaybe<RadioShowWhere>;
  radioShowAggregate?: InputMaybe<RadioShowScheduleRadioShowAggregateInput>;
  radioShowConnection?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
  radioShowConnection_NOT?: InputMaybe<RadioShowScheduleRadioShowConnectionWhere>;
  radioShow_NOT?: InputMaybe<RadioShowWhere>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  startDate_GT?: InputMaybe<Scalars['Int']['input']>;
  startDate_GTE?: InputMaybe<Scalars['Int']['input']>;
  startDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate_LT?: InputMaybe<Scalars['Int']['input']>;
  startDate_LTE?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  startTime_GT?: InputMaybe<Scalars['Int']['input']>;
  startTime_GTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  startTime_LT?: InputMaybe<Scalars['Int']['input']>;
  startTime_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RadioShowSchedulesConnection = {
  __typename?: 'RadioShowSchedulesConnection';
  edges: Array<RadioShowScheduleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort RadioShows by. The order in which sorts are applied is not guaranteed when specifying many fields in one RadioShowSort object. */
export type RadioShowSort = {
  deletedAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  genre?: InputMaybe<SortDirection>;
  hidden?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  slug?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum RadioShowType {
  FreeLive = 'FREE_LIVE',
  Live = 'LIVE',
  Playlist = 'PLAYLIST',
  Podcast = 'PODCAST'
}

export type RadioShowUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type RadioShowUpdateInput = {
  cover?: InputMaybe<RadioShowCoverUpdateFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  djs?: InputMaybe<Array<RadioShowDjsUpdateFieldInput>>;
  genre?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<Array<RadioShowScheduleUpdateFieldInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RadioShowType>;
};

export type RadioShowUserDjsAggregationSelection = {
  __typename?: 'RadioShowUserDjsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RadioShowUserDjsNodeAggregateSelection>;
};

export type RadioShowUserDjsNodeAggregateSelection = {
  __typename?: 'RadioShowUserDjsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type RadioShowWhere = {
  AND?: InputMaybe<Array<RadioShowWhere>>;
  NOT?: InputMaybe<RadioShowWhere>;
  OR?: InputMaybe<Array<RadioShowWhere>>;
  cover?: InputMaybe<FileWhere>;
  coverAggregate?: InputMaybe<RadioShowCoverAggregateInput>;
  coverConnection?: InputMaybe<RadioShowCoverConnectionWhere>;
  coverConnection_NOT?: InputMaybe<RadioShowCoverConnectionWhere>;
  cover_NOT?: InputMaybe<FileWhere>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  djsAggregate?: InputMaybe<RadioShowDjsAggregateInput>;
  /** Return RadioShows where all of the related RadioShowDjsConnections match this filter */
  djsConnection_ALL?: InputMaybe<RadioShowDjsConnectionWhere>;
  /** Return RadioShows where none of the related RadioShowDjsConnections match this filter */
  djsConnection_NONE?: InputMaybe<RadioShowDjsConnectionWhere>;
  /** Return RadioShows where one of the related RadioShowDjsConnections match this filter */
  djsConnection_SINGLE?: InputMaybe<RadioShowDjsConnectionWhere>;
  /** Return RadioShows where some of the related RadioShowDjsConnections match this filter */
  djsConnection_SOME?: InputMaybe<RadioShowDjsConnectionWhere>;
  /** Return RadioShows where all of the related Users match this filter */
  djs_ALL?: InputMaybe<UserWhere>;
  /** Return RadioShows where none of the related Users match this filter */
  djs_NONE?: InputMaybe<UserWhere>;
  /** Return RadioShows where one of the related Users match this filter */
  djs_SINGLE?: InputMaybe<UserWhere>;
  /** Return RadioShows where some of the related Users match this filter */
  djs_SOME?: InputMaybe<UserWhere>;
  genre?: InputMaybe<Scalars['String']['input']>;
  genre_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  genre_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  genre_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  genre_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  scheduleAggregate?: InputMaybe<RadioShowScheduleAggregateInput>;
  /** Return RadioShows where all of the related RadioShowScheduleConnections match this filter */
  scheduleConnection_ALL?: InputMaybe<RadioShowScheduleConnectionWhere>;
  /** Return RadioShows where none of the related RadioShowScheduleConnections match this filter */
  scheduleConnection_NONE?: InputMaybe<RadioShowScheduleConnectionWhere>;
  /** Return RadioShows where one of the related RadioShowScheduleConnections match this filter */
  scheduleConnection_SINGLE?: InputMaybe<RadioShowScheduleConnectionWhere>;
  /** Return RadioShows where some of the related RadioShowScheduleConnections match this filter */
  scheduleConnection_SOME?: InputMaybe<RadioShowScheduleConnectionWhere>;
  /** Return RadioShows where all of the related RadioShowSchedules match this filter */
  schedule_ALL?: InputMaybe<RadioShowScheduleWhere>;
  /** Return RadioShows where none of the related RadioShowSchedules match this filter */
  schedule_NONE?: InputMaybe<RadioShowScheduleWhere>;
  /** Return RadioShows where one of the related RadioShowSchedules match this filter */
  schedule_SINGLE?: InputMaybe<RadioShowScheduleWhere>;
  /** Return RadioShows where some of the related RadioShowSchedules match this filter */
  schedule_SOME?: InputMaybe<RadioShowScheduleWhere>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  slug_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RadioShowType>;
  type_IN?: InputMaybe<Array<RadioShowType>>;
};

export type RadioShowsConnection = {
  __typename?: 'RadioShowsConnection';
  edges: Array<RadioShowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RequestedSong = {
  __typename?: 'RequestedSong';
  album?: Maybe<Scalars['String']['output']>;
  artist?: Maybe<Scalars['String']['output']>;
  cover: Scalars['String']['output'];
  previousRank: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type RequestedSongAggregateSelection = {
  __typename?: 'RequestedSongAggregateSelection';
  album: StringAggregateSelection;
  artist: StringAggregateSelection;
  count: Scalars['Int']['output'];
  cover: StringAggregateSelection;
  previousRank: IntAggregateSelection;
  rank: IntAggregateSelection;
  title: StringAggregateSelection;
};

export type RequestedSongEdge = {
  __typename?: 'RequestedSongEdge';
  cursor: Scalars['String']['output'];
  node: RequestedSong;
};

export type RequestedSongOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RequestedSongSort objects to sort RequestedSongs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RequestedSongSort>>;
};

/** Fields to sort RequestedSongs by. The order in which sorts are applied is not guaranteed when specifying many fields in one RequestedSongSort object. */
export type RequestedSongSort = {
  album?: InputMaybe<SortDirection>;
  artist?: InputMaybe<SortDirection>;
  cover?: InputMaybe<SortDirection>;
  previousRank?: InputMaybe<SortDirection>;
  rank?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type RequestedSongWhere = {
  AND?: InputMaybe<Array<RequestedSongWhere>>;
  NOT?: InputMaybe<RequestedSongWhere>;
  OR?: InputMaybe<Array<RequestedSongWhere>>;
  album?: InputMaybe<Scalars['String']['input']>;
  album_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  album_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  album_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  album_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  artist?: InputMaybe<Scalars['String']['input']>;
  artist_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  artist_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  artist_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  artist_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  cover_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cover_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cover_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  cover_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  previousRank?: InputMaybe<Scalars['Int']['input']>;
  previousRank_GT?: InputMaybe<Scalars['Int']['input']>;
  previousRank_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousRank_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  previousRank_LT?: InputMaybe<Scalars['Int']['input']>;
  previousRank_LTE?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rank_GT?: InputMaybe<Scalars['Int']['input']>;
  rank_GTE?: InputMaybe<Scalars['Int']['input']>;
  rank_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  rank_LT?: InputMaybe<Scalars['Int']['input']>;
  rank_LTE?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RequestedSongsConnection = {
  __typename?: 'RequestedSongsConnection';
  edges: Array<RequestedSongEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SaveSongRequestInput = {
  file: Scalars['String']['input'];
  fileMeta: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rid: Scalars['Int']['input'];
  time: Scalars['DateTime']['input'];
};

export type SendMessageInput = {
  body: Scalars['String']['input'];
  recipients: Array<UserRole>;
  subject: Scalars['String']['input'];
};

export type ShedPostRevisionInput = {
  id: Scalars['ID']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialType {
  Bluesky = 'BLUESKY',
  Custom = 'CUSTOM',
  Deviantart = 'DEVIANTART',
  Facebook = 'FACEBOOK',
  Flickr = 'FLICKR',
  Github = 'GITHUB',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Psn = 'PSN',
  Skype = 'SKYPE',
  Soundcloud = 'SOUNDCLOUD',
  Steam = 'STEAM',
  Tiktok = 'TIKTOK',
  Tumblr = 'TUMBLR',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  XboxLive = 'XBOX_LIVE',
  Youtube = 'YOUTUBE'
}

export type SongRequest = {
  __typename?: 'SongRequest';
  author: Scalars['String']['output'];
  box: SongRequestBox;
  createdAt: Scalars['DateTime']['output'];
  forDj?: Maybe<User>;
  forDjAggregate?: Maybe<SongRequestUserForDjAggregationSelection>;
  forDjConnection: SongRequestForDjConnection;
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  song?: Maybe<Scalars['String']['output']>;
};


export type SongRequestForDjArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SongRequestForDjAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SongRequestForDjConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SongRequestForDjConnectionSort>>;
  where?: InputMaybe<SongRequestForDjConnectionWhere>;
};

export type SongRequestAggregateSelection = {
  __typename?: 'SongRequestAggregateSelection';
  author: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  ip: StringAggregateSelection;
  message: StringAggregateSelection;
  readAt: DateTimeAggregateSelection;
  song: StringAggregateSelection;
};

export type SongRequestBannedIp = {
  __typename?: 'SongRequestBannedIp';
  bannedBy: User;
  bannedByAggregate?: Maybe<SongRequestBannedIpUserBannedByAggregationSelection>;
  bannedByConnection: SongRequestBannedIpBannedByConnection;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  mask?: Maybe<Scalars['Int']['output']>;
};


export type SongRequestBannedIpBannedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SongRequestBannedIpBannedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SongRequestBannedIpBannedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SongRequestBannedIpBannedByConnectionSort>>;
  where?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
};

export type SongRequestBannedIpAggregateSelection = {
  __typename?: 'SongRequestBannedIpAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  ip: StringAggregateSelection;
  mask: IntAggregateSelection;
};

export type SongRequestBannedIpBannedByAggregateInput = {
  AND?: InputMaybe<Array<SongRequestBannedIpBannedByAggregateInput>>;
  NOT?: InputMaybe<SongRequestBannedIpBannedByAggregateInput>;
  OR?: InputMaybe<Array<SongRequestBannedIpBannedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SongRequestBannedIpBannedByNodeAggregationWhereInput>;
};

export type SongRequestBannedIpBannedByConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type SongRequestBannedIpBannedByConnectOrCreateFieldInput = {
  onCreate: SongRequestBannedIpBannedByConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type SongRequestBannedIpBannedByConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type SongRequestBannedIpBannedByConnection = {
  __typename?: 'SongRequestBannedIpBannedByConnection';
  edges: Array<SongRequestBannedIpBannedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SongRequestBannedIpBannedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SongRequestBannedIpBannedByConnectionWhere = {
  AND?: InputMaybe<Array<SongRequestBannedIpBannedByConnectionWhere>>;
  NOT?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
  OR?: InputMaybe<Array<SongRequestBannedIpBannedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SongRequestBannedIpBannedByCreateFieldInput = {
  node: UserCreateInput;
};

export type SongRequestBannedIpBannedByDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
};

export type SongRequestBannedIpBannedByDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
};

export type SongRequestBannedIpBannedByFieldInput = {
  connect?: InputMaybe<SongRequestBannedIpBannedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<SongRequestBannedIpBannedByConnectOrCreateFieldInput>;
  create?: InputMaybe<SongRequestBannedIpBannedByCreateFieldInput>;
};

export type SongRequestBannedIpBannedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SongRequestBannedIpBannedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SongRequestBannedIpBannedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SongRequestBannedIpBannedByNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SongRequestBannedIpBannedByRelationship = {
  __typename?: 'SongRequestBannedIpBannedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SongRequestBannedIpBannedByUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type SongRequestBannedIpBannedByUpdateFieldInput = {
  connect?: InputMaybe<SongRequestBannedIpBannedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<SongRequestBannedIpBannedByConnectOrCreateFieldInput>;
  create?: InputMaybe<SongRequestBannedIpBannedByCreateFieldInput>;
  delete?: InputMaybe<SongRequestBannedIpBannedByDeleteFieldInput>;
  disconnect?: InputMaybe<SongRequestBannedIpBannedByDisconnectFieldInput>;
  update?: InputMaybe<SongRequestBannedIpBannedByUpdateConnectionInput>;
  where?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
};

export type SongRequestBannedIpConnectInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByConnectFieldInput>;
};

export type SongRequestBannedIpConnectOrCreateInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByConnectOrCreateFieldInput>;
};

export type SongRequestBannedIpCreateInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByFieldInput>;
  ip: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['Int']['input']>;
};

export type SongRequestBannedIpDeleteInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByDeleteFieldInput>;
};

export type SongRequestBannedIpDisconnectInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByDisconnectFieldInput>;
};

export type SongRequestBannedIpEdge = {
  __typename?: 'SongRequestBannedIpEdge';
  cursor: Scalars['String']['output'];
  node: SongRequestBannedIp;
};

export type SongRequestBannedIpOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SongRequestBannedIpSort objects to sort SongRequestBannedIps by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SongRequestBannedIpSort>>;
};

export type SongRequestBannedIpRelationInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByCreateFieldInput>;
};

/** Fields to sort SongRequestBannedIps by. The order in which sorts are applied is not guaranteed when specifying many fields in one SongRequestBannedIpSort object. */
export type SongRequestBannedIpSort = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  ip?: InputMaybe<SortDirection>;
  mask?: InputMaybe<SortDirection>;
};

export type SongRequestBannedIpUpdateInput = {
  bannedBy?: InputMaybe<SongRequestBannedIpBannedByUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  mask?: InputMaybe<Scalars['Int']['input']>;
  mask_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  mask_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type SongRequestBannedIpUserBannedByAggregationSelection = {
  __typename?: 'SongRequestBannedIpUserBannedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SongRequestBannedIpUserBannedByNodeAggregateSelection>;
};

export type SongRequestBannedIpUserBannedByNodeAggregateSelection = {
  __typename?: 'SongRequestBannedIpUserBannedByNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type SongRequestBannedIpWhere = {
  AND?: InputMaybe<Array<SongRequestBannedIpWhere>>;
  NOT?: InputMaybe<SongRequestBannedIpWhere>;
  OR?: InputMaybe<Array<SongRequestBannedIpWhere>>;
  bannedBy?: InputMaybe<UserWhere>;
  bannedByAggregate?: InputMaybe<SongRequestBannedIpBannedByAggregateInput>;
  bannedByConnection?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
  bannedByConnection_NOT?: InputMaybe<SongRequestBannedIpBannedByConnectionWhere>;
  bannedBy_NOT?: InputMaybe<UserWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ip_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ip_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ip_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  ip_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mask?: InputMaybe<Scalars['Int']['input']>;
  mask_GT?: InputMaybe<Scalars['Int']['input']>;
  mask_GTE?: InputMaybe<Scalars['Int']['input']>;
  mask_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mask_LT?: InputMaybe<Scalars['Int']['input']>;
  mask_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SongRequestBannedIpsConnection = {
  __typename?: 'SongRequestBannedIpsConnection';
  edges: Array<SongRequestBannedIpEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SongRequestBox {
  Archived = 'ARCHIVED',
  Default = 'DEFAULT',
  Read = 'READ'
}

export type SongRequestConnectInput = {
  forDj?: InputMaybe<SongRequestForDjConnectFieldInput>;
};

export type SongRequestConnectOrCreateInput = {
  forDj?: InputMaybe<SongRequestForDjConnectOrCreateFieldInput>;
};

export type SongRequestConnectOrCreateWhere = {
  node: SongRequestUniqueWhere;
};

export type SongRequestConnectWhere = {
  node: SongRequestWhere;
};

export type SongRequestCreateInput = {
  author: Scalars['String']['input'];
  box: SongRequestBox;
  forDj?: InputMaybe<SongRequestForDjFieldInput>;
  ip: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  song?: InputMaybe<Scalars['String']['input']>;
};

export type SongRequestDeleteInput = {
  forDj?: InputMaybe<SongRequestForDjDeleteFieldInput>;
};

export type SongRequestDisconnectInput = {
  forDj?: InputMaybe<SongRequestForDjDisconnectFieldInput>;
};

export type SongRequestEdge = {
  __typename?: 'SongRequestEdge';
  cursor: Scalars['String']['output'];
  node: SongRequest;
};

export type SongRequestForDjAggregateInput = {
  AND?: InputMaybe<Array<SongRequestForDjAggregateInput>>;
  NOT?: InputMaybe<SongRequestForDjAggregateInput>;
  OR?: InputMaybe<Array<SongRequestForDjAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SongRequestForDjNodeAggregationWhereInput>;
};

export type SongRequestForDjConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type SongRequestForDjConnectOrCreateFieldInput = {
  onCreate: SongRequestForDjConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type SongRequestForDjConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type SongRequestForDjConnection = {
  __typename?: 'SongRequestForDjConnection';
  edges: Array<SongRequestForDjRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SongRequestForDjConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SongRequestForDjConnectionWhere = {
  AND?: InputMaybe<Array<SongRequestForDjConnectionWhere>>;
  NOT?: InputMaybe<SongRequestForDjConnectionWhere>;
  OR?: InputMaybe<Array<SongRequestForDjConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SongRequestForDjCreateFieldInput = {
  node: UserCreateInput;
};

export type SongRequestForDjDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<SongRequestForDjConnectionWhere>;
};

export type SongRequestForDjDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<SongRequestForDjConnectionWhere>;
};

export type SongRequestForDjFieldInput = {
  connect?: InputMaybe<SongRequestForDjConnectFieldInput>;
  connectOrCreate?: InputMaybe<SongRequestForDjConnectOrCreateFieldInput>;
  create?: InputMaybe<SongRequestForDjCreateFieldInput>;
};

export type SongRequestForDjNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SongRequestForDjNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SongRequestForDjNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SongRequestForDjNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SongRequestForDjRelationship = {
  __typename?: 'SongRequestForDjRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SongRequestForDjUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type SongRequestForDjUpdateFieldInput = {
  connect?: InputMaybe<SongRequestForDjConnectFieldInput>;
  connectOrCreate?: InputMaybe<SongRequestForDjConnectOrCreateFieldInput>;
  create?: InputMaybe<SongRequestForDjCreateFieldInput>;
  delete?: InputMaybe<SongRequestForDjDeleteFieldInput>;
  disconnect?: InputMaybe<SongRequestForDjDisconnectFieldInput>;
  update?: InputMaybe<SongRequestForDjUpdateConnectionInput>;
  where?: InputMaybe<SongRequestForDjConnectionWhere>;
};

export type SongRequestOnCreateInput = {
  author: Scalars['String']['input'];
  box: SongRequestBox;
  ip: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  song?: InputMaybe<Scalars['String']['input']>;
};

export type SongRequestOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SongRequestSort objects to sort SongRequests by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SongRequestSort>>;
};

export type SongRequestRelationInput = {
  forDj?: InputMaybe<SongRequestForDjCreateFieldInput>;
};

/** Fields to sort SongRequests by. The order in which sorts are applied is not guaranteed when specifying many fields in one SongRequestSort object. */
export type SongRequestSort = {
  author?: InputMaybe<SortDirection>;
  box?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  ip?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  readAt?: InputMaybe<SortDirection>;
  song?: InputMaybe<SortDirection>;
};

export type SongRequestUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SongRequestUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  box?: InputMaybe<SongRequestBox>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forDj?: InputMaybe<SongRequestForDjUpdateFieldInput>;
  ip?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  song?: InputMaybe<Scalars['String']['input']>;
};

export type SongRequestUserForDjAggregationSelection = {
  __typename?: 'SongRequestUserForDjAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SongRequestUserForDjNodeAggregateSelection>;
};

export type SongRequestUserForDjNodeAggregateSelection = {
  __typename?: 'SongRequestUserForDjNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type SongRequestWhere = {
  AND?: InputMaybe<Array<SongRequestWhere>>;
  NOT?: InputMaybe<SongRequestWhere>;
  OR?: InputMaybe<Array<SongRequestWhere>>;
  author?: InputMaybe<Scalars['String']['input']>;
  author_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  author_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  author_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  author_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  box?: InputMaybe<SongRequestBox>;
  box_IN?: InputMaybe<Array<SongRequestBox>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  forDj?: InputMaybe<UserWhere>;
  forDjAggregate?: InputMaybe<SongRequestForDjAggregateInput>;
  forDjConnection?: InputMaybe<SongRequestForDjConnectionWhere>;
  forDjConnection_NOT?: InputMaybe<SongRequestForDjConnectionWhere>;
  forDj_NOT?: InputMaybe<UserWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ip_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ip_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ip_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  ip_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  readAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  song?: InputMaybe<Scalars['String']['input']>;
  song_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  song_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  song_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  song_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SongRequestsConnection = {
  __typename?: 'SongRequestsConnection';
  edges: Array<SongRequestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export type StreamingAbsence = {
  __typename?: 'StreamingAbsence';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<StreamingAbsenceUserCreatedByAggregationSelection>;
  createdByConnection: StreamingAbsenceCreatedByConnection;
  date: Scalars['Date']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  justification?: Maybe<Scalars['String']['output']>;
  radioShow: RadioShow;
  radioShowAggregate?: Maybe<StreamingAbsenceRadioShowRadioShowAggregationSelection>;
  radioShowConnection: StreamingAbsenceRadioShowConnection;
  replacementDj?: Maybe<User>;
  replacementDjAggregate?: Maybe<StreamingAbsenceUserReplacementDjAggregationSelection>;
  replacementDjConnection: StreamingAbsenceReplacementDjConnection;
  startTime: Scalars['Int']['output'];
  user: User;
  userAggregate?: Maybe<StreamingAbsenceUserUserAggregationSelection>;
  userConnection: StreamingAbsenceUserConnection;
};


export type StreamingAbsenceCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StreamingAbsenceCreatedByConnectionSort>>;
  where?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
};


export type StreamingAbsenceRadioShowArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type StreamingAbsenceRadioShowAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RadioShowWhere>;
};


export type StreamingAbsenceRadioShowConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StreamingAbsenceRadioShowConnectionSort>>;
  where?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
};


export type StreamingAbsenceReplacementDjArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceReplacementDjAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceReplacementDjConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StreamingAbsenceReplacementDjConnectionSort>>;
  where?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
};


export type StreamingAbsenceUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type StreamingAbsenceUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StreamingAbsenceUserConnectionSort>>;
  where?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
};

export type StreamingAbsenceAggregateSelection = {
  __typename?: 'StreamingAbsenceAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  endTime: IntAggregateSelection;
  id: IdAggregateSelection;
  justification: StringAggregateSelection;
  startTime: IntAggregateSelection;
};

export type StreamingAbsenceConnectInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByConnectFieldInput>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowConnectFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjConnectFieldInput>;
  user?: InputMaybe<StreamingAbsenceUserConnectFieldInput>;
};

export type StreamingAbsenceConnectOrCreateInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByConnectOrCreateFieldInput>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowConnectOrCreateFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjConnectOrCreateFieldInput>;
  user?: InputMaybe<StreamingAbsenceUserConnectOrCreateFieldInput>;
};

export type StreamingAbsenceCreateInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByFieldInput>;
  date: Scalars['Date']['input'];
  endTime: Scalars['Int']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjFieldInput>;
  startTime: Scalars['Int']['input'];
  user?: InputMaybe<StreamingAbsenceUserFieldInput>;
};

export type StreamingAbsenceCreatedByAggregateInput = {
  AND?: InputMaybe<Array<StreamingAbsenceCreatedByAggregateInput>>;
  NOT?: InputMaybe<StreamingAbsenceCreatedByAggregateInput>;
  OR?: InputMaybe<Array<StreamingAbsenceCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<StreamingAbsenceCreatedByNodeAggregationWhereInput>;
};

export type StreamingAbsenceCreatedByConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type StreamingAbsenceCreatedByConnectOrCreateFieldInput = {
  onCreate: StreamingAbsenceCreatedByConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type StreamingAbsenceCreatedByConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type StreamingAbsenceCreatedByConnection = {
  __typename?: 'StreamingAbsenceCreatedByConnection';
  edges: Array<StreamingAbsenceCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StreamingAbsenceCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type StreamingAbsenceCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<StreamingAbsenceCreatedByConnectionWhere>>;
  NOT?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<StreamingAbsenceCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type StreamingAbsenceCreatedByCreateFieldInput = {
  node: UserCreateInput;
};

export type StreamingAbsenceCreatedByDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
};

export type StreamingAbsenceCreatedByDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
};

export type StreamingAbsenceCreatedByFieldInput = {
  connect?: InputMaybe<StreamingAbsenceCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceCreatedByCreateFieldInput>;
};

export type StreamingAbsenceCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<StreamingAbsenceCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<StreamingAbsenceCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<StreamingAbsenceCreatedByNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamingAbsenceCreatedByRelationship = {
  __typename?: 'StreamingAbsenceCreatedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type StreamingAbsenceCreatedByUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type StreamingAbsenceCreatedByUpdateFieldInput = {
  connect?: InputMaybe<StreamingAbsenceCreatedByConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceCreatedByConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceCreatedByCreateFieldInput>;
  delete?: InputMaybe<StreamingAbsenceCreatedByDeleteFieldInput>;
  disconnect?: InputMaybe<StreamingAbsenceCreatedByDisconnectFieldInput>;
  update?: InputMaybe<StreamingAbsenceCreatedByUpdateConnectionInput>;
  where?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
};

export type StreamingAbsenceDeleteInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByDeleteFieldInput>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowDeleteFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjDeleteFieldInput>;
  user?: InputMaybe<StreamingAbsenceUserDeleteFieldInput>;
};

export type StreamingAbsenceDisconnectInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByDisconnectFieldInput>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowDisconnectFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjDisconnectFieldInput>;
  user?: InputMaybe<StreamingAbsenceUserDisconnectFieldInput>;
};

export type StreamingAbsenceEdge = {
  __typename?: 'StreamingAbsenceEdge';
  cursor: Scalars['String']['output'];
  node: StreamingAbsence;
};

export type StreamingAbsenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more StreamingAbsenceSort objects to sort StreamingAbsences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<StreamingAbsenceSort>>;
};

export type StreamingAbsenceRadioShowAggregateInput = {
  AND?: InputMaybe<Array<StreamingAbsenceRadioShowAggregateInput>>;
  NOT?: InputMaybe<StreamingAbsenceRadioShowAggregateInput>;
  OR?: InputMaybe<Array<StreamingAbsenceRadioShowAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<StreamingAbsenceRadioShowNodeAggregationWhereInput>;
};

export type StreamingAbsenceRadioShowConnectFieldInput = {
  connect?: InputMaybe<RadioShowConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RadioShowConnectWhere>;
};

export type StreamingAbsenceRadioShowConnectOrCreateFieldInput = {
  onCreate: StreamingAbsenceRadioShowConnectOrCreateFieldInputOnCreate;
  where: RadioShowConnectOrCreateWhere;
};

export type StreamingAbsenceRadioShowConnectOrCreateFieldInputOnCreate = {
  node: RadioShowOnCreateInput;
};

export type StreamingAbsenceRadioShowConnection = {
  __typename?: 'StreamingAbsenceRadioShowConnection';
  edges: Array<StreamingAbsenceRadioShowRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StreamingAbsenceRadioShowConnectionSort = {
  node?: InputMaybe<RadioShowSort>;
};

export type StreamingAbsenceRadioShowConnectionWhere = {
  AND?: InputMaybe<Array<StreamingAbsenceRadioShowConnectionWhere>>;
  NOT?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
  OR?: InputMaybe<Array<StreamingAbsenceRadioShowConnectionWhere>>;
  node?: InputMaybe<RadioShowWhere>;
};

export type StreamingAbsenceRadioShowCreateFieldInput = {
  node: RadioShowCreateInput;
};

export type StreamingAbsenceRadioShowDeleteFieldInput = {
  delete?: InputMaybe<RadioShowDeleteInput>;
  where?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
};

export type StreamingAbsenceRadioShowDisconnectFieldInput = {
  disconnect?: InputMaybe<RadioShowDisconnectInput>;
  where?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
};

export type StreamingAbsenceRadioShowFieldInput = {
  connect?: InputMaybe<StreamingAbsenceRadioShowConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceRadioShowConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceRadioShowCreateFieldInput>;
};

export type StreamingAbsenceRadioShowNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<StreamingAbsenceRadioShowNodeAggregationWhereInput>>;
  NOT?: InputMaybe<StreamingAbsenceRadioShowNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<StreamingAbsenceRadioShowNodeAggregationWhereInput>>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamingAbsenceRadioShowRadioShowAggregationSelection = {
  __typename?: 'StreamingAbsenceRadioShowRadioShowAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<StreamingAbsenceRadioShowRadioShowNodeAggregateSelection>;
};

export type StreamingAbsenceRadioShowRadioShowNodeAggregateSelection = {
  __typename?: 'StreamingAbsenceRadioShowRadioShowNodeAggregateSelection';
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type StreamingAbsenceRadioShowRelationship = {
  __typename?: 'StreamingAbsenceRadioShowRelationship';
  cursor: Scalars['String']['output'];
  node: RadioShow;
};

export type StreamingAbsenceRadioShowUpdateConnectionInput = {
  node?: InputMaybe<RadioShowUpdateInput>;
};

export type StreamingAbsenceRadioShowUpdateFieldInput = {
  connect?: InputMaybe<StreamingAbsenceRadioShowConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceRadioShowConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceRadioShowCreateFieldInput>;
  delete?: InputMaybe<StreamingAbsenceRadioShowDeleteFieldInput>;
  disconnect?: InputMaybe<StreamingAbsenceRadioShowDisconnectFieldInput>;
  update?: InputMaybe<StreamingAbsenceRadioShowUpdateConnectionInput>;
  where?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
};

export type StreamingAbsenceRelationInput = {
  createdBy?: InputMaybe<StreamingAbsenceCreatedByCreateFieldInput>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowCreateFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjCreateFieldInput>;
  user?: InputMaybe<StreamingAbsenceUserCreateFieldInput>;
};

export type StreamingAbsenceReplacementDjAggregateInput = {
  AND?: InputMaybe<Array<StreamingAbsenceReplacementDjAggregateInput>>;
  NOT?: InputMaybe<StreamingAbsenceReplacementDjAggregateInput>;
  OR?: InputMaybe<Array<StreamingAbsenceReplacementDjAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<StreamingAbsenceReplacementDjNodeAggregationWhereInput>;
};

export type StreamingAbsenceReplacementDjConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type StreamingAbsenceReplacementDjConnectOrCreateFieldInput = {
  onCreate: StreamingAbsenceReplacementDjConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type StreamingAbsenceReplacementDjConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type StreamingAbsenceReplacementDjConnection = {
  __typename?: 'StreamingAbsenceReplacementDjConnection';
  edges: Array<StreamingAbsenceReplacementDjRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StreamingAbsenceReplacementDjConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type StreamingAbsenceReplacementDjConnectionWhere = {
  AND?: InputMaybe<Array<StreamingAbsenceReplacementDjConnectionWhere>>;
  NOT?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
  OR?: InputMaybe<Array<StreamingAbsenceReplacementDjConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type StreamingAbsenceReplacementDjCreateFieldInput = {
  node: UserCreateInput;
};

export type StreamingAbsenceReplacementDjDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
};

export type StreamingAbsenceReplacementDjDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
};

export type StreamingAbsenceReplacementDjFieldInput = {
  connect?: InputMaybe<StreamingAbsenceReplacementDjConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceReplacementDjConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceReplacementDjCreateFieldInput>;
};

export type StreamingAbsenceReplacementDjNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<StreamingAbsenceReplacementDjNodeAggregationWhereInput>>;
  NOT?: InputMaybe<StreamingAbsenceReplacementDjNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<StreamingAbsenceReplacementDjNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamingAbsenceReplacementDjRelationship = {
  __typename?: 'StreamingAbsenceReplacementDjRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type StreamingAbsenceReplacementDjUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type StreamingAbsenceReplacementDjUpdateFieldInput = {
  connect?: InputMaybe<StreamingAbsenceReplacementDjConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceReplacementDjConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceReplacementDjCreateFieldInput>;
  delete?: InputMaybe<StreamingAbsenceReplacementDjDeleteFieldInput>;
  disconnect?: InputMaybe<StreamingAbsenceReplacementDjDisconnectFieldInput>;
  update?: InputMaybe<StreamingAbsenceReplacementDjUpdateConnectionInput>;
  where?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
};

/** Fields to sort StreamingAbsences by. The order in which sorts are applied is not guaranteed when specifying many fields in one StreamingAbsenceSort object. */
export type StreamingAbsenceSort = {
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  endTime?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  justification?: InputMaybe<SortDirection>;
  startTime?: InputMaybe<SortDirection>;
};

export type StreamingAbsenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<StreamingAbsenceCreatedByUpdateFieldInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  endTime_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  endTime_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  radioShow?: InputMaybe<StreamingAbsenceRadioShowUpdateFieldInput>;
  replacementDj?: InputMaybe<StreamingAbsenceReplacementDjUpdateFieldInput>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  startTime_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  startTime_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<StreamingAbsenceUserUpdateFieldInput>;
};

export type StreamingAbsenceUserAggregateInput = {
  AND?: InputMaybe<Array<StreamingAbsenceUserAggregateInput>>;
  NOT?: InputMaybe<StreamingAbsenceUserAggregateInput>;
  OR?: InputMaybe<Array<StreamingAbsenceUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<StreamingAbsenceUserNodeAggregationWhereInput>;
};

export type StreamingAbsenceUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type StreamingAbsenceUserConnectOrCreateFieldInput = {
  onCreate: StreamingAbsenceUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type StreamingAbsenceUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type StreamingAbsenceUserConnection = {
  __typename?: 'StreamingAbsenceUserConnection';
  edges: Array<StreamingAbsenceUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StreamingAbsenceUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type StreamingAbsenceUserConnectionWhere = {
  AND?: InputMaybe<Array<StreamingAbsenceUserConnectionWhere>>;
  NOT?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
  OR?: InputMaybe<Array<StreamingAbsenceUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type StreamingAbsenceUserCreateFieldInput = {
  node: UserCreateInput;
};

export type StreamingAbsenceUserCreatedByAggregationSelection = {
  __typename?: 'StreamingAbsenceUserCreatedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<StreamingAbsenceUserCreatedByNodeAggregateSelection>;
};

export type StreamingAbsenceUserCreatedByNodeAggregateSelection = {
  __typename?: 'StreamingAbsenceUserCreatedByNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type StreamingAbsenceUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
};

export type StreamingAbsenceUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
};

export type StreamingAbsenceUserFieldInput = {
  connect?: InputMaybe<StreamingAbsenceUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceUserConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceUserCreateFieldInput>;
};

export type StreamingAbsenceUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<StreamingAbsenceUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<StreamingAbsenceUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<StreamingAbsenceUserNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamingAbsenceUserRelationship = {
  __typename?: 'StreamingAbsenceUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type StreamingAbsenceUserReplacementDjAggregationSelection = {
  __typename?: 'StreamingAbsenceUserReplacementDjAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<StreamingAbsenceUserReplacementDjNodeAggregateSelection>;
};

export type StreamingAbsenceUserReplacementDjNodeAggregateSelection = {
  __typename?: 'StreamingAbsenceUserReplacementDjNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type StreamingAbsenceUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type StreamingAbsenceUserUpdateFieldInput = {
  connect?: InputMaybe<StreamingAbsenceUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<StreamingAbsenceUserConnectOrCreateFieldInput>;
  create?: InputMaybe<StreamingAbsenceUserCreateFieldInput>;
  delete?: InputMaybe<StreamingAbsenceUserDeleteFieldInput>;
  disconnect?: InputMaybe<StreamingAbsenceUserDisconnectFieldInput>;
  update?: InputMaybe<StreamingAbsenceUserUpdateConnectionInput>;
  where?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
};

export type StreamingAbsenceUserUserAggregationSelection = {
  __typename?: 'StreamingAbsenceUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<StreamingAbsenceUserUserNodeAggregateSelection>;
};

export type StreamingAbsenceUserUserNodeAggregateSelection = {
  __typename?: 'StreamingAbsenceUserUserNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type StreamingAbsenceWhere = {
  AND?: InputMaybe<Array<StreamingAbsenceWhere>>;
  NOT?: InputMaybe<StreamingAbsenceWhere>;
  OR?: InputMaybe<Array<StreamingAbsenceWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<StreamingAbsenceCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<StreamingAbsenceCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  endTime_GT?: InputMaybe<Scalars['Int']['input']>;
  endTime_GTE?: InputMaybe<Scalars['Int']['input']>;
  endTime_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  endTime_LT?: InputMaybe<Scalars['Int']['input']>;
  endTime_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  justification_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  justification_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  justification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  justification_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  radioShow?: InputMaybe<RadioShowWhere>;
  radioShowAggregate?: InputMaybe<StreamingAbsenceRadioShowAggregateInput>;
  radioShowConnection?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
  radioShowConnection_NOT?: InputMaybe<StreamingAbsenceRadioShowConnectionWhere>;
  radioShow_NOT?: InputMaybe<RadioShowWhere>;
  replacementDj?: InputMaybe<UserWhere>;
  replacementDjAggregate?: InputMaybe<StreamingAbsenceReplacementDjAggregateInput>;
  replacementDjConnection?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
  replacementDjConnection_NOT?: InputMaybe<StreamingAbsenceReplacementDjConnectionWhere>;
  replacementDj_NOT?: InputMaybe<UserWhere>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  startTime_GT?: InputMaybe<Scalars['Int']['input']>;
  startTime_GTE?: InputMaybe<Scalars['Int']['input']>;
  startTime_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  startTime_LT?: InputMaybe<Scalars['Int']['input']>;
  startTime_LTE?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<StreamingAbsenceUserAggregateInput>;
  userConnection?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<StreamingAbsenceUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type StreamingAbsencesConnection = {
  __typename?: 'StreamingAbsencesConnection';
  edges: Array<StreamingAbsenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  revisions: Array<PostRevision>;
  revisionsAggregate?: Maybe<TagPostRevisionRevisionsAggregationSelection>;
  revisionsConnection: TagRevisionsConnection;
  slug: Scalars['String']['output'];
  synonyms: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
};


export type TagRevisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostRevisionOptions>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type TagRevisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostRevisionWhere>;
};


export type TagRevisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TagRevisionsConnectionSort>>;
  where?: InputMaybe<TagRevisionsConnectionWhere>;
};

export type TagAggregateSelection = {
  __typename?: 'TagAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type TagConnectInput = {
  revisions?: InputMaybe<Array<TagRevisionsConnectFieldInput>>;
};

export type TagConnectOrCreateInput = {
  revisions?: InputMaybe<Array<TagRevisionsConnectOrCreateFieldInput>>;
};

export type TagConnectOrCreateWhere = {
  node: TagUniqueWhere;
};

export type TagConnectWhere = {
  node: TagWhere;
};

export type TagCreateInput = {
  revisions?: InputMaybe<TagRevisionsFieldInput>;
  synonyms: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TagDeleteInput = {
  revisions?: InputMaybe<Array<TagRevisionsDeleteFieldInput>>;
};

export type TagDisconnectInput = {
  revisions?: InputMaybe<Array<TagRevisionsDisconnectFieldInput>>;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor: Scalars['String']['output'];
  node: Tag;
};

export type TagOnCreateInput = {
  synonyms: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TagOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TagSort objects to sort Tags by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TagSort>>;
};

export type TagPostRevisionRevisionsAggregationSelection = {
  __typename?: 'TagPostRevisionRevisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TagPostRevisionRevisionsNodeAggregateSelection>;
};

export type TagPostRevisionRevisionsNodeAggregateSelection = {
  __typename?: 'TagPostRevisionRevisionsNodeAggregateSelection';
  body: StringAggregateSelection;
  coverAttribution: StringAggregateSelection;
  coverAttributionLink: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lead: StringAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type TagRelationInput = {
  revisions?: InputMaybe<Array<TagRevisionsCreateFieldInput>>;
};

export type TagRevisionsAggregateInput = {
  AND?: InputMaybe<Array<TagRevisionsAggregateInput>>;
  NOT?: InputMaybe<TagRevisionsAggregateInput>;
  OR?: InputMaybe<Array<TagRevisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TagRevisionsNodeAggregationWhereInput>;
};

export type TagRevisionsConnectFieldInput = {
  connect?: InputMaybe<Array<PostRevisionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostRevisionConnectWhere>;
};

export type TagRevisionsConnectOrCreateFieldInput = {
  onCreate: TagRevisionsConnectOrCreateFieldInputOnCreate;
  where: PostRevisionConnectOrCreateWhere;
};

export type TagRevisionsConnectOrCreateFieldInputOnCreate = {
  node: PostRevisionOnCreateInput;
};

export type TagRevisionsConnection = {
  __typename?: 'TagRevisionsConnection';
  edges: Array<TagRevisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TagRevisionsConnectionSort = {
  node?: InputMaybe<PostRevisionSort>;
};

export type TagRevisionsConnectionWhere = {
  AND?: InputMaybe<Array<TagRevisionsConnectionWhere>>;
  NOT?: InputMaybe<TagRevisionsConnectionWhere>;
  OR?: InputMaybe<Array<TagRevisionsConnectionWhere>>;
  node?: InputMaybe<PostRevisionWhere>;
};

export type TagRevisionsCreateFieldInput = {
  node: PostRevisionCreateInput;
};

export type TagRevisionsDeleteFieldInput = {
  delete?: InputMaybe<PostRevisionDeleteInput>;
  where?: InputMaybe<TagRevisionsConnectionWhere>;
};

export type TagRevisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostRevisionDisconnectInput>;
  where?: InputMaybe<TagRevisionsConnectionWhere>;
};

export type TagRevisionsFieldInput = {
  connect?: InputMaybe<Array<TagRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TagRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TagRevisionsCreateFieldInput>>;
};

export type TagRevisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TagRevisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TagRevisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TagRevisionsNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttributionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttributionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverAttribution_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverAttribution_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lead_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lead_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lead_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lead_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TagRevisionsRelationship = {
  __typename?: 'TagRevisionsRelationship';
  cursor: Scalars['String']['output'];
  node: PostRevision;
};

export type TagRevisionsUpdateConnectionInput = {
  node?: InputMaybe<PostRevisionUpdateInput>;
};

export type TagRevisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<TagRevisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TagRevisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TagRevisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<TagRevisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TagRevisionsDisconnectFieldInput>>;
  update?: InputMaybe<TagRevisionsUpdateConnectionInput>;
  where?: InputMaybe<TagRevisionsConnectionWhere>;
};

/** Fields to sort Tags by. The order in which sorts are applied is not guaranteed when specifying many fields in one TagSort object. */
export type TagSort = {
  id?: InputMaybe<SortDirection>;
  slug?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  usageCount?: InputMaybe<SortDirection>;
};

export type TagUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TagUpdateInput = {
  revisions?: InputMaybe<Array<TagRevisionsUpdateFieldInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
  synonyms_POP?: InputMaybe<Scalars['Int']['input']>;
  synonyms_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TagWhere = {
  AND?: InputMaybe<Array<TagWhere>>;
  NOT?: InputMaybe<TagWhere>;
  OR?: InputMaybe<Array<TagWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  revisionsAggregate?: InputMaybe<TagRevisionsAggregateInput>;
  /** Return Tags where all of the related TagRevisionsConnections match this filter */
  revisionsConnection_ALL?: InputMaybe<TagRevisionsConnectionWhere>;
  /** Return Tags where none of the related TagRevisionsConnections match this filter */
  revisionsConnection_NONE?: InputMaybe<TagRevisionsConnectionWhere>;
  /** Return Tags where one of the related TagRevisionsConnections match this filter */
  revisionsConnection_SINGLE?: InputMaybe<TagRevisionsConnectionWhere>;
  /** Return Tags where some of the related TagRevisionsConnections match this filter */
  revisionsConnection_SOME?: InputMaybe<TagRevisionsConnectionWhere>;
  /** Return Tags where all of the related PostRevisions match this filter */
  revisions_ALL?: InputMaybe<PostRevisionWhere>;
  /** Return Tags where none of the related PostRevisions match this filter */
  revisions_NONE?: InputMaybe<PostRevisionWhere>;
  /** Return Tags where one of the related PostRevisions match this filter */
  revisions_SINGLE?: InputMaybe<PostRevisionWhere>;
  /** Return Tags where some of the related PostRevisions match this filter */
  revisions_SOME?: InputMaybe<PostRevisionWhere>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  slug_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
  synonyms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
  usageCount_GT?: InputMaybe<Scalars['Int']['input']>;
  usageCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  usageCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  usageCount_LT?: InputMaybe<Scalars['Int']['input']>;
  usageCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TagsConnection = {
  __typename?: 'TagsConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateAuthSettingsInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  regenerateCodes?: InputMaybe<Scalars['Boolean']['input']>;
  tfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tfaSecret?: InputMaybe<Scalars['String']['input']>;
  tokenConfirm?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBannersMutationResponse = {
  __typename?: 'UpdateBannersMutationResponse';
  banners: Array<Banner>;
  info: UpdateInfo;
};

export type UpdateCategoriesMutationResponse = {
  __typename?: 'UpdateCategoriesMutationResponse';
  categories: Array<Category>;
  info: UpdateInfo;
};

export type UpdateCommercialBreakSchedulesMutationResponse = {
  __typename?: 'UpdateCommercialBreakSchedulesMutationResponse';
  commercialBreakSchedules: Array<CommercialBreakSchedule>;
  info: UpdateInfo;
};

export type UpdateCreateAppkeyResponsesMutationResponse = {
  __typename?: 'UpdateCreateAppkeyResponsesMutationResponse';
  createAppkeyResponses: Array<CreateAppkeyResponse>;
  info: UpdateInfo;
};

export type UpdateDeadlinesMutationResponse = {
  __typename?: 'UpdateDeadlinesMutationResponse';
  deadlines: Array<Deadline>;
  info: UpdateInfo;
};

export type UpdateFanGalleryItemsMutationResponse = {
  __typename?: 'UpdateFanGalleryItemsMutationResponse';
  fanGalleryItems: Array<FanGalleryItem>;
  info: UpdateInfo;
};

export type UpdateFilesMutationResponse = {
  __typename?: 'UpdateFilesMutationResponse';
  files: Array<File>;
  info: UpdateInfo;
};

/** Information about the number of nodes and relationships created and deleted during an update mutation */
export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  /** @deprecated This field has been deprecated because bookmarks are now handled by the driver. */
  bookmark?: Maybe<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type UpdateOurSocialLinksMutationResponse = {
  __typename?: 'UpdateOurSocialLinksMutationResponse';
  info: UpdateInfo;
  ourSocialLinks: Array<OurSocialLink>;
};

export type UpdatePartnersMutationResponse = {
  __typename?: 'UpdatePartnersMutationResponse';
  info: UpdateInfo;
  partners: Array<Partner>;
};

export type UpdatePollsMutationResponse = {
  __typename?: 'UpdatePollsMutationResponse';
  info: UpdateInfo;
  polls: Array<Poll>;
};

export type UpdatePostAbsencesMutationResponse = {
  __typename?: 'UpdatePostAbsencesMutationResponse';
  info: UpdateInfo;
  postAbsences: Array<PostAbsence>;
};

export type UpdatePostSchedulesMutationResponse = {
  __typename?: 'UpdatePostSchedulesMutationResponse';
  info: UpdateInfo;
  postSchedules: Array<PostSchedule>;
};

export type UpdateRadioShowSchedulesMutationResponse = {
  __typename?: 'UpdateRadioShowSchedulesMutationResponse';
  info: UpdateInfo;
  radioShowSchedules: Array<RadioShowSchedule>;
};

export type UpdateRadioShowsMutationResponse = {
  __typename?: 'UpdateRadioShowsMutationResponse';
  info: UpdateInfo;
  radioShows: Array<RadioShow>;
};

export type UpdateSongRequestBannedIpsMutationResponse = {
  __typename?: 'UpdateSongRequestBannedIpsMutationResponse';
  info: UpdateInfo;
  songRequestBannedIps: Array<SongRequestBannedIp>;
};

export type UpdateSongRequestsMutationResponse = {
  __typename?: 'UpdateSongRequestsMutationResponse';
  info: UpdateInfo;
  songRequests: Array<SongRequest>;
};

export type UpdateStreamingAbsencesMutationResponse = {
  __typename?: 'UpdateStreamingAbsencesMutationResponse';
  info: UpdateInfo;
  streamingAbsences: Array<StreamingAbsence>;
};

export type UpdateTagsMutationResponse = {
  __typename?: 'UpdateTagsMutationResponse';
  info: UpdateInfo;
  tags: Array<Tag>;
};

export type UpdateUserAppkeysMutationResponse = {
  __typename?: 'UpdateUserAppkeysMutationResponse';
  info: UpdateInfo;
  userAppkeys: Array<UserAppkey>;
};

export type UpdateUserPasskeysMutationResponse = {
  __typename?: 'UpdateUserPasskeysMutationResponse';
  info: UpdateInfo;
  userPasskeys: Array<UserPasskey>;
};

export type UpdateUsersMutationResponse = {
  __typename?: 'UpdateUsersMutationResponse';
  info: UpdateInfo;
  users: Array<User>;
};

export type User = {
  __typename?: 'User';
  allCategories: Array<Category>;
  appkeyCount: Scalars['Int']['output'];
  appkeys: Array<UserAppkey>;
  appkeysAggregate?: Maybe<UserUserAppkeyAppkeysAggregationSelection>;
  appkeysConnection: UserAppkeysConnection;
  categories: Array<Category>;
  categoriesAggregate?: Maybe<UserCategoryCategoriesAggregationSelection>;
  categoriesConnection: UserCategoriesConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['EmailAddress']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAway: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  passkeyCount: Scalars['Int']['output'];
  passkeys: Array<UserPasskey>;
  passkeysAggregate?: Maybe<UserUserPasskeyPasskeysAggregationSelection>;
  passkeysConnection: UserPasskeysConnection;
  passwordUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  postAbsenceCount: Scalars['Int']['output'];
  posts: Array<Post>;
  postsAggregate?: Maybe<UserPostPostsAggregationSelection>;
  postsConnection: UserPostsConnection;
  profile?: Maybe<UserProfile>;
  profileAggregate?: Maybe<UserUserProfileProfileAggregationSelection>;
  profileConnection: UserProfileConnection;
  radioShows: Array<RadioShow>;
  radioShowsAggregate?: Maybe<UserRadioShowRadioShowsAggregationSelection>;
  radioShowsConnection: UserRadioShowsConnection;
  remainingCodes: Scalars['Int']['output'];
  roles: Array<UserRole>;
  songRequests: Array<SongRequest>;
  songRequestsAggregate?: Maybe<UserSongRequestSongRequestsAggregationSelection>;
  songRequestsConnection: UserSongRequestsConnection;
  streamingAbsenceCount: Scalars['Int']['output'];
  tfaEnabled: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};


export type UserAppkeysArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserAppkeyOptions>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type UserAppkeysAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserAppkeyWhere>;
};


export type UserAppkeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAppkeysConnectionSort>>;
  where?: InputMaybe<UserAppkeysConnectionWhere>;
};


export type UserCategoriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CategoryOptions>;
  where?: InputMaybe<CategoryWhere>;
};


export type UserCategoriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryWhere>;
};


export type UserCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserCategoriesConnectionSort>>;
  where?: InputMaybe<UserCategoriesConnectionWhere>;
};


export type UserPasskeysArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserPasskeyOptions>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type UserPasskeysAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserPasskeyWhere>;
};


export type UserPasskeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserPasskeysConnectionSort>>;
  where?: InputMaybe<UserPasskeysConnectionWhere>;
};


export type UserPostsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type UserPostsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type UserPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserPostsConnectionSort>>;
  where?: InputMaybe<UserPostsConnectionWhere>;
};


export type UserProfileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserProfileOptions>;
  where?: InputMaybe<UserProfileWhere>;
};


export type UserProfileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserProfileWhere>;
};


export type UserProfileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserProfileConnectionSort>>;
  where?: InputMaybe<UserProfileConnectionWhere>;
};


export type UserRadioShowsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RadioShowOptions>;
  where?: InputMaybe<RadioShowWhere>;
};


export type UserRadioShowsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RadioShowWhere>;
};


export type UserRadioShowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserRadioShowsConnectionSort>>;
  where?: InputMaybe<UserRadioShowsConnectionWhere>;
};


export type UserSongRequestsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SongRequestOptions>;
  where?: InputMaybe<SongRequestWhere>;
};


export type UserSongRequestsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SongRequestWhere>;
};


export type UserSongRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSongRequestsConnectionSort>>;
  where?: InputMaybe<UserSongRequestsConnectionWhere>;
};

export type UserAggregateSelection = {
  __typename?: 'UserAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type UserAppkey = {
  __typename?: 'UserAppkey';
  createdAt: Scalars['DateTime']['output'];
  credentialID: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  user: User;
  userAggregate?: Maybe<UserAppkeyUserUserAggregationSelection>;
  userConnection: UserAppkeyUserConnection;
};


export type UserAppkeyUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type UserAppkeyUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type UserAppkeyUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAppkeyUserConnectionSort>>;
  where?: InputMaybe<UserAppkeyUserConnectionWhere>;
};

export type UserAppkeyAggregateSelection = {
  __typename?: 'UserAppkeyAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  credentialID: StringAggregateSelection;
  lastUsedAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  purpose: StringAggregateSelection;
};

export type UserAppkeyConnectInput = {
  user?: InputMaybe<UserAppkeyUserConnectFieldInput>;
};

export type UserAppkeyConnectOrCreateInput = {
  user?: InputMaybe<UserAppkeyUserConnectOrCreateFieldInput>;
};

export type UserAppkeyConnectOrCreateWhere = {
  node: UserAppkeyUniqueWhere;
};

export type UserAppkeyConnectWhere = {
  node: UserAppkeyWhere;
};

export type UserAppkeyCreateInput = {
  credentialID: Scalars['String']['input'];
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['Secret']['input'];
  purpose: Scalars['String']['input'];
  user?: InputMaybe<UserAppkeyUserFieldInput>;
};

export type UserAppkeyDeleteInput = {
  user?: InputMaybe<UserAppkeyUserDeleteFieldInput>;
};

export type UserAppkeyDisconnectInput = {
  user?: InputMaybe<UserAppkeyUserDisconnectFieldInput>;
};

export type UserAppkeyEdge = {
  __typename?: 'UserAppkeyEdge';
  cursor: Scalars['String']['output'];
  node: UserAppkey;
};

export type UserAppkeyOnCreateInput = {
  credentialID: Scalars['String']['input'];
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['Secret']['input'];
  purpose: Scalars['String']['input'];
};

export type UserAppkeyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserAppkeySort objects to sort UserAppkeys by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserAppkeySort>>;
};

export type UserAppkeyRelationInput = {
  user?: InputMaybe<UserAppkeyUserCreateFieldInput>;
};

/** Fields to sort UserAppkeys by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserAppkeySort object. */
export type UserAppkeySort = {
  createdAt?: InputMaybe<SortDirection>;
  credentialID?: InputMaybe<SortDirection>;
  lastUsedAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  password?: InputMaybe<SortDirection>;
  purpose?: InputMaybe<SortDirection>;
};

export type UserAppkeyUniqueWhere = {
  credentialID?: InputMaybe<Scalars['String']['input']>;
};

export type UserAppkeyUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialID?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserAppkeyUserUpdateFieldInput>;
};

export type UserAppkeyUserAggregateInput = {
  AND?: InputMaybe<Array<UserAppkeyUserAggregateInput>>;
  NOT?: InputMaybe<UserAppkeyUserAggregateInput>;
  OR?: InputMaybe<Array<UserAppkeyUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAppkeyUserNodeAggregationWhereInput>;
};

export type UserAppkeyUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type UserAppkeyUserConnectOrCreateFieldInput = {
  onCreate: UserAppkeyUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type UserAppkeyUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type UserAppkeyUserConnection = {
  __typename?: 'UserAppkeyUserConnection';
  edges: Array<UserAppkeyUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAppkeyUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type UserAppkeyUserConnectionWhere = {
  AND?: InputMaybe<Array<UserAppkeyUserConnectionWhere>>;
  NOT?: InputMaybe<UserAppkeyUserConnectionWhere>;
  OR?: InputMaybe<Array<UserAppkeyUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type UserAppkeyUserCreateFieldInput = {
  node: UserCreateInput;
};

export type UserAppkeyUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<UserAppkeyUserConnectionWhere>;
};

export type UserAppkeyUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<UserAppkeyUserConnectionWhere>;
};

export type UserAppkeyUserFieldInput = {
  connect?: InputMaybe<UserAppkeyUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserAppkeyUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserAppkeyUserCreateFieldInput>;
};

export type UserAppkeyUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAppkeyUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAppkeyUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAppkeyUserNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAppkeyUserRelationship = {
  __typename?: 'UserAppkeyUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserAppkeyUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type UserAppkeyUserUpdateFieldInput = {
  connect?: InputMaybe<UserAppkeyUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserAppkeyUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserAppkeyUserCreateFieldInput>;
  delete?: InputMaybe<UserAppkeyUserDeleteFieldInput>;
  disconnect?: InputMaybe<UserAppkeyUserDisconnectFieldInput>;
  update?: InputMaybe<UserAppkeyUserUpdateConnectionInput>;
  where?: InputMaybe<UserAppkeyUserConnectionWhere>;
};

export type UserAppkeyUserUserAggregationSelection = {
  __typename?: 'UserAppkeyUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAppkeyUserUserNodeAggregateSelection>;
};

export type UserAppkeyUserUserNodeAggregateSelection = {
  __typename?: 'UserAppkeyUserUserNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type UserAppkeyWhere = {
  AND?: InputMaybe<Array<UserAppkeyWhere>>;
  NOT?: InputMaybe<UserAppkeyWhere>;
  OR?: InputMaybe<Array<UserAppkeyWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  credentialID?: InputMaybe<Scalars['String']['input']>;
  credentialID_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  credentialID_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialID_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialID_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUsedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  password_IN?: InputMaybe<Array<Scalars['Secret']['input']>>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  purpose_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purpose_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purpose_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<UserAppkeyUserAggregateInput>;
  userConnection?: InputMaybe<UserAppkeyUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<UserAppkeyUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type UserAppkeysAggregateInput = {
  AND?: InputMaybe<Array<UserAppkeysAggregateInput>>;
  NOT?: InputMaybe<UserAppkeysAggregateInput>;
  OR?: InputMaybe<Array<UserAppkeysAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAppkeysNodeAggregationWhereInput>;
};

export type UserAppkeysConnectFieldInput = {
  connect?: InputMaybe<Array<UserAppkeyConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserAppkeyConnectWhere>;
};

export type UserAppkeysConnectOrCreateFieldInput = {
  onCreate: UserAppkeysConnectOrCreateFieldInputOnCreate;
  where: UserAppkeyConnectOrCreateWhere;
};

export type UserAppkeysConnectOrCreateFieldInputOnCreate = {
  node: UserAppkeyOnCreateInput;
};

export type UserAppkeysConnection = {
  __typename?: 'UserAppkeysConnection';
  edges: Array<UserAppkeysRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAppkeysConnectionSort = {
  node?: InputMaybe<UserAppkeySort>;
};

export type UserAppkeysConnectionWhere = {
  AND?: InputMaybe<Array<UserAppkeysConnectionWhere>>;
  NOT?: InputMaybe<UserAppkeysConnectionWhere>;
  OR?: InputMaybe<Array<UserAppkeysConnectionWhere>>;
  node?: InputMaybe<UserAppkeyWhere>;
};

export type UserAppkeysCreateFieldInput = {
  node: UserAppkeyCreateInput;
};

export type UserAppkeysDeleteFieldInput = {
  delete?: InputMaybe<UserAppkeyDeleteInput>;
  where?: InputMaybe<UserAppkeysConnectionWhere>;
};

export type UserAppkeysDisconnectFieldInput = {
  disconnect?: InputMaybe<UserAppkeyDisconnectInput>;
  where?: InputMaybe<UserAppkeysConnectionWhere>;
};

export type UserAppkeysFieldInput = {
  connect?: InputMaybe<Array<UserAppkeysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAppkeysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAppkeysCreateFieldInput>>;
};

export type UserAppkeysNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAppkeysNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAppkeysNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAppkeysNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  credentialID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  credentialID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUsedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purpose_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purpose_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purpose_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purpose_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purpose_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purpose_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purpose_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purpose_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purpose_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purpose_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purpose_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purpose_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purpose_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purpose_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purpose_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAppkeysRelationship = {
  __typename?: 'UserAppkeysRelationship';
  cursor: Scalars['String']['output'];
  node: UserAppkey;
};

export type UserAppkeysUpdateConnectionInput = {
  node?: InputMaybe<UserAppkeyUpdateInput>;
};

export type UserAppkeysUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAppkeysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAppkeysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAppkeysCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAppkeysDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAppkeysDisconnectFieldInput>>;
  update?: InputMaybe<UserAppkeysUpdateConnectionInput>;
  where?: InputMaybe<UserAppkeysConnectionWhere>;
};

export type UserCategoriesAggregateInput = {
  AND?: InputMaybe<Array<UserCategoriesAggregateInput>>;
  NOT?: InputMaybe<UserCategoriesAggregateInput>;
  OR?: InputMaybe<Array<UserCategoriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserCategoriesNodeAggregationWhereInput>;
};

export type UserCategoriesConnectFieldInput = {
  connect?: InputMaybe<Array<CategoryConnectInput>>;
  edge: PostsOnCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CategoryConnectWhere>;
};

export type UserCategoriesConnectOrCreateFieldInput = {
  onCreate: UserCategoriesConnectOrCreateFieldInputOnCreate;
  where: CategoryConnectOrCreateWhere;
};

export type UserCategoriesConnectOrCreateFieldInputOnCreate = {
  edge: PostsOnCreateInput;
  node: CategoryOnCreateInput;
};

export type UserCategoriesConnection = {
  __typename?: 'UserCategoriesConnection';
  edges: Array<UserCategoriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserCategoriesConnectionSort = {
  edge?: InputMaybe<PostsOnSort>;
  node?: InputMaybe<CategorySort>;
};

export type UserCategoriesConnectionWhere = {
  AND?: InputMaybe<Array<UserCategoriesConnectionWhere>>;
  NOT?: InputMaybe<UserCategoriesConnectionWhere>;
  OR?: InputMaybe<Array<UserCategoriesConnectionWhere>>;
  edge?: InputMaybe<PostsOnWhere>;
  node?: InputMaybe<CategoryWhere>;
};

export type UserCategoriesCreateFieldInput = {
  edge: PostsOnCreateInput;
  node: CategoryCreateInput;
};

export type UserCategoriesDeleteFieldInput = {
  delete?: InputMaybe<CategoryDeleteInput>;
  where?: InputMaybe<UserCategoriesConnectionWhere>;
};

export type UserCategoriesDisconnectFieldInput = {
  disconnect?: InputMaybe<CategoryDisconnectInput>;
  where?: InputMaybe<UserCategoriesConnectionWhere>;
};

export type UserCategoriesFieldInput = {
  connect?: InputMaybe<Array<UserCategoriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserCategoriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserCategoriesCreateFieldInput>>;
};

export type UserCategoriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserCategoriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserCategoriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserCategoriesNodeAggregationWhereInput>>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCategoriesRelationship = {
  __typename?: 'UserCategoriesRelationship';
  cursor: Scalars['String']['output'];
  node: Category;
  properties: PostsOn;
};

export type UserCategoriesUpdateConnectionInput = {
  edge?: InputMaybe<PostsOnUpdateInput>;
  node?: InputMaybe<CategoryUpdateInput>;
};

export type UserCategoriesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserCategoriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserCategoriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserCategoriesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserCategoriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserCategoriesDisconnectFieldInput>>;
  update?: InputMaybe<UserCategoriesUpdateConnectionInput>;
  where?: InputMaybe<UserCategoriesConnectionWhere>;
};

export type UserCategoryCategoriesAggregationSelection = {
  __typename?: 'UserCategoryCategoriesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserCategoryCategoriesNodeAggregateSelection>;
};

export type UserCategoryCategoriesNodeAggregateSelection = {
  __typename?: 'UserCategoryCategoriesNodeAggregateSelection';
  body: StringAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  views: IntAggregateSelection;
};

export type UserConnectInput = {
  appkeys?: InputMaybe<Array<UserAppkeysConnectFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesConnectFieldInput>>;
  passkeys?: InputMaybe<Array<UserPasskeysConnectFieldInput>>;
  posts?: InputMaybe<Array<UserPostsConnectFieldInput>>;
  profile?: InputMaybe<UserProfileConnectFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsConnectFieldInput>>;
  songRequests?: InputMaybe<Array<UserSongRequestsConnectFieldInput>>;
};

export type UserConnectOrCreateInput = {
  appkeys?: InputMaybe<Array<UserAppkeysConnectOrCreateFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesConnectOrCreateFieldInput>>;
  passkeys?: InputMaybe<Array<UserPasskeysConnectOrCreateFieldInput>>;
  posts?: InputMaybe<Array<UserPostsConnectOrCreateFieldInput>>;
  profile?: InputMaybe<UserProfileConnectOrCreateFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsConnectOrCreateFieldInput>>;
  songRequests?: InputMaybe<Array<UserSongRequestsConnectOrCreateFieldInput>>;
};

export type UserConnectOrCreateWhere = {
  node: UserUniqueWhere;
};

export type UserConnectWhere = {
  node: UserWhere;
};

export type UserCreateInput = {
  appkeys?: InputMaybe<UserAppkeysFieldInput>;
  categories?: InputMaybe<UserCategoriesFieldInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['EmailAddress']['input'];
  isAway: Scalars['Boolean']['input'];
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  passkeys?: InputMaybe<UserPasskeysFieldInput>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  passwordUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount?: Scalars['Int']['input'];
  posts?: InputMaybe<UserPostsFieldInput>;
  profile?: InputMaybe<UserProfileFieldInput>;
  radioShows?: InputMaybe<UserRadioShowsFieldInput>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  roles: Array<UserRole>;
  securityCodes: Array<Scalars['Secret']['input']>;
  songRequests?: InputMaybe<UserSongRequestsFieldInput>;
  streamingAbsenceCount?: Scalars['Int']['input'];
  tfaSecret?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UserDeleteInput = {
  appkeys?: InputMaybe<Array<UserAppkeysDeleteFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesDeleteFieldInput>>;
  passkeys?: InputMaybe<Array<UserPasskeysDeleteFieldInput>>;
  posts?: InputMaybe<Array<UserPostsDeleteFieldInput>>;
  profile?: InputMaybe<UserProfileDeleteFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsDeleteFieldInput>>;
  songRequests?: InputMaybe<Array<UserSongRequestsDeleteFieldInput>>;
};

export type UserDisconnectInput = {
  appkeys?: InputMaybe<Array<UserAppkeysDisconnectFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesDisconnectFieldInput>>;
  passkeys?: InputMaybe<Array<UserPasskeysDisconnectFieldInput>>;
  posts?: InputMaybe<Array<UserPostsDisconnectFieldInput>>;
  profile?: InputMaybe<UserProfileDisconnectFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsDisconnectFieldInput>>;
  songRequests?: InputMaybe<Array<UserSongRequestsDisconnectFieldInput>>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserOnCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['EmailAddress']['input'];
  isAway: Scalars['Boolean']['input'];
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  passwordUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount?: Scalars['Int']['input'];
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  roles: Array<UserRole>;
  securityCodes: Array<Scalars['Secret']['input']>;
  streamingAbsenceCount?: Scalars['Int']['input'];
  tfaSecret?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSort>>;
};

export type UserPasskey = {
  __typename?: 'UserPasskey';
  counter: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialBackedUp: Scalars['Boolean']['output'];
  credentialDeviceType: Scalars['String']['output'];
  credentialID: Scalars['String']['output'];
  credentialPublicKey: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  transports?: Maybe<Array<Scalars['String']['output']>>;
  user: User;
  userAggregate?: Maybe<UserPasskeyUserUserAggregationSelection>;
  userConnection: UserPasskeyUserConnection;
};


export type UserPasskeyUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type UserPasskeyUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type UserPasskeyUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserPasskeyUserConnectionSort>>;
  where?: InputMaybe<UserPasskeyUserConnectionWhere>;
};

export type UserPasskeyAggregateSelection = {
  __typename?: 'UserPasskeyAggregateSelection';
  count: Scalars['Int']['output'];
  counter: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  credentialDeviceType: StringAggregateSelection;
  credentialID: StringAggregateSelection;
  credentialPublicKey: StringAggregateSelection;
  lastUsedAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type UserPasskeyConnectInput = {
  user?: InputMaybe<UserPasskeyUserConnectFieldInput>;
};

export type UserPasskeyConnectOrCreateInput = {
  user?: InputMaybe<UserPasskeyUserConnectOrCreateFieldInput>;
};

export type UserPasskeyConnectOrCreateWhere = {
  node: UserPasskeyUniqueWhere;
};

export type UserPasskeyConnectWhere = {
  node: UserPasskeyWhere;
};

export type UserPasskeyCreateInput = {
  counter: Scalars['Int']['input'];
  credentialBackedUp: Scalars['Boolean']['input'];
  credentialDeviceType: Scalars['String']['input'];
  credentialID: Scalars['String']['input'];
  credentialPublicKey: Scalars['String']['input'];
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<UserPasskeyUserFieldInput>;
};

export type UserPasskeyDeleteInput = {
  user?: InputMaybe<UserPasskeyUserDeleteFieldInput>;
};

export type UserPasskeyDisconnectInput = {
  user?: InputMaybe<UserPasskeyUserDisconnectFieldInput>;
};

export type UserPasskeyEdge = {
  __typename?: 'UserPasskeyEdge';
  cursor: Scalars['String']['output'];
  node: UserPasskey;
};

export type UserPasskeyOnCreateInput = {
  counter: Scalars['Int']['input'];
  credentialBackedUp: Scalars['Boolean']['input'];
  credentialDeviceType: Scalars['String']['input'];
  credentialID: Scalars['String']['input'];
  credentialPublicKey: Scalars['String']['input'];
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserPasskeyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserPasskeySort objects to sort UserPasskeys by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserPasskeySort>>;
};

export type UserPasskeyRelationInput = {
  user?: InputMaybe<UserPasskeyUserCreateFieldInput>;
};

/** Fields to sort UserPasskeys by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserPasskeySort object. */
export type UserPasskeySort = {
  counter?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  credentialBackedUp?: InputMaybe<SortDirection>;
  credentialDeviceType?: InputMaybe<SortDirection>;
  credentialID?: InputMaybe<SortDirection>;
  credentialPublicKey?: InputMaybe<SortDirection>;
  lastUsedAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type UserPasskeyUniqueWhere = {
  credentialID?: InputMaybe<Scalars['String']['input']>;
};

export type UserPasskeyUpdateInput = {
  counter?: InputMaybe<Scalars['Int']['input']>;
  counter_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  counter_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialBackedUp?: InputMaybe<Scalars['Boolean']['input']>;
  credentialDeviceType?: InputMaybe<Scalars['String']['input']>;
  credentialID?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  transports_POP?: InputMaybe<Scalars['Int']['input']>;
  transports_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<UserPasskeyUserUpdateFieldInput>;
};

export type UserPasskeyUserAggregateInput = {
  AND?: InputMaybe<Array<UserPasskeyUserAggregateInput>>;
  NOT?: InputMaybe<UserPasskeyUserAggregateInput>;
  OR?: InputMaybe<Array<UserPasskeyUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserPasskeyUserNodeAggregationWhereInput>;
};

export type UserPasskeyUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type UserPasskeyUserConnectOrCreateFieldInput = {
  onCreate: UserPasskeyUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type UserPasskeyUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type UserPasskeyUserConnection = {
  __typename?: 'UserPasskeyUserConnection';
  edges: Array<UserPasskeyUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPasskeyUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type UserPasskeyUserConnectionWhere = {
  AND?: InputMaybe<Array<UserPasskeyUserConnectionWhere>>;
  NOT?: InputMaybe<UserPasskeyUserConnectionWhere>;
  OR?: InputMaybe<Array<UserPasskeyUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type UserPasskeyUserCreateFieldInput = {
  node: UserCreateInput;
};

export type UserPasskeyUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<UserPasskeyUserConnectionWhere>;
};

export type UserPasskeyUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<UserPasskeyUserConnectionWhere>;
};

export type UserPasskeyUserFieldInput = {
  connect?: InputMaybe<UserPasskeyUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserPasskeyUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserPasskeyUserCreateFieldInput>;
};

export type UserPasskeyUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserPasskeyUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserPasskeyUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserPasskeyUserNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  postAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resetPasswordToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  streamingAbsenceCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tfaSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPasskeyUserRelationship = {
  __typename?: 'UserPasskeyUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserPasskeyUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type UserPasskeyUserUpdateFieldInput = {
  connect?: InputMaybe<UserPasskeyUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserPasskeyUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserPasskeyUserCreateFieldInput>;
  delete?: InputMaybe<UserPasskeyUserDeleteFieldInput>;
  disconnect?: InputMaybe<UserPasskeyUserDisconnectFieldInput>;
  update?: InputMaybe<UserPasskeyUserUpdateConnectionInput>;
  where?: InputMaybe<UserPasskeyUserConnectionWhere>;
};

export type UserPasskeyUserUserAggregationSelection = {
  __typename?: 'UserPasskeyUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserPasskeyUserUserNodeAggregateSelection>;
};

export type UserPasskeyUserUserNodeAggregateSelection = {
  __typename?: 'UserPasskeyUserUserNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastLogin: DateTimeAggregateSelection;
  passwordUpdatedAt: DateTimeAggregateSelection;
  postAbsenceCount: IntAggregateSelection;
  streamingAbsenceCount: IntAggregateSelection;
  username: StringAggregateSelection;
};

export type UserPasskeyWhere = {
  AND?: InputMaybe<Array<UserPasskeyWhere>>;
  NOT?: InputMaybe<UserPasskeyWhere>;
  OR?: InputMaybe<Array<UserPasskeyWhere>>;
  counter?: InputMaybe<Scalars['Int']['input']>;
  counter_GT?: InputMaybe<Scalars['Int']['input']>;
  counter_GTE?: InputMaybe<Scalars['Int']['input']>;
  counter_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  counter_LT?: InputMaybe<Scalars['Int']['input']>;
  counter_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  credentialBackedUp?: InputMaybe<Scalars['Boolean']['input']>;
  credentialDeviceType?: InputMaybe<Scalars['String']['input']>;
  credentialDeviceType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  credentialDeviceType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialDeviceType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialDeviceType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialID?: InputMaybe<Scalars['String']['input']>;
  credentialID_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  credentialID_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialID_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialID_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialPublicKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUsedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  transports_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<UserPasskeyUserAggregateInput>;
  userConnection?: InputMaybe<UserPasskeyUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<UserPasskeyUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type UserPasskeysAggregateInput = {
  AND?: InputMaybe<Array<UserPasskeysAggregateInput>>;
  NOT?: InputMaybe<UserPasskeysAggregateInput>;
  OR?: InputMaybe<Array<UserPasskeysAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserPasskeysNodeAggregationWhereInput>;
};

export type UserPasskeysConnectFieldInput = {
  connect?: InputMaybe<Array<UserPasskeyConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserPasskeyConnectWhere>;
};

export type UserPasskeysConnectOrCreateFieldInput = {
  onCreate: UserPasskeysConnectOrCreateFieldInputOnCreate;
  where: UserPasskeyConnectOrCreateWhere;
};

export type UserPasskeysConnectOrCreateFieldInputOnCreate = {
  node: UserPasskeyOnCreateInput;
};

export type UserPasskeysConnection = {
  __typename?: 'UserPasskeysConnection';
  edges: Array<UserPasskeysRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPasskeysConnectionSort = {
  node?: InputMaybe<UserPasskeySort>;
};

export type UserPasskeysConnectionWhere = {
  AND?: InputMaybe<Array<UserPasskeysConnectionWhere>>;
  NOT?: InputMaybe<UserPasskeysConnectionWhere>;
  OR?: InputMaybe<Array<UserPasskeysConnectionWhere>>;
  node?: InputMaybe<UserPasskeyWhere>;
};

export type UserPasskeysCreateFieldInput = {
  node: UserPasskeyCreateInput;
};

export type UserPasskeysDeleteFieldInput = {
  delete?: InputMaybe<UserPasskeyDeleteInput>;
  where?: InputMaybe<UserPasskeysConnectionWhere>;
};

export type UserPasskeysDisconnectFieldInput = {
  disconnect?: InputMaybe<UserPasskeyDisconnectInput>;
  where?: InputMaybe<UserPasskeysConnectionWhere>;
};

export type UserPasskeysFieldInput = {
  connect?: InputMaybe<Array<UserPasskeysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserPasskeysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserPasskeysCreateFieldInput>>;
};

export type UserPasskeysNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserPasskeysNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserPasskeysNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserPasskeysNodeAggregationWhereInput>>;
  counter_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counter_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  counter_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  counter_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  counter_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  counter_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counter_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  counter_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  counter_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  counter_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  counter_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counter_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  counter_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  counter_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  counter_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  counter_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counter_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  counter_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  counter_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  counter_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  credentialDeviceType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  credentialDeviceType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  credentialDeviceType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  credentialDeviceType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  credentialDeviceType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  credentialDeviceType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialDeviceType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  credentialID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  credentialID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  credentialPublicKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  credentialPublicKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  credentialPublicKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  credentialPublicKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  credentialPublicKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  credentialPublicKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUsedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUsedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPasskeysRelationship = {
  __typename?: 'UserPasskeysRelationship';
  cursor: Scalars['String']['output'];
  node: UserPasskey;
};

export type UserPasskeysUpdateConnectionInput = {
  node?: InputMaybe<UserPasskeyUpdateInput>;
};

export type UserPasskeysUpdateFieldInput = {
  connect?: InputMaybe<Array<UserPasskeysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserPasskeysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserPasskeysCreateFieldInput>>;
  delete?: InputMaybe<Array<UserPasskeysDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserPasskeysDisconnectFieldInput>>;
  update?: InputMaybe<UserPasskeysUpdateConnectionInput>;
  where?: InputMaybe<UserPasskeysConnectionWhere>;
};

export type UserPostPostsAggregationSelection = {
  __typename?: 'UserPostPostsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserPostPostsNodeAggregateSelection>;
};

export type UserPostPostsNodeAggregateSelection = {
  __typename?: 'UserPostPostsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  deletedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  oldId: IntAggregateSelection;
  publishedAt: DateTimeAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  views: IntAggregateSelection;
};

export type UserPostsAggregateInput = {
  AND?: InputMaybe<Array<UserPostsAggregateInput>>;
  NOT?: InputMaybe<UserPostsAggregateInput>;
  OR?: InputMaybe<Array<UserPostsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserPostsNodeAggregationWhereInput>;
};

export type UserPostsConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type UserPostsConnectOrCreateFieldInput = {
  onCreate: UserPostsConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type UserPostsConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type UserPostsConnection = {
  __typename?: 'UserPostsConnection';
  edges: Array<UserPostsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPostsConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type UserPostsConnectionWhere = {
  AND?: InputMaybe<Array<UserPostsConnectionWhere>>;
  NOT?: InputMaybe<UserPostsConnectionWhere>;
  OR?: InputMaybe<Array<UserPostsConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type UserPostsCreateFieldInput = {
  node: PostCreateInput;
};

export type UserPostsDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<UserPostsConnectionWhere>;
};

export type UserPostsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<UserPostsConnectionWhere>;
};

export type UserPostsFieldInput = {
  connect?: InputMaybe<Array<UserPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserPostsCreateFieldInput>>;
};

export type UserPostsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserPostsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserPostsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserPostsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  oldId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  oldId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  oldId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  oldId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  views_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  views_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  views_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  views_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  views_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPostsRelationship = {
  __typename?: 'UserPostsRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type UserPostsUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type UserPostsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserPostsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserPostsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserPostsDisconnectFieldInput>>;
  update?: InputMaybe<UserPostsUpdateConnectionInput>;
  where?: InputMaybe<UserPostsConnectionWhere>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  animeTastes: Scalars['String']['output'];
  background?: Maybe<File>;
  backgroundAggregate?: Maybe<UserProfileFileBackgroundAggregationSelection>;
  backgroundConnection: UserProfileBackgroundConnection;
  birthdate: Scalars['DateTime']['output'];
  blurb: Scalars['String']['output'];
  countriesToGo: Scalars['String']['output'];
  customTitle: Scalars['String']['output'];
  dislikes: Scalars['String']['output'];
  doramaTastes: Scalars['String']['output'];
  favAsianCulture: Scalars['String']['output'];
  favFood: Scalars['String']['output'];
  favPerson: Scalars['String']['output'];
  gameTastes: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  hobbies: Scalars['String']['output'];
  likes: Scalars['String']['output'];
  location: Scalars['String']['output'];
  mostActiveSocial: Scalars['String']['output'];
  musicTastes: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  nicknameBackground: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  phrase: Scalars['String']['output'];
  picture: File;
  pictureAggregate?: Maybe<UserProfileFilePictureAggregationSelection>;
  pictureConnection: UserProfilePictureConnection;
  realName: Scalars['String']['output'];
  ship: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  socialLinks: Array<UserSocialLink>;
  socialLinksAggregate?: Maybe<UserProfileUserSocialLinkSocialLinksAggregationSelection>;
  socialLinksConnection: UserProfileSocialLinksConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UserProfileBackgroundArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type UserProfileBackgroundAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type UserProfileBackgroundConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserProfileBackgroundConnectionSort>>;
  where?: InputMaybe<UserProfileBackgroundConnectionWhere>;
};


export type UserProfilePictureArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type UserProfilePictureAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type UserProfilePictureConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserProfilePictureConnectionSort>>;
  where?: InputMaybe<UserProfilePictureConnectionWhere>;
};


export type UserProfileSocialLinksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserSocialLinkOptions>;
  where?: InputMaybe<UserSocialLinkWhere>;
};


export type UserProfileSocialLinksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserSocialLinkWhere>;
};


export type UserProfileSocialLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserProfileSocialLinksConnectionSort>>;
  where?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
};

export type UserProfileAggregateInput = {
  AND?: InputMaybe<Array<UserProfileAggregateInput>>;
  NOT?: InputMaybe<UserProfileAggregateInput>;
  OR?: InputMaybe<Array<UserProfileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserProfileNodeAggregationWhereInput>;
};

export type UserProfileBackgroundAggregateInput = {
  AND?: InputMaybe<Array<UserProfileBackgroundAggregateInput>>;
  NOT?: InputMaybe<UserProfileBackgroundAggregateInput>;
  OR?: InputMaybe<Array<UserProfileBackgroundAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserProfileBackgroundNodeAggregationWhereInput>;
};

export type UserProfileBackgroundConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type UserProfileBackgroundConnectOrCreateFieldInput = {
  onCreate: UserProfileBackgroundConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type UserProfileBackgroundConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type UserProfileBackgroundConnection = {
  __typename?: 'UserProfileBackgroundConnection';
  edges: Array<UserProfileBackgroundRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserProfileBackgroundConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type UserProfileBackgroundConnectionWhere = {
  AND?: InputMaybe<Array<UserProfileBackgroundConnectionWhere>>;
  NOT?: InputMaybe<UserProfileBackgroundConnectionWhere>;
  OR?: InputMaybe<Array<UserProfileBackgroundConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type UserProfileBackgroundCreateFieldInput = {
  node: FileCreateInput;
};

export type UserProfileBackgroundDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<UserProfileBackgroundConnectionWhere>;
};

export type UserProfileBackgroundDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<UserProfileBackgroundConnectionWhere>;
};

export type UserProfileBackgroundFieldInput = {
  connect?: InputMaybe<UserProfileBackgroundConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfileBackgroundConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfileBackgroundCreateFieldInput>;
};

export type UserProfileBackgroundNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserProfileBackgroundNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserProfileBackgroundNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserProfileBackgroundNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProfileBackgroundRelationship = {
  __typename?: 'UserProfileBackgroundRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type UserProfileBackgroundUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type UserProfileBackgroundUpdateFieldInput = {
  connect?: InputMaybe<UserProfileBackgroundConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfileBackgroundConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfileBackgroundCreateFieldInput>;
  delete?: InputMaybe<UserProfileBackgroundDeleteFieldInput>;
  disconnect?: InputMaybe<UserProfileBackgroundDisconnectFieldInput>;
  update?: InputMaybe<UserProfileBackgroundUpdateConnectionInput>;
  where?: InputMaybe<UserProfileBackgroundConnectionWhere>;
};

export type UserProfileConnectFieldInput = {
  connect?: InputMaybe<UserProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserProfileConnectWhere>;
};

export type UserProfileConnectInput = {
  background?: InputMaybe<UserProfileBackgroundConnectFieldInput>;
  picture?: InputMaybe<UserProfilePictureConnectFieldInput>;
  socialLinks?: InputMaybe<Array<UserProfileSocialLinksConnectFieldInput>>;
};

export type UserProfileConnectOrCreateFieldInput = {
  onCreate: UserProfileConnectOrCreateFieldInputOnCreate;
  where: UserProfileConnectOrCreateWhere;
};

export type UserProfileConnectOrCreateFieldInputOnCreate = {
  node: UserProfileOnCreateInput;
};

export type UserProfileConnectOrCreateWhere = {
  node: UserProfileUniqueWhere;
};

export type UserProfileConnectWhere = {
  node: UserProfileWhere;
};

export type UserProfileConnection = {
  __typename?: 'UserProfileConnection';
  edges: Array<UserProfileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserProfileConnectionSort = {
  node?: InputMaybe<UserProfileSort>;
};

export type UserProfileConnectionWhere = {
  AND?: InputMaybe<Array<UserProfileConnectionWhere>>;
  NOT?: InputMaybe<UserProfileConnectionWhere>;
  OR?: InputMaybe<Array<UserProfileConnectionWhere>>;
  node?: InputMaybe<UserProfileWhere>;
};

export type UserProfileCreateFieldInput = {
  node: UserProfileCreateInput;
};

export type UserProfileCreateInput = {
  animeTastes: Scalars['String']['input'];
  background?: InputMaybe<UserProfileBackgroundFieldInput>;
  birthdate: Scalars['DateTime']['input'];
  blurb: Scalars['String']['input'];
  countriesToGo: Scalars['String']['input'];
  customTitle: Scalars['String']['input'];
  dislikes: Scalars['String']['input'];
  doramaTastes: Scalars['String']['input'];
  favAsianCulture: Scalars['String']['input'];
  favFood: Scalars['String']['input'];
  favPerson: Scalars['String']['input'];
  gameTastes: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  hobbies: Scalars['String']['input'];
  likes: Scalars['String']['input'];
  location: Scalars['String']['input'];
  mostActiveSocial: Scalars['String']['input'];
  musicTastes: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  nicknameBackground: Scalars['String']['input'];
  occupation: Scalars['String']['input'];
  phrase: Scalars['String']['input'];
  picture?: InputMaybe<UserProfilePictureFieldInput>;
  realName: Scalars['String']['input'];
  ship: Scalars['String']['input'];
  socialLinks?: InputMaybe<UserProfileSocialLinksFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProfileDeleteFieldInput = {
  delete?: InputMaybe<UserProfileDeleteInput>;
  where?: InputMaybe<UserProfileConnectionWhere>;
};

export type UserProfileDeleteInput = {
  background?: InputMaybe<UserProfileBackgroundDeleteFieldInput>;
  picture?: InputMaybe<UserProfilePictureDeleteFieldInput>;
  socialLinks?: InputMaybe<Array<UserProfileSocialLinksDeleteFieldInput>>;
};

export type UserProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<UserProfileDisconnectInput>;
  where?: InputMaybe<UserProfileConnectionWhere>;
};

export type UserProfileDisconnectInput = {
  background?: InputMaybe<UserProfileBackgroundDisconnectFieldInput>;
  picture?: InputMaybe<UserProfilePictureDisconnectFieldInput>;
  socialLinks?: InputMaybe<Array<UserProfileSocialLinksDisconnectFieldInput>>;
};

export type UserProfileFieldInput = {
  connect?: InputMaybe<UserProfileConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfileConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfileCreateFieldInput>;
};

export type UserProfileFileBackgroundAggregationSelection = {
  __typename?: 'UserProfileFileBackgroundAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserProfileFileBackgroundNodeAggregateSelection>;
};

export type UserProfileFileBackgroundNodeAggregateSelection = {
  __typename?: 'UserProfileFileBackgroundNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type UserProfileFilePictureAggregationSelection = {
  __typename?: 'UserProfileFilePictureAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserProfileFilePictureNodeAggregateSelection>;
};

export type UserProfileFilePictureNodeAggregateSelection = {
  __typename?: 'UserProfileFilePictureNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  hash: StringAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  name: StringAggregateSelection;
  size: IntAggregateSelection;
};

export type UserProfileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserProfileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserProfileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserProfileNodeAggregationWhereInput>>;
  animeTastes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  animeTastes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  animeTastes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  animeTastes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  animeTastes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  animeTastes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  animeTastes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthdate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  blurb_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  blurb_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  blurb_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  blurb_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  blurb_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  blurb_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  blurb_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  blurb_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  blurb_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  blurb_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  blurb_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  blurb_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  blurb_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  blurb_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  blurb_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countriesToGo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countriesToGo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countriesToGo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countriesToGo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countriesToGo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesToGo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  customTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  customTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  customTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  customTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  customTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  customTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  customTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  customTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  customTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  customTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dislikes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dislikes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dislikes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dislikes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dislikes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dislikes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dislikes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dislikes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dislikes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dislikes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dislikes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dislikes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dislikes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dislikes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dislikes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  doramaTastes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  doramaTastes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  doramaTastes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  doramaTastes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  doramaTastes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  doramaTastes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favAsianCulture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favAsianCulture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favAsianCulture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favAsianCulture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favAsianCulture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favAsianCulture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favFood_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favFood_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favFood_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favFood_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favFood_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favFood_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favFood_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favFood_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favFood_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favFood_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favFood_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favFood_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favFood_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favFood_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favFood_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favPerson_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favPerson_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favPerson_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favPerson_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favPerson_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favPerson_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favPerson_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favPerson_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favPerson_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favPerson_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favPerson_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favPerson_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favPerson_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favPerson_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favPerson_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameTastes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameTastes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameTastes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameTastes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameTastes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameTastes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hobbies_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hobbies_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hobbies_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hobbies_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hobbies_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hobbies_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hobbies_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hobbies_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hobbies_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hobbies_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hobbies_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hobbies_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hobbies_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hobbies_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hobbies_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  likes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  likes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  likes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  likes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  likes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  likes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  likes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  likes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  likes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  likes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  likes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  likes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  likes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  likes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  likes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  location_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  location_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  location_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  location_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  location_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  location_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  location_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  location_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  location_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  location_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  location_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  location_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  location_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  location_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  location_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mostActiveSocial_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mostActiveSocial_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mostActiveSocial_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mostActiveSocial_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mostActiveSocial_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mostActiveSocial_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  musicTastes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  musicTastes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  musicTastes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  musicTastes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  musicTastes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  musicTastes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nicknameBackground_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nicknameBackground_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nicknameBackground_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nicknameBackground_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nicknameBackground_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nicknameBackground_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nickname_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nickname_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nickname_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nickname_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nickname_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nickname_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nickname_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nickname_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nickname_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nickname_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nickname_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nickname_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nickname_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nickname_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nickname_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  occupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  occupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  occupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  occupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  occupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  occupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  occupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  occupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  occupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  occupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  occupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  occupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  occupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  occupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  occupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phrase_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phrase_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phrase_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phrase_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phrase_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phrase_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phrase_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phrase_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phrase_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phrase_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phrase_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phrase_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phrase_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phrase_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phrase_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  realName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  realName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  realName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  realName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  realName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  realName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  realName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  realName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  realName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  realName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  realName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  realName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  realName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  realName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  realName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ship_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ship_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ship_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ship_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ship_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ship_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ship_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ship_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ship_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ship_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ship_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ship_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ship_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ship_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ship_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProfileOnCreateInput = {
  animeTastes: Scalars['String']['input'];
  birthdate: Scalars['DateTime']['input'];
  blurb: Scalars['String']['input'];
  countriesToGo: Scalars['String']['input'];
  customTitle: Scalars['String']['input'];
  dislikes: Scalars['String']['input'];
  doramaTastes: Scalars['String']['input'];
  favAsianCulture: Scalars['String']['input'];
  favFood: Scalars['String']['input'];
  favPerson: Scalars['String']['input'];
  gameTastes: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  hobbies: Scalars['String']['input'];
  likes: Scalars['String']['input'];
  location: Scalars['String']['input'];
  mostActiveSocial: Scalars['String']['input'];
  musicTastes: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  nicknameBackground: Scalars['String']['input'];
  occupation: Scalars['String']['input'];
  phrase: Scalars['String']['input'];
  realName: Scalars['String']['input'];
  ship: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProfileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserProfileSort objects to sort UserProfiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserProfileSort>>;
};

export type UserProfilePictureAggregateInput = {
  AND?: InputMaybe<Array<UserProfilePictureAggregateInput>>;
  NOT?: InputMaybe<UserProfilePictureAggregateInput>;
  OR?: InputMaybe<Array<UserProfilePictureAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserProfilePictureNodeAggregationWhereInput>;
};

export type UserProfilePictureConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type UserProfilePictureConnectOrCreateFieldInput = {
  onCreate: UserProfilePictureConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type UserProfilePictureConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type UserProfilePictureConnection = {
  __typename?: 'UserProfilePictureConnection';
  edges: Array<UserProfilePictureRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserProfilePictureConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type UserProfilePictureConnectionWhere = {
  AND?: InputMaybe<Array<UserProfilePictureConnectionWhere>>;
  NOT?: InputMaybe<UserProfilePictureConnectionWhere>;
  OR?: InputMaybe<Array<UserProfilePictureConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type UserProfilePictureCreateFieldInput = {
  node: FileCreateInput;
};

export type UserProfilePictureDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<UserProfilePictureConnectionWhere>;
};

export type UserProfilePictureDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<UserProfilePictureConnectionWhere>;
};

export type UserProfilePictureFieldInput = {
  connect?: InputMaybe<UserProfilePictureConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfilePictureConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfilePictureCreateFieldInput>;
};

export type UserProfilePictureNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserProfilePictureNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserProfilePictureNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserProfilePictureNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hash_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hash_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hash_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProfilePictureRelationship = {
  __typename?: 'UserProfilePictureRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type UserProfilePictureUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type UserProfilePictureUpdateFieldInput = {
  connect?: InputMaybe<UserProfilePictureConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfilePictureConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfilePictureCreateFieldInput>;
  delete?: InputMaybe<UserProfilePictureDeleteFieldInput>;
  disconnect?: InputMaybe<UserProfilePictureDisconnectFieldInput>;
  update?: InputMaybe<UserProfilePictureUpdateConnectionInput>;
  where?: InputMaybe<UserProfilePictureConnectionWhere>;
};

export type UserProfileRelationship = {
  __typename?: 'UserProfileRelationship';
  cursor: Scalars['String']['output'];
  node: UserProfile;
};

export type UserProfileSocialLinksAggregateInput = {
  AND?: InputMaybe<Array<UserProfileSocialLinksAggregateInput>>;
  NOT?: InputMaybe<UserProfileSocialLinksAggregateInput>;
  OR?: InputMaybe<Array<UserProfileSocialLinksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserProfileSocialLinksNodeAggregationWhereInput>;
};

export type UserProfileSocialLinksConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserSocialLinkConnectWhere>;
};

export type UserProfileSocialLinksConnectOrCreateFieldInput = {
  onCreate: UserProfileSocialLinksConnectOrCreateFieldInputOnCreate;
  where: UserSocialLinkConnectOrCreateWhere;
};

export type UserProfileSocialLinksConnectOrCreateFieldInputOnCreate = {
  node: UserSocialLinkOnCreateInput;
};

export type UserProfileSocialLinksConnection = {
  __typename?: 'UserProfileSocialLinksConnection';
  edges: Array<UserProfileSocialLinksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserProfileSocialLinksConnectionSort = {
  node?: InputMaybe<UserSocialLinkSort>;
};

export type UserProfileSocialLinksConnectionWhere = {
  AND?: InputMaybe<Array<UserProfileSocialLinksConnectionWhere>>;
  NOT?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
  OR?: InputMaybe<Array<UserProfileSocialLinksConnectionWhere>>;
  node?: InputMaybe<UserSocialLinkWhere>;
};

export type UserProfileSocialLinksCreateFieldInput = {
  node: UserSocialLinkCreateInput;
};

export type UserProfileSocialLinksDeleteFieldInput = {
  where?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
};

export type UserProfileSocialLinksDisconnectFieldInput = {
  where?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
};

export type UserProfileSocialLinksFieldInput = {
  connect?: InputMaybe<Array<UserProfileSocialLinksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserProfileSocialLinksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserProfileSocialLinksCreateFieldInput>>;
};

export type UserProfileSocialLinksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserProfileSocialLinksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserProfileSocialLinksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserProfileSocialLinksNodeAggregationWhereInput>>;
  link_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  link_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  link_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  link_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  link_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  link_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  link_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  link_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  link_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  link_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  link_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProfileSocialLinksRelationship = {
  __typename?: 'UserProfileSocialLinksRelationship';
  cursor: Scalars['String']['output'];
  node: UserSocialLink;
};

export type UserProfileSocialLinksUpdateConnectionInput = {
  node?: InputMaybe<UserSocialLinkUpdateInput>;
};

export type UserProfileSocialLinksUpdateFieldInput = {
  connect?: InputMaybe<Array<UserProfileSocialLinksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserProfileSocialLinksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserProfileSocialLinksCreateFieldInput>>;
  delete?: InputMaybe<Array<UserProfileSocialLinksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserProfileSocialLinksDisconnectFieldInput>>;
  update?: InputMaybe<UserProfileSocialLinksUpdateConnectionInput>;
  where?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
};

/** Fields to sort UserProfiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserProfileSort object. */
export type UserProfileSort = {
  animeTastes?: InputMaybe<SortDirection>;
  birthdate?: InputMaybe<SortDirection>;
  blurb?: InputMaybe<SortDirection>;
  countriesToGo?: InputMaybe<SortDirection>;
  customTitle?: InputMaybe<SortDirection>;
  dislikes?: InputMaybe<SortDirection>;
  doramaTastes?: InputMaybe<SortDirection>;
  favAsianCulture?: InputMaybe<SortDirection>;
  favFood?: InputMaybe<SortDirection>;
  favPerson?: InputMaybe<SortDirection>;
  gameTastes?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  hobbies?: InputMaybe<SortDirection>;
  likes?: InputMaybe<SortDirection>;
  location?: InputMaybe<SortDirection>;
  mostActiveSocial?: InputMaybe<SortDirection>;
  musicTastes?: InputMaybe<SortDirection>;
  nickname?: InputMaybe<SortDirection>;
  nicknameBackground?: InputMaybe<SortDirection>;
  occupation?: InputMaybe<SortDirection>;
  phrase?: InputMaybe<SortDirection>;
  realName?: InputMaybe<SortDirection>;
  ship?: InputMaybe<SortDirection>;
  slug?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type UserProfileUniqueWhere = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileUpdateConnectionInput = {
  node?: InputMaybe<UserProfileUpdateInput>;
};

export type UserProfileUpdateFieldInput = {
  connect?: InputMaybe<UserProfileConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserProfileConnectOrCreateFieldInput>;
  create?: InputMaybe<UserProfileCreateFieldInput>;
  delete?: InputMaybe<UserProfileDeleteFieldInput>;
  disconnect?: InputMaybe<UserProfileDisconnectFieldInput>;
  update?: InputMaybe<UserProfileUpdateConnectionInput>;
  where?: InputMaybe<UserProfileConnectionWhere>;
};

export type UserProfileUpdateInput = {
  animeTastes?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<UserProfileBackgroundUpdateFieldInput>;
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  blurb?: InputMaybe<Scalars['String']['input']>;
  countriesToGo?: InputMaybe<Scalars['String']['input']>;
  customTitle?: InputMaybe<Scalars['String']['input']>;
  dislikes?: InputMaybe<Scalars['String']['input']>;
  doramaTastes?: InputMaybe<Scalars['String']['input']>;
  favAsianCulture?: InputMaybe<Scalars['String']['input']>;
  favFood?: InputMaybe<Scalars['String']['input']>;
  favPerson?: InputMaybe<Scalars['String']['input']>;
  gameTastes?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hobbies?: InputMaybe<Scalars['String']['input']>;
  likes?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mostActiveSocial?: InputMaybe<Scalars['String']['input']>;
  musicTastes?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nicknameBackground?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  phrase?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<UserProfilePictureUpdateFieldInput>;
  realName?: InputMaybe<Scalars['String']['input']>;
  ship?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialLinks?: InputMaybe<Array<UserProfileSocialLinksUpdateFieldInput>>;
};

export type UserProfileUserSocialLinkSocialLinksAggregationSelection = {
  __typename?: 'UserProfileUserSocialLinkSocialLinksAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserProfileUserSocialLinkSocialLinksNodeAggregateSelection>;
};

export type UserProfileUserSocialLinkSocialLinksNodeAggregateSelection = {
  __typename?: 'UserProfileUserSocialLinkSocialLinksNodeAggregateSelection';
  id: IdAggregateSelection;
  link: StringAggregateSelection;
};

export type UserProfileWhere = {
  AND?: InputMaybe<Array<UserProfileWhere>>;
  NOT?: InputMaybe<UserProfileWhere>;
  OR?: InputMaybe<Array<UserProfileWhere>>;
  animeTastes?: InputMaybe<Scalars['String']['input']>;
  animeTastes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  animeTastes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  animeTastes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  animeTastes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<FileWhere>;
  backgroundAggregate?: InputMaybe<UserProfileBackgroundAggregateInput>;
  backgroundConnection?: InputMaybe<UserProfileBackgroundConnectionWhere>;
  backgroundConnection_NOT?: InputMaybe<UserProfileBackgroundConnectionWhere>;
  background_NOT?: InputMaybe<FileWhere>;
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  birthdate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthdate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  blurb?: InputMaybe<Scalars['String']['input']>;
  blurb_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  blurb_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  blurb_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  blurb_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countriesToGo?: InputMaybe<Scalars['String']['input']>;
  countriesToGo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countriesToGo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countriesToGo_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countriesToGo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  customTitle?: InputMaybe<Scalars['String']['input']>;
  customTitle_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  customTitle_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  customTitle_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  customTitle_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dislikes?: InputMaybe<Scalars['String']['input']>;
  dislikes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dislikes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dislikes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  dislikes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  doramaTastes?: InputMaybe<Scalars['String']['input']>;
  doramaTastes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  doramaTastes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  doramaTastes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  doramaTastes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favAsianCulture?: InputMaybe<Scalars['String']['input']>;
  favAsianCulture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favAsianCulture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favAsianCulture_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  favAsianCulture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favFood?: InputMaybe<Scalars['String']['input']>;
  favFood_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favFood_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favFood_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  favFood_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favPerson?: InputMaybe<Scalars['String']['input']>;
  favPerson_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favPerson_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favPerson_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  favPerson_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameTastes?: InputMaybe<Scalars['String']['input']>;
  gameTastes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gameTastes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameTastes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  gameTastes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gender_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hobbies?: InputMaybe<Scalars['String']['input']>;
  hobbies_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hobbies_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hobbies_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  hobbies_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  likes?: InputMaybe<Scalars['String']['input']>;
  likes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  likes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  likes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  likes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  location_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  location_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  location_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mostActiveSocial?: InputMaybe<Scalars['String']['input']>;
  mostActiveSocial_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mostActiveSocial_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mostActiveSocial_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  mostActiveSocial_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  musicTastes?: InputMaybe<Scalars['String']['input']>;
  musicTastes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  musicTastes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  musicTastes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  musicTastes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nicknameBackground?: InputMaybe<Scalars['String']['input']>;
  nicknameBackground_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nicknameBackground_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nicknameBackground_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  nicknameBackground_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nickname_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nickname_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nickname_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  occupation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  occupation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  occupation_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  occupation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  phrase?: InputMaybe<Scalars['String']['input']>;
  phrase_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phrase_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phrase_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  phrase_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<FileWhere>;
  pictureAggregate?: InputMaybe<UserProfilePictureAggregateInput>;
  pictureConnection?: InputMaybe<UserProfilePictureConnectionWhere>;
  pictureConnection_NOT?: InputMaybe<UserProfilePictureConnectionWhere>;
  picture_NOT?: InputMaybe<FileWhere>;
  realName?: InputMaybe<Scalars['String']['input']>;
  realName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  realName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  realName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  realName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ship?: InputMaybe<Scalars['String']['input']>;
  ship_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ship_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ship_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  ship_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  slug_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  slug_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  socialLinksAggregate?: InputMaybe<UserProfileSocialLinksAggregateInput>;
  /** Return UserProfiles where all of the related UserProfileSocialLinksConnections match this filter */
  socialLinksConnection_ALL?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
  /** Return UserProfiles where none of the related UserProfileSocialLinksConnections match this filter */
  socialLinksConnection_NONE?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
  /** Return UserProfiles where one of the related UserProfileSocialLinksConnections match this filter */
  socialLinksConnection_SINGLE?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
  /** Return UserProfiles where some of the related UserProfileSocialLinksConnections match this filter */
  socialLinksConnection_SOME?: InputMaybe<UserProfileSocialLinksConnectionWhere>;
  /** Return UserProfiles where all of the related UserSocialLinks match this filter */
  socialLinks_ALL?: InputMaybe<UserSocialLinkWhere>;
  /** Return UserProfiles where none of the related UserSocialLinks match this filter */
  socialLinks_NONE?: InputMaybe<UserSocialLinkWhere>;
  /** Return UserProfiles where one of the related UserSocialLinks match this filter */
  socialLinks_SINGLE?: InputMaybe<UserSocialLinkWhere>;
  /** Return UserProfiles where some of the related UserSocialLinks match this filter */
  socialLinks_SOME?: InputMaybe<UserSocialLinkWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserRadioShowRadioShowsAggregationSelection = {
  __typename?: 'UserRadioShowRadioShowsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserRadioShowRadioShowsNodeAggregateSelection>;
};

export type UserRadioShowRadioShowsNodeAggregateSelection = {
  __typename?: 'UserRadioShowRadioShowsNodeAggregateSelection';
  deletedAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  genre: StringAggregateSelection;
  id: IdAggregateSelection;
  slug: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type UserRadioShowsAggregateInput = {
  AND?: InputMaybe<Array<UserRadioShowsAggregateInput>>;
  NOT?: InputMaybe<UserRadioShowsAggregateInput>;
  OR?: InputMaybe<Array<UserRadioShowsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserRadioShowsNodeAggregationWhereInput>;
};

export type UserRadioShowsConnectFieldInput = {
  connect?: InputMaybe<Array<RadioShowConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RadioShowConnectWhere>;
};

export type UserRadioShowsConnectOrCreateFieldInput = {
  onCreate: UserRadioShowsConnectOrCreateFieldInputOnCreate;
  where: RadioShowConnectOrCreateWhere;
};

export type UserRadioShowsConnectOrCreateFieldInputOnCreate = {
  node: RadioShowOnCreateInput;
};

export type UserRadioShowsConnection = {
  __typename?: 'UserRadioShowsConnection';
  edges: Array<UserRadioShowsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserRadioShowsConnectionSort = {
  node?: InputMaybe<RadioShowSort>;
};

export type UserRadioShowsConnectionWhere = {
  AND?: InputMaybe<Array<UserRadioShowsConnectionWhere>>;
  NOT?: InputMaybe<UserRadioShowsConnectionWhere>;
  OR?: InputMaybe<Array<UserRadioShowsConnectionWhere>>;
  node?: InputMaybe<RadioShowWhere>;
};

export type UserRadioShowsCreateFieldInput = {
  node: RadioShowCreateInput;
};

export type UserRadioShowsDeleteFieldInput = {
  delete?: InputMaybe<RadioShowDeleteInput>;
  where?: InputMaybe<UserRadioShowsConnectionWhere>;
};

export type UserRadioShowsDisconnectFieldInput = {
  disconnect?: InputMaybe<RadioShowDisconnectInput>;
  where?: InputMaybe<UserRadioShowsConnectionWhere>;
};

export type UserRadioShowsFieldInput = {
  connect?: InputMaybe<Array<UserRadioShowsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserRadioShowsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserRadioShowsCreateFieldInput>>;
};

export type UserRadioShowsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserRadioShowsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserRadioShowsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserRadioShowsNodeAggregationWhereInput>>;
  deletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  genre_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  genre_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  genre_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  slug_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  slug_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  slug_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRadioShowsRelationship = {
  __typename?: 'UserRadioShowsRelationship';
  cursor: Scalars['String']['output'];
  node: RadioShow;
};

export type UserRadioShowsUpdateConnectionInput = {
  node?: InputMaybe<RadioShowUpdateInput>;
};

export type UserRadioShowsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserRadioShowsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserRadioShowsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserRadioShowsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserRadioShowsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserRadioShowsDisconnectFieldInput>>;
  update?: InputMaybe<UserRadioShowsUpdateConnectionInput>;
  where?: InputMaybe<UserRadioShowsConnectionWhere>;
};

export type UserRelationInput = {
  appkeys?: InputMaybe<Array<UserAppkeysCreateFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesCreateFieldInput>>;
  passkeys?: InputMaybe<Array<UserPasskeysCreateFieldInput>>;
  posts?: InputMaybe<Array<UserPostsCreateFieldInput>>;
  profile?: InputMaybe<UserProfileCreateFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsCreateFieldInput>>;
  songRequests?: InputMaybe<Array<UserSongRequestsCreateFieldInput>>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Audio = 'AUDIO',
  AudioAdmin = 'AUDIO_ADMIN',
  Author = 'AUTHOR',
  AuthorAdmin = 'AUTHOR_ADMIN',
  Dj = 'DJ',
  DjAdmin = 'DJ_ADMIN',
  Pr = 'PR',
  PrAdmin = 'PR_ADMIN',
  Super = 'SUPER'
}

export type UserSettingsResponse = {
  __typename?: 'UserSettingsResponse';
  email: Scalars['EmailAddress']['output'];
  passwordUpdatedAt: Scalars['DateTime']['output'];
  securityCodes?: Maybe<Array<Scalars['String']['output']>>;
  tfaEnabled: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type UserSocialLink = {
  __typename?: 'UserSocialLink';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: SocialType;
};

export type UserSocialLinkConnectOrCreateWhere = {
  node: UserSocialLinkUniqueWhere;
};

export type UserSocialLinkConnectWhere = {
  node: UserSocialLinkWhere;
};

export type UserSocialLinkCreateInput = {
  link: Scalars['String']['input'];
  type: SocialType;
};

export type UserSocialLinkOnCreateInput = {
  link: Scalars['String']['input'];
  type: SocialType;
};

export type UserSocialLinkOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserSocialLinkSort objects to sort UserSocialLinks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSocialLinkSort>>;
};

/** Fields to sort UserSocialLinks by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSocialLinkSort object. */
export type UserSocialLinkSort = {
  id?: InputMaybe<SortDirection>;
  link?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type UserSocialLinkUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserSocialLinkUpdateInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SocialType>;
};

export type UserSocialLinkWhere = {
  AND?: InputMaybe<Array<UserSocialLinkWhere>>;
  NOT?: InputMaybe<UserSocialLinkWhere>;
  OR?: InputMaybe<Array<UserSocialLinkWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  link_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  link_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  link_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SocialType>;
  type_IN?: InputMaybe<Array<SocialType>>;
};

export type UserSongRequestSongRequestsAggregationSelection = {
  __typename?: 'UserSongRequestSongRequestsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserSongRequestSongRequestsNodeAggregateSelection>;
};

export type UserSongRequestSongRequestsNodeAggregateSelection = {
  __typename?: 'UserSongRequestSongRequestsNodeAggregateSelection';
  author: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  ip: StringAggregateSelection;
  message: StringAggregateSelection;
  readAt: DateTimeAggregateSelection;
  song: StringAggregateSelection;
};

export type UserSongRequestsAggregateInput = {
  AND?: InputMaybe<Array<UserSongRequestsAggregateInput>>;
  NOT?: InputMaybe<UserSongRequestsAggregateInput>;
  OR?: InputMaybe<Array<UserSongRequestsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSongRequestsNodeAggregationWhereInput>;
};

export type UserSongRequestsConnectFieldInput = {
  connect?: InputMaybe<Array<SongRequestConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SongRequestConnectWhere>;
};

export type UserSongRequestsConnectOrCreateFieldInput = {
  onCreate: UserSongRequestsConnectOrCreateFieldInputOnCreate;
  where: SongRequestConnectOrCreateWhere;
};

export type UserSongRequestsConnectOrCreateFieldInputOnCreate = {
  node: SongRequestOnCreateInput;
};

export type UserSongRequestsConnection = {
  __typename?: 'UserSongRequestsConnection';
  edges: Array<UserSongRequestsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSongRequestsConnectionSort = {
  node?: InputMaybe<SongRequestSort>;
};

export type UserSongRequestsConnectionWhere = {
  AND?: InputMaybe<Array<UserSongRequestsConnectionWhere>>;
  NOT?: InputMaybe<UserSongRequestsConnectionWhere>;
  OR?: InputMaybe<Array<UserSongRequestsConnectionWhere>>;
  node?: InputMaybe<SongRequestWhere>;
};

export type UserSongRequestsCreateFieldInput = {
  node: SongRequestCreateInput;
};

export type UserSongRequestsDeleteFieldInput = {
  delete?: InputMaybe<SongRequestDeleteInput>;
  where?: InputMaybe<UserSongRequestsConnectionWhere>;
};

export type UserSongRequestsDisconnectFieldInput = {
  disconnect?: InputMaybe<SongRequestDisconnectInput>;
  where?: InputMaybe<UserSongRequestsConnectionWhere>;
};

export type UserSongRequestsFieldInput = {
  connect?: InputMaybe<Array<UserSongRequestsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSongRequestsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSongRequestsCreateFieldInput>>;
};

export type UserSongRequestsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSongRequestsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSongRequestsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSongRequestsNodeAggregationWhereInput>>;
  author_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  author_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  author_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  author_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  author_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  author_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  author_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  author_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  author_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  author_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  author_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  author_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  author_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  author_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  author_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  ip_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ip_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ip_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ip_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ip_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ip_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ip_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ip_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ip_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ip_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ip_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ip_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ip_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ip_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ip_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  readAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  song_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  song_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  song_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  song_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  song_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  song_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  song_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  song_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  song_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  song_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  song_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  song_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  song_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  song_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  song_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSongRequestsRelationship = {
  __typename?: 'UserSongRequestsRelationship';
  cursor: Scalars['String']['output'];
  node: SongRequest;
};

export type UserSongRequestsUpdateConnectionInput = {
  node?: InputMaybe<SongRequestUpdateInput>;
};

export type UserSongRequestsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserSongRequestsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSongRequestsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSongRequestsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserSongRequestsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserSongRequestsDisconnectFieldInput>>;
  update?: InputMaybe<UserSongRequestsUpdateConnectionInput>;
  where?: InputMaybe<UserSongRequestsConnectionWhere>;
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
  appkeyCount?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  deletedAt?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  hasPassword?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAway?: InputMaybe<SortDirection>;
  lastLogin?: InputMaybe<SortDirection>;
  passkeyCount?: InputMaybe<SortDirection>;
  password?: InputMaybe<SortDirection>;
  passwordUpdatedAt?: InputMaybe<SortDirection>;
  postAbsenceCount?: InputMaybe<SortDirection>;
  remainingCodes?: InputMaybe<SortDirection>;
  resetPasswordToken?: InputMaybe<SortDirection>;
  streamingAbsenceCount?: InputMaybe<SortDirection>;
  tfaEnabled?: InputMaybe<SortDirection>;
  tfaSecret?: InputMaybe<SortDirection>;
  username?: InputMaybe<SortDirection>;
};

export type UserUniqueWhere = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserUpdateInput = {
  appkeys?: InputMaybe<Array<UserAppkeysUpdateFieldInput>>;
  categories?: InputMaybe<Array<UserCategoriesUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  isAway?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  passkeys?: InputMaybe<Array<UserPasskeysUpdateFieldInput>>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  passwordUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  postAbsenceCount?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  posts?: InputMaybe<Array<UserPostsUpdateFieldInput>>;
  profile?: InputMaybe<UserProfileUpdateFieldInput>;
  radioShows?: InputMaybe<Array<UserRadioShowsUpdateFieldInput>>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRole>>;
  securityCodes?: InputMaybe<Array<Scalars['Secret']['input']>>;
  songRequests?: InputMaybe<Array<UserSongRequestsUpdateFieldInput>>;
  streamingAbsenceCount?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  tfaSecret?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserUserAppkeyAppkeysAggregationSelection = {
  __typename?: 'UserUserAppkeyAppkeysAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserAppkeyAppkeysNodeAggregateSelection>;
};

export type UserUserAppkeyAppkeysNodeAggregateSelection = {
  __typename?: 'UserUserAppkeyAppkeysNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  credentialID: StringAggregateSelection;
  lastUsedAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  purpose: StringAggregateSelection;
};

export type UserUserPasskeyPasskeysAggregationSelection = {
  __typename?: 'UserUserPasskeyPasskeysAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserPasskeyPasskeysNodeAggregateSelection>;
};

export type UserUserPasskeyPasskeysNodeAggregateSelection = {
  __typename?: 'UserUserPasskeyPasskeysNodeAggregateSelection';
  counter: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  credentialDeviceType: StringAggregateSelection;
  credentialID: StringAggregateSelection;
  credentialPublicKey: StringAggregateSelection;
  lastUsedAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type UserUserProfileProfileAggregationSelection = {
  __typename?: 'UserUserProfileProfileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserProfileProfileNodeAggregateSelection>;
};

export type UserUserProfileProfileNodeAggregateSelection = {
  __typename?: 'UserUserProfileProfileNodeAggregateSelection';
  animeTastes: StringAggregateSelection;
  birthdate: DateTimeAggregateSelection;
  blurb: StringAggregateSelection;
  countriesToGo: StringAggregateSelection;
  customTitle: StringAggregateSelection;
  dislikes: StringAggregateSelection;
  doramaTastes: StringAggregateSelection;
  favAsianCulture: StringAggregateSelection;
  favFood: StringAggregateSelection;
  favPerson: StringAggregateSelection;
  gameTastes: StringAggregateSelection;
  gender: StringAggregateSelection;
  hobbies: StringAggregateSelection;
  likes: StringAggregateSelection;
  location: StringAggregateSelection;
  mostActiveSocial: StringAggregateSelection;
  musicTastes: StringAggregateSelection;
  nickname: StringAggregateSelection;
  nicknameBackground: StringAggregateSelection;
  occupation: StringAggregateSelection;
  phrase: StringAggregateSelection;
  realName: StringAggregateSelection;
  ship: StringAggregateSelection;
  slug: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<UserWhere>;
  OR?: InputMaybe<Array<UserWhere>>;
  allCategories?: InputMaybe<CategoryWhere>;
  allCategories_ALL?: InputMaybe<CategoryWhere>;
  allCategories_NONE?: InputMaybe<CategoryWhere>;
  allCategories_SINGLE?: InputMaybe<CategoryWhere>;
  allCategories_SOME?: InputMaybe<CategoryWhere>;
  appkeyCount?: InputMaybe<Scalars['Int']['input']>;
  appkeyCount_GT?: InputMaybe<Scalars['Int']['input']>;
  appkeyCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  appkeyCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  appkeyCount_LT?: InputMaybe<Scalars['Int']['input']>;
  appkeyCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  appkeysAggregate?: InputMaybe<UserAppkeysAggregateInput>;
  /** Return Users where all of the related UserAppkeysConnections match this filter */
  appkeysConnection_ALL?: InputMaybe<UserAppkeysConnectionWhere>;
  /** Return Users where none of the related UserAppkeysConnections match this filter */
  appkeysConnection_NONE?: InputMaybe<UserAppkeysConnectionWhere>;
  /** Return Users where one of the related UserAppkeysConnections match this filter */
  appkeysConnection_SINGLE?: InputMaybe<UserAppkeysConnectionWhere>;
  /** Return Users where some of the related UserAppkeysConnections match this filter */
  appkeysConnection_SOME?: InputMaybe<UserAppkeysConnectionWhere>;
  /** Return Users where all of the related UserAppkeys match this filter */
  appkeys_ALL?: InputMaybe<UserAppkeyWhere>;
  /** Return Users where none of the related UserAppkeys match this filter */
  appkeys_NONE?: InputMaybe<UserAppkeyWhere>;
  /** Return Users where one of the related UserAppkeys match this filter */
  appkeys_SINGLE?: InputMaybe<UserAppkeyWhere>;
  /** Return Users where some of the related UserAppkeys match this filter */
  appkeys_SOME?: InputMaybe<UserAppkeyWhere>;
  categoriesAggregate?: InputMaybe<UserCategoriesAggregateInput>;
  /** Return Users where all of the related UserCategoriesConnections match this filter */
  categoriesConnection_ALL?: InputMaybe<UserCategoriesConnectionWhere>;
  /** Return Users where none of the related UserCategoriesConnections match this filter */
  categoriesConnection_NONE?: InputMaybe<UserCategoriesConnectionWhere>;
  /** Return Users where one of the related UserCategoriesConnections match this filter */
  categoriesConnection_SINGLE?: InputMaybe<UserCategoriesConnectionWhere>;
  /** Return Users where some of the related UserCategoriesConnections match this filter */
  categoriesConnection_SOME?: InputMaybe<UserCategoriesConnectionWhere>;
  /** Return Users where all of the related Categories match this filter */
  categories_ALL?: InputMaybe<CategoryWhere>;
  /** Return Users where none of the related Categories match this filter */
  categories_NONE?: InputMaybe<CategoryWhere>;
  /** Return Users where one of the related Categories match this filter */
  categories_SINGLE?: InputMaybe<CategoryWhere>;
  /** Return Users where some of the related Categories match this filter */
  categories_SOME?: InputMaybe<CategoryWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  email_IN?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAway?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastLogin_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLogin_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passkeyCount?: InputMaybe<Scalars['Int']['input']>;
  passkeyCount_GT?: InputMaybe<Scalars['Int']['input']>;
  passkeyCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  passkeyCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  passkeyCount_LT?: InputMaybe<Scalars['Int']['input']>;
  passkeyCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  passkeysAggregate?: InputMaybe<UserPasskeysAggregateInput>;
  /** Return Users where all of the related UserPasskeysConnections match this filter */
  passkeysConnection_ALL?: InputMaybe<UserPasskeysConnectionWhere>;
  /** Return Users where none of the related UserPasskeysConnections match this filter */
  passkeysConnection_NONE?: InputMaybe<UserPasskeysConnectionWhere>;
  /** Return Users where one of the related UserPasskeysConnections match this filter */
  passkeysConnection_SINGLE?: InputMaybe<UserPasskeysConnectionWhere>;
  /** Return Users where some of the related UserPasskeysConnections match this filter */
  passkeysConnection_SOME?: InputMaybe<UserPasskeysConnectionWhere>;
  /** Return Users where all of the related UserPasskeys match this filter */
  passkeys_ALL?: InputMaybe<UserPasskeyWhere>;
  /** Return Users where none of the related UserPasskeys match this filter */
  passkeys_NONE?: InputMaybe<UserPasskeyWhere>;
  /** Return Users where one of the related UserPasskeys match this filter */
  passkeys_SINGLE?: InputMaybe<UserPasskeyWhere>;
  /** Return Users where some of the related UserPasskeys match this filter */
  passkeys_SOME?: InputMaybe<UserPasskeyWhere>;
  password?: InputMaybe<Scalars['Secret']['input']>;
  passwordUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  passwordUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  password_IN?: InputMaybe<Array<InputMaybe<Scalars['Secret']['input']>>>;
  postAbsenceCount?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_GT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  postAbsenceCount_LT?: InputMaybe<Scalars['Int']['input']>;
  postAbsenceCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  postsAggregate?: InputMaybe<UserPostsAggregateInput>;
  /** Return Users where all of the related UserPostsConnections match this filter */
  postsConnection_ALL?: InputMaybe<UserPostsConnectionWhere>;
  /** Return Users where none of the related UserPostsConnections match this filter */
  postsConnection_NONE?: InputMaybe<UserPostsConnectionWhere>;
  /** Return Users where one of the related UserPostsConnections match this filter */
  postsConnection_SINGLE?: InputMaybe<UserPostsConnectionWhere>;
  /** Return Users where some of the related UserPostsConnections match this filter */
  postsConnection_SOME?: InputMaybe<UserPostsConnectionWhere>;
  /** Return Users where all of the related Posts match this filter */
  posts_ALL?: InputMaybe<PostWhere>;
  /** Return Users where none of the related Posts match this filter */
  posts_NONE?: InputMaybe<PostWhere>;
  /** Return Users where one of the related Posts match this filter */
  posts_SINGLE?: InputMaybe<PostWhere>;
  /** Return Users where some of the related Posts match this filter */
  posts_SOME?: InputMaybe<PostWhere>;
  profile?: InputMaybe<UserProfileWhere>;
  profileAggregate?: InputMaybe<UserProfileAggregateInput>;
  profileConnection?: InputMaybe<UserProfileConnectionWhere>;
  profileConnection_NOT?: InputMaybe<UserProfileConnectionWhere>;
  profile_NOT?: InputMaybe<UserProfileWhere>;
  radioShowsAggregate?: InputMaybe<UserRadioShowsAggregateInput>;
  /** Return Users where all of the related UserRadioShowsConnections match this filter */
  radioShowsConnection_ALL?: InputMaybe<UserRadioShowsConnectionWhere>;
  /** Return Users where none of the related UserRadioShowsConnections match this filter */
  radioShowsConnection_NONE?: InputMaybe<UserRadioShowsConnectionWhere>;
  /** Return Users where one of the related UserRadioShowsConnections match this filter */
  radioShowsConnection_SINGLE?: InputMaybe<UserRadioShowsConnectionWhere>;
  /** Return Users where some of the related UserRadioShowsConnections match this filter */
  radioShowsConnection_SOME?: InputMaybe<UserRadioShowsConnectionWhere>;
  /** Return Users where all of the related RadioShows match this filter */
  radioShows_ALL?: InputMaybe<RadioShowWhere>;
  /** Return Users where none of the related RadioShows match this filter */
  radioShows_NONE?: InputMaybe<RadioShowWhere>;
  /** Return Users where one of the related RadioShows match this filter */
  radioShows_SINGLE?: InputMaybe<RadioShowWhere>;
  /** Return Users where some of the related RadioShows match this filter */
  radioShows_SOME?: InputMaybe<RadioShowWhere>;
  remainingCodes?: InputMaybe<Scalars['Int']['input']>;
  remainingCodes_GT?: InputMaybe<Scalars['Int']['input']>;
  remainingCodes_GTE?: InputMaybe<Scalars['Int']['input']>;
  remainingCodes_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  remainingCodes_LT?: InputMaybe<Scalars['Int']['input']>;
  remainingCodes_LTE?: InputMaybe<Scalars['Int']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resetPasswordToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRole>>;
  roles_INCLUDES?: InputMaybe<UserRole>;
  securityCodes?: InputMaybe<Array<Scalars['Secret']['input']>>;
  securityCodes_INCLUDES?: InputMaybe<Scalars['Secret']['input']>;
  songRequestsAggregate?: InputMaybe<UserSongRequestsAggregateInput>;
  /** Return Users where all of the related UserSongRequestsConnections match this filter */
  songRequestsConnection_ALL?: InputMaybe<UserSongRequestsConnectionWhere>;
  /** Return Users where none of the related UserSongRequestsConnections match this filter */
  songRequestsConnection_NONE?: InputMaybe<UserSongRequestsConnectionWhere>;
  /** Return Users where one of the related UserSongRequestsConnections match this filter */
  songRequestsConnection_SINGLE?: InputMaybe<UserSongRequestsConnectionWhere>;
  /** Return Users where some of the related UserSongRequestsConnections match this filter */
  songRequestsConnection_SOME?: InputMaybe<UserSongRequestsConnectionWhere>;
  /** Return Users where all of the related SongRequests match this filter */
  songRequests_ALL?: InputMaybe<SongRequestWhere>;
  /** Return Users where none of the related SongRequests match this filter */
  songRequests_NONE?: InputMaybe<SongRequestWhere>;
  /** Return Users where one of the related SongRequests match this filter */
  songRequests_SINGLE?: InputMaybe<SongRequestWhere>;
  /** Return Users where some of the related SongRequests match this filter */
  songRequests_SOME?: InputMaybe<SongRequestWhere>;
  streamingAbsenceCount?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_GT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  streamingAbsenceCount_LT?: InputMaybe<Scalars['Int']['input']>;
  streamingAbsenceCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  tfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tfaSecret?: InputMaybe<Scalars['String']['input']>;
  tfaSecret_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tfaSecret_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tfaSecret_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tfaSecret_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  username_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  username_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  username_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FanGalleryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type FanGalleryQuery = { __typename?: 'Query', fanGalleryItems: Array<{ __typename?: 'FanGalleryItem', id: string, title: string, description: string, author: string, authorSocial?: string | null, createdAt: any, image: { __typename?: 'File', url: string } }>, fanGalleryItemsAggregate: { __typename?: 'FanGalleryItemAggregateSelection', count: number } };

export type QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuery = { __typename?: 'Query', latestRadioShows: Array<{ __typename?: 'RadioShow', title: string, slug: string }>, latestCategories: Array<{ __typename?: 'Category', title: string, slug: string }> };

export type PartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnersQuery = { __typename?: 'Query', partners: Array<{ __typename?: 'Partner', type: PartnerType, title: string, link: string, picture: { __typename?: 'File', url: string } }> };

export type CurrentPollQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPollQuery = { __typename?: 'Query', polls: Array<{ __typename?: 'Poll', id: string, title: string, options: Array<{ __typename?: 'PollOption', id: string, title: string, votes: number }>, optionsAggregate?: { __typename?: 'PollPollOptionOptionsAggregationSelection', node?: { __typename?: 'PollPollOptionOptionsNodeAggregateSelection', votes: { __typename?: 'IntAggregateSelection', sum?: number | null } } | null } | null }> };

export type VoteOnPollMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  optionId: Scalars['ID']['input'];
}>;


export type VoteOnPollMutation = { __typename?: 'Mutation', voteOnPoll: boolean };

export type PostLightQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostLightQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', hasPendingModifications: boolean, deletedAt?: any | null, status: PostStatus, author: { __typename?: 'User', id: string }, category?: { __typename?: 'Category', id: string } | null }> };

export type InfoQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type InfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<UserRole> }, users: Array<{ __typename?: 'User', id: string, displayName: string, profile?: { __typename?: 'UserProfile', slug: string, gender: string, picture: { __typename?: 'File', url: string } } | null }>, categories: Array<{ __typename?: 'Category', id: string, title: string, cover: { __typename?: 'File', url: string } }> };

export type PostQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  type: PostType;
  id: Scalars['ID']['input'];
}>;


export type PostQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, oldId?: number | null, slug?: string | null, type: PostType, publishedAt?: any | null, updatedAt: any, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', title?: string | null, lead?: string | null, body?: string | null, coverAttribution?: string | null, coverAttributionLink?: string | null, author: { __typename?: 'User', id: string, displayName: string, profile?: { __typename?: 'UserProfile', slug: string, gender: string, blurb: string, picture: { __typename?: 'File', url: string } } | null }, category?: { __typename?: 'Category', id: string, slug: string, title: string, cover: { __typename?: 'File', url: string } } | null, cover?: { __typename?: 'File', url: string } | null, tags: Array<{ __typename?: 'Tag', id: string, slug: string, title: string }> } }> } }> };

export type PostsQueryVariables = Exact<{
  where?: InputMaybe<PostWhere>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type PostsQuery = { __typename?: 'Query', postsAggregate: { __typename?: 'PostAggregateSelection', count: number }, posts: Array<{ __typename?: 'Post', id: string, slug?: string | null, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', title?: string | null, lead?: string | null, sticky: boolean, publishedAt?: any | null, cover?: { __typename?: 'File', url: string } | null, category?: { __typename?: 'Category', id: string, title: string, slug: string } | null } }> } }> };

export type OurSocialLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type OurSocialLinksQuery = { __typename?: 'Query', ourSocialLinks: Array<{ __typename?: 'OurSocialLink', type: SocialType, link: string }> };

export type TopSongsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopSongsQuery = { __typename?: 'Query', requestedSongs: Array<{ __typename?: 'RequestedSong', album?: string | null, artist?: string | null, title: string, cover: string, rank: number, previousRank: number }> };

export type TopTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', title: string, slug: string, usageCount: number }> };

export type ProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProfileQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', roles: Array<UserRole>, createdAt: any, categories: Array<{ __typename?: 'Category', id: string, title: string, slug: string, genre: string, cover: { __typename?: 'File', url: string } }>, radioShows: Array<{ __typename?: 'RadioShow', id: string, title: string, slug: string, genre: string, cover: { __typename?: 'File', url: string } }>, profile?: { __typename?: 'UserProfile', nickname: string, realName: string, slug: string, gender: string, birthdate: any, location: string, ship: string, occupation: string, blurb: string, customTitle: string, nicknameBackground: string, hobbies: string, musicTastes: string, likes: string, dislikes: string, animeTastes: string, doramaTastes: string, gameTastes: string, mostActiveSocial: string, favAsianCulture: string, countriesToGo: string, favFood: string, favPerson: string, phrase: string, picture: { __typename?: 'File', url: string }, background?: { __typename?: 'File', url: string } | null, socialLinks: Array<{ __typename?: 'UserSocialLink', type: SocialType, link: string }> } | null }> };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', title: string }> };

export type CategoryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', title: string, cover: { __typename?: 'File', url: string } }> };

export type SlugTypeQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SlugTypeQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', title: string, body: string, cover: { __typename?: 'File', url: string } }>, posts: Array<{ __typename?: 'Post', id: string }>, users: Array<{ __typename?: 'User', id: string }> };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', title: string, slug: string, genre: string, cover: { __typename?: 'File', url: string }, users: Array<{ __typename?: 'User', displayName: string }> }>, deletedCategories: Array<{ __typename?: 'Category', title: string, slug: string, genre: string, cover: { __typename?: 'File', url: string }, users: Array<{ __typename?: 'User', displayName: string }> }> };

export type PollsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type PollsQuery = { __typename?: 'Query', pollsAggregate: { __typename?: 'PollAggregateSelection', count: number }, polls: Array<{ __typename?: 'Poll', id: string, title: string, createdAt: any, options: Array<{ __typename?: 'PollOption', id: string, title: string, votes: number }>, optionsAggregate?: { __typename?: 'PollPollOptionOptionsAggregationSelection', node?: { __typename?: 'PollPollOptionOptionsNodeAggregateSelection', votes: { __typename?: 'IntAggregateSelection', sum?: number | null } } | null } | null }> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', displayName: string, roles: Array<UserRole>, profile?: { __typename?: 'UserProfile', slug: string, gender: string, picture: { __typename?: 'File', url: string } } | null }> };

export type RadioShowScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type RadioShowScheduleQuery = { __typename?: 'Query', radioShowSchedules: Array<{ __typename?: 'RadioShowSchedule', id: string, startTime: number, endTime: number, startDate?: number | null, endDate?: number | null, days?: number | null, radioShow: { __typename?: 'RadioShow', id: string, slug: string, title: string, type: RadioShowType, genre: string, description: string, cover: { __typename?: 'File', url: string }, djs: Array<{ __typename?: 'User', displayName: string, profile?: { __typename?: 'UserProfile', slug: string } | null }> } }>, basePlaylist: { __typename?: 'RadioShow', id: string, slug: string, title: string, type: RadioShowType, genre: string, description: string, cover: { __typename?: 'File', url: string }, djs: Array<{ __typename?: 'User', displayName: string, profile?: { __typename?: 'UserProfile', slug: string } | null }> } };

export type MainPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MainPageQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, slug?: string | null, author: { __typename?: 'User', displayName: string, profile?: { __typename?: 'UserProfile', slug: string } | null }, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', title?: string | null, lead?: string | null, sticky: boolean, publishedAt?: any | null, cover?: { __typename?: 'File', url: string } | null, category?: { __typename?: 'Category', id: string, title: string, slug: string } | null } }> } }> };

export type FeedQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, slug?: string | null, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', title?: string | null, lead?: string | null, publishedAt?: any | null, author: { __typename?: 'User', displayName: string }, cover?: { __typename?: 'File', url: string, mimeType: string, size: number } | null, category?: { __typename?: 'Category', id: string, title: string, slug: string } | null } }> } }> };

export type SitemapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapDataQuery = { __typename?: 'Query', pagesAggregate: { __typename?: 'PostAggregateSelection', count: number }, postsAggregate: { __typename?: 'PostAggregateSelection', count: number }, tagsAggregate: { __typename?: 'TagAggregateSelection', count: number }, usersAggregate: { __typename?: 'UserAggregateSelection', count: number } };

export type SitemapPagesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SitemapPagesQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, slug?: string | null, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', body?: string | null, updatedAt: any } }> } }> };

export type SitemapPostsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SitemapPostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, slug?: string | null, revisionsConnection: { __typename?: 'PostRevisionsConnection', edges: Array<{ __typename?: 'PostRevisionsRelationship', node: { __typename?: 'PostRevision', body?: string | null, updatedAt: any, category?: { __typename?: 'Category', id: string, slug: string } | null } }> } }> };

export type SitemapTagsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SitemapTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, slug: string, updatedAt: any }> };

export type SitemapUsersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SitemapUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, profile?: { __typename?: 'UserProfile', slug: string, updatedAt?: any | null, picture: { __typename?: 'File', url: string } } | null }> };

export type TagQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type TagQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', title: string }> };

export type RelatedPostsQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type RelatedPostsQuery = { __typename?: 'Query', relatedPosts: Array<{ __typename?: 'Post', title?: string | null, slug?: string | null, publishedAt?: any | null, category?: { __typename?: 'Category', slug: string } | null }> };


export const FanGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FanGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fanGalleryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorSocial"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fanGalleryItemsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<FanGalleryQuery, FanGalleryQueryVariables>;
export const QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestRadioShows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const PartnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PartnersQuery, PartnersQueryVariables>;
export const CurrentPollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentPoll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isOpen"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weight"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"votes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentPollQuery, CurrentPollQueryVariables>;
export const VoteOnPollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoteOnPoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"optionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voteOnPoll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pollId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}}},{"kind":"Argument","name":{"kind":"Name","value":"optionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"optionId"}}}]}]}}]} as unknown as DocumentNode<VoteOnPollMutation, VoteOnPollMutationVariables>;
export const PostLightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PostLight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPendingModifications"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PostLightQuery, PostLightQueryVariables>;
export const InfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Info"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_INCLUDES"},"value":{"kind":"EnumValue","value":"SUPER"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_INCLUDES"},"value":{"kind":"EnumValue","value":"ADMIN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_INCLUDES"},"value":{"kind":"EnumValue","value":"AUTHOR_ADMIN"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_INCLUDES"},"value":{"kind":"EnumValue","value":"AUTHOR"}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InfoQuery, InfoQueryVariables>;
export const PostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Post"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oldId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lead"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverAttribution"}},{"kind":"Field","name":{"kind":"Name","value":"coverAttributionLink"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PostQuery, PostQueryVariables>;
export const PostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Posts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PostWhere"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sticky"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lead"}},{"kind":"Field","name":{"kind":"Name","value":"sticky"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PostsQuery, PostsQueryVariables>;
export const OurSocialLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurSocialLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ourSocialLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weight"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<OurSocialLinksQuery, OurSocialLinksQueryVariables>;
export const TopSongsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopSongs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestedSongs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"album"}},{"kind":"Field","name":{"kind":"Name","value":"artist"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cover"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"previousRank"}}]}}]}}]} as unknown as DocumentNode<TopSongsQuery, TopSongsQueryVariables>;
export const TopTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usageCount"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}}]}}]}}]} as unknown as DocumentNode<TopTagsQuery, TopTagsQueryVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"radioShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"realName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"ship"}},{"kind":"Field","name":{"kind":"Name","value":"occupation"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"customTitle"}},{"kind":"Field","name":{"kind":"Name","value":"nicknameBackground"}},{"kind":"Field","name":{"kind":"Name","value":"hobbies"}},{"kind":"Field","name":{"kind":"Name","value":"musicTastes"}},{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"dislikes"}},{"kind":"Field","name":{"kind":"Name","value":"animeTastes"}},{"kind":"Field","name":{"kind":"Name","value":"doramaTastes"}},{"kind":"Field","name":{"kind":"Name","value":"gameTastes"}},{"kind":"Field","name":{"kind":"Name","value":"mostActiveSocial"}},{"kind":"Field","name":{"kind":"Name","value":"favAsianCulture"}},{"kind":"Field","name":{"kind":"Name","value":"countriesToGo"}},{"kind":"Field","name":{"kind":"Name","value":"favFood"}},{"kind":"Field","name":{"kind":"Name","value":"favPerson"}},{"kind":"Field","name":{"kind":"Name","value":"phrase"}},{"kind":"Field","name":{"kind":"Name","value":"socialLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const TagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<TagsQuery, TagsQueryVariables>;
export const CategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Category"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryQuery, CategoryQueryVariables>;
export const SlugTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlugType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"PAGE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SlugTypeQuery, SlugTypeQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"deletedCategories"},"name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"NOT"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const PollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Polls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pollsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weight"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"votes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PollsQuery, PollsQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"profile_NOT"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const RadioShowScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RadioShowSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"radioShowSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTime"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"radioShow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"djs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basePlaylist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"djs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RadioShowScheduleQuery, RadioShowScheduleQueryVariables>;
export const MainPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MainPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"ARTICLE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sticky"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lead"}},{"kind":"Field","name":{"kind":"Name","value":"sticky"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MainPageQuery, MainPageQueryVariables>;
export const FeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Feed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"ARTICLE"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sticky"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lead"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeedQuery, FeedQueryVariables>;
export const SitemapDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pagesAggregate"},"name":{"kind":"Name","value":"postsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"PAGE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"ARTICLE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tagsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<SitemapDataQuery, SitemapDataQueryVariables>;
export const SitemapPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"PAGE"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SitemapPagesQuery, SitemapPagesQueryVariables>;
export const SitemapPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"PUBLISHED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"ARTICLE"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"revisionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edge"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CURRENT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SitemapPostsQuery, SitemapPostsQueryVariables>;
export const SitemapTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<SitemapTagsQuery, SitemapTagsQueryVariables>;
export const SitemapUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SitemapUsersQuery, SitemapUsersQueryVariables>;
export const TagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<TagQuery, TagQueryVariables>;
export const RelatedPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedPostsQuery, RelatedPostsQueryVariables>;